/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-fs-onboarding.js
   asset: assets/skon-fs-onboarding.js
   Modulo: Free Shipping Test — Onboarding NC (micro-toast)
   Aggiornato: 2 novembre 2026, ore 16:51 (Europe/Rome)
   Versione: 4.18.0 (Fase 2, parziale, del porting — vedi
   claude/SKON_PORT_PIANO_15ott2026.md e la guida di deploy consegnata
   insieme per il quadro completo)

   CHANGELOG 4.18.0 (2 novembre 2026, ore 16:51 Europe/Rome) — BLACK MONTH: gli sconti di benvenuto scendono da -15% (email) / -20% (WhatsApp)
   a -10% / -15% (codici WELCOME10 e WA15). Le percentuali scritte a mano in 14 punti dei testi del flusso rich
   (benvenuto NC, promemoria "join-wa" e "wa-code", "codice in arrivo", schermata WhatsApp unita, chiusura "done")
   ora vengono da UN SOLO punto: la costante WELCOME_PCT (vicino a WHATSAPP_ASK_ENABLED). I testi usano i segnaposto
   %%PE%% (email) e %%PW%% (WhatsApp) e _richGo() li espande; ogni schermata passa da _richGo, quindi nessun
   testo del flusso resta con la percentuale vecchia. Il ripristino a fine promo = cambiare i due numeri di
   WELCOME_PCT (e `steps` in skon-entrypoints.js, che le CTA leggono da sé). capabilities() espone `welcomePct`
   (sola lettura) per i test di coerenza con le CTA. I testi dedicati delle CTA (offer.*) arrivano già da
   skon-entrypoints.js. Nessun'altra modifica: logica, eventi, trigger, CSS e codici sconto invariati (i codici
   veri li applica Shopify; le percentuali mostrate dopo l'applicazione le legge SkonDiscount da Shopify).

   CHANGELOG 4.17.1 (31 ottobre 2026, ore 13:09 Europe/Rome) — banner in collection: con la tastiera la pagina saliva
   troppo, portando il CAMPO email a ridosso del bordo alto dello schermo (segnalazione di Matteo su Android reale):
   la persona perdeva il punto in cui si trovava.
   - Ora si allinea l'INIZIO DEL BOX (il banner), appena sotto la testata fissa (misurata sul posto con
     elementFromPoint: nessuna misura fissa), e non piu' il campo. La pagina si muove SOLO se il campo (con un po' di
     spazio sotto per conferma e privacy) e' coperto dalla tastiera o finisce sotto la testata; se e' gia' ben
     visibile resta tutto fermo.
   - Se il box e' piu' alto dell'area libera vince il campo: si scorre il minimo per tenerlo visibile sopra la tastiera.
   - Il popup centrale e il resto non cambiano rispetto alla 4.17.0.

   CHANGELOG 4.17.0 (31 ottobre 2026, ore 11:52 Europe/Rome) — tastiera virtuale di Android/iOS (segnalazione di Matteo
   su Android reale: la tastiera copriva il campo email).
   - Prima il campo veniva portato in vista UNA sola volta (380 ms dopo il tocco) con un solo calcolo: su Android la
     tastiera sale piu' tardi e il campo restava coperto. Ora, finche' un campo di testo del flusso ha il focus, un
     controllo a ciclo chiuso (_richKbdStart) misura la zona REALMENTE visibile (visualViewport) e riposiziona: ripete
     ad ogni resize/scroll del visualViewport e ogni 120 ms per ~2,8 s dopo il focus, si ferma se la persona scorre
     col dito, poi resta di guardia solo se il campo torna coperto.
   - Banner in collection (flusso nella pagina): la pagina scorre in verticale in modo che il campo stia nella parte
     alta dell'area visibile, sotto la testata fissa; aggiunge uno spazio temporaneo in fondo alla pagina (rimosso alla
     chiusura della tastiera) per poter scorrere anche quando il banner e' vicino al fondo.
   - Popup centrale / toast fisso: con la tastiera aperta il popup viene ridimensionato e centrato nell'area visibile
     (stile inline top/bottom/max-height, ripuliti a tastiera chiusa); se il contenuto e' piu' alto scorre dentro il
     popup fino al campo.
   - Nessuna modifica al CSS (resta skon-fs-onboarding.css 3.9). Senza tastiera (desktop) nessun effetto.

   CHANGELOG 4.16.2 (31 ottobre 2026, ore 10:49 Europe/Rome) — verifica pre-produzione (richiesta di Matteo).
   - FIX (gia' presente nel popup): la schermata WhatsApp dopo "Non ora, continua" diceva "Il tuo -15% e' gia'
     in arrivo... controlla la tua email" anche a chi NON aveva inviato nessuna email. Ora quel testo compare solo
     se l'email e' stata davvero inviata (_rc.codeSent); altrimenti: "Vuoi restare in contatto anche su WhatsApp?".
   - Banner: la larghezza della colonna a campo aperto non resta piu' bloccata da uno stile inline (se si ruota
     il telefono o si ridimensiona la finestra segue le regole CSS) — richiede skon-fs-onboarding.css >= 3.9.
   - Banner: dopo l'apertura il campo viene portato in vista tenendo conto della tastiera (visualViewport), non
     piu' al centro della pagina (su iPhone piccoli il centro finiva sotto la tastiera).
   - Nessun altro cambiamento di comportamento.

   CHANGELOG 4.16.1 (31 ottobre 2026, ore 10:20 Europe/Rome) — il pulsante di invio email compare SOLO con un
   indirizzo email formalmente valido (richiesta di Matteo). Prima bastava `x@y.z` (anche `a@b.c`).
   - _richValidEmail() (solo flusso rich: popup e banner) ora verifica la struttura tipica di un indirizzo:
     una sola @; parte locale 1-64 caratteri ammessi (lettere, cifre e . ! # $ % & ' * + / = ? ^ _ ` { | } ~ -),
     senza punto iniziale/finale ne' doppi punti; dominio con almeno due etichette (lettere, cifre, trattino
     interno, max 63), ultima etichetta solo lettere (2-24) oppure punycode xn--; max 254 caratteri; spazi ai
     bordi ignorati. Nessuna regex con lookbehind (compatibile con Safari/iOS meno recenti).
   - Il pulsante di conferma (e il suo feedback) restano nascosti (visibility:hidden, quindi anche non
     cliccabili ne' raggiungibili da tastiera) finche' l'indirizzo non e' valido; tornano nascosti se
     l'indirizzo viene modificato in uno non valido. Il click e Invio ricontrollano comunque l'indirizzo.
   - _validEmail() (flusso classico e altri moduli) NON e' toccata.
   - Richiede skon-fs-onboarding.css >= 3.8 (regola visibility del blocco di conferma).

   CHANGELOG 4.16.0 (30 ottobre 2026, ore 18:41 Europe/Rome) — il banner in collection NON ospita piu' la scheda
   del popup (la 4.15.0 era una trasformazione "troppo shock", richiesta di Matteo): si trasforma SUL POSTO,
   come fa la CTA nel popup.
   - openFrom({ inlineStyle:'banner', host, offer:{…, banner:{title:{pre,acc,post}, sub, cta}}, onReady }): il
     banner (stesso aspetto, stesse dimensioni, stesso testo) viene reso dal modulo dentro `host`; UN solo clic
     sulla CTA = la CTA diventa il campo email GIA' SELEZIONATO e pronto a scrivere (stesso morph del popup),
     compaiono la conferma ("Inviami il codice") e l'informativa privacy sotto il campo, piu' l'asterisco delle
     condizioni sul titolo (le condizioni si leggono PRIMA di lasciare l'email).
   - Invio email e schermate successive: stesso identico flusso del popup; la scheda successiva compare nello
     stesso box con dissolvenza e altezza animata (niente salto). Dalla seconda schermata in poi il box e' la
     cornice verde con la scheda bianca (come 4.15.0).
   - La prima schermata del banner e' resa in modo sincrono (nessun fade-out iniziale): il focus del campo
     avviene dentro il gesto dell'utente (necessario su iOS per aprire la tastiera).
   - `onReady` (opzionale) viene chiamata appena il banner reso dal modulo e' in pagina: l'ospite rimuove il suo.
   - capabilities(): version 4.16.0, `inlineBanner: true` (+ `inline: true` come prima).
   - Senza `inlineStyle:'banner'` (o senza `offer.banner`) tutto resta identico alla 4.15.0 / 4.14.1.
   - Richiede skon-fs-onboarding.css >= 3.7 e skon-entrypoints.js >= 1.5.0.

   CHANGELOG 4.15.0 (30 ottobre 2026, ore 16:56 Europe/Rome) — FLUSSO INLINE nel banner delle collection
   (richiesta di Matteo: la CTA del box verde deve avere lo stesso effetto che nel popup, nello stesso box).
   - openFrom() accetta `host` (elemento della pagina) e `onClose` (callback): il toast rich NON e' piu'
     un overlay ma si monta dentro `host` (classe .skon-fs-ob-rich-toast--inline, CSS >= 3.5), senza
     scrim, senza Esc modale. Stesse schermate, stessi id, stessi eventi, stesse chiamate ai Worker.
   - Alla chiusura (fine flusso) il toast viene rimosso e `onClose` avvisa l'ospite; se la persona lo
     minimizza (X o "Preferisco solo esplorare") il toast esce dall'ospite e diventa il normale toast
     flottante nascosto, riapribile dal "❔" (stessa logica di sempre); `onClose` viene chiamata comunque.
   - capabilities() espone `inline: true` e version 4.15.0 (chi chiama sa se il montaggio inline c'e').
   - offer.title.astKind ('plain' | 'price'): se 'price' il boxino dell'asterisco spiega anche il prezzo.
   - Senza `host` tutto resta identico alla 4.14.1.
   - Richiede skon-fs-onboarding.css >= 3.5 e skon-entrypoints.js >= 1.4.0.

   CHANGELOG 4.14.1 (30 ottobre 2026, ore 16:23 Europe/Rome) — l'asterisco del titolo da CTA e' ora uno
   <span role="button" tabindex="0"> INLINE (prima <button>): non puo' piu' andare a capo da solo.
   Stile: apice + sottolineato tratteggiato (skon-fs-onboarding.css 3.4). Nessun'altra modifica.
   Richiede skon-fs-onboarding.css >= 3.4 e skon-entrypoints.js >= 1.3.1.

   CHANGELOG 4.14.0 (30 ottobre 2026, ore 16:07 Europe/Rome) — schermata CTA semplificata
   (richiesta di Matteo: "troppissimo casino"). La schermata da CTA ora e': raccordo (con prezzo
   barrato), titolo su due righe con la parte in evidenza arancione, sottotitolo, pulsante,
   "Preferisco solo esplorare". NIENTE nota sotto il pulsante: le condizioni stanno nel boxino
   dell'asterisco.
   - offer.title accetta `ast:true` (asterisco cliccabile, tratteggiato, dopo il titolo): e' un
     <button data-skon-ep-ast="plain"> gestito dal modulo skon-entrypoints.js (boxino con le
     condizioni, stessa fonte dei testi). Se il modulo non e' presente il pulsante non fa nulla.
   - FIX: gli spazi attorno alla parte in evidenza sparivano (es. "ottobre:dal 15%") perche' i testi
     venivano rifilati; ora gli spazi dei pezzi del titolo sono conservati. Un "\n" nel titolo
     diventa un a capo.
   - disclaimer/conditions dell'offer sono ancora accettati ma, se vuoti, non si disegna nulla.
   - Richiede skon-fs-onboarding.css >= 3.3 e skon-entrypoints.js >= 1.3.0.

   CHANGELOG 4.13.0 (30 ottobre 2026, ore 13:55 Europe/Rome) — schermata dedicata
   per chi arriva dalle CTA (richiesta di Matteo: il popup non e' piu' la schermata
   di sempre con una riga sopra, ma un percorso pensato per questo ingresso).
   Solo ADDITIVO: l'apertura automatica del toast (dwell/scroll/inattivita') e tutte
   le altre schermate restano identiche.
   - openFrom() accetta due campi nuovi, facoltativi: `offer` e `leadHtml`.
       offer = { kind, min, max, twoSteps, today, title:{pre,acc,post}, sub, cta,
         disclaimer, conditions:[…] } -- TESTI GIA' PRONTI preparati dal modulo CTA
         (skon-entrypoints.js, unica fonte: COPY/OFFER). Questo file NON contiene
         percentuali di sconto per questa schermata: stampa quanto riceve (escapato).
       leadHtml = raccordo con il solo tag <s>…</s> (prezzo di listino barrato);
         ogni altro carattere viene escapato qui. Senza `leadHtml` vale `lead` (testo).
   - _richRenderNcWelcome(): se l'apertura porta `offer` (entry 'nc-welcome' da CTA),
     disegna la schermata dedicata: titolo con la parte in evidenza arancione (es.
     "dal 15% al 20%*"), sottotitolo, pulsante (stesso id richWantCode), campo email e
     conferma INVARIATI (stessi id, stessi eventi, stessa logica di invio), nota con
     il disclaimer e le condizioni sotto il pulsante, "Preferisco solo esplorare".
     Senza `offer` (ingresso automatico o `offer` non valida) resta la schermata di prima.
   - Nessun nuovo evento, nessun cambio a step id, RICH_FLOW, WHATSAPP_ASK_ENABLED,
     PROFILE_CHECK, tracciamento. `capabilities().version` = '4.13.0'.
   - Richiede skon-fs-onboarding.css >= 3.2.

   CHANGELOG 4.12.0 (30 ottobre 2026, ore 00:57 Europe/Rome) — punti di ingresso
   al toast (nuovo modulo assets/skon-entrypoints.js). Solo ADDITIVO: nessuna
   funzione esistente cambia comportamento quando il toast parte da solo
   (trigger dwell/scroll/inattivita), verificato a parita' di flag.
   - NUOVI metodi pubblici su SkonFS.onboarding:
       capabilities() -> { version, enabled, whatsapp, birthday, codeSent,
         waSubscribed, customer, needs, open, pending } -- SOLA LETTURA, per
         permettere al modulo CTA di scegliere cosa promettere (es. "fino
         al 20%" solo se lo step WhatsApp e' davvero attivo) senza
         duplicare le costanti private di questo file.
       openFrom({ entry, origin, lead, leadHtml, offer, modal }) -> boolean -- riapre il
         toast rich da una CTA del sito: entry in { 'nc-welcome',
         'rc-welcome', 'reminder-join-wa', 'reminder-wa-code' }, origin =
         etichetta della superficie (es. 'pdp_price'), lead = una riga di
         raccordo mostrata UNA volta sopra la prima schermata, modal =
         true (default) -> popup al centro con scrim. Ritorna false (e non
         fa nulla) se il modulo e' spento o l'entry non e' ammessa.
   - toast_shown ora porta entry_type = 'cta:<origin>' quando l'apertura
     arriva da una CTA (prima: sempre il nome dell'entry): nessuna modifica
     al Worker eventi, il campo e' testo libero <=64 caratteri.
   - Il flag di sessione (skon_fs_onboarding_shown) viene impostato anche
     dall'apertura da CTA: il toast automatico non compare piu' sopra al
     popup scelto dalla persona.
   - Nuovo stile .skon-fs-ob-rich-toast--modal (solo CSS v3.1): centrato,
     scrim sempre attivo, chiusura con Esc o tocco sullo scrim (stessa
     azione della X: minimizza, il tab "❔" resta).
   - Nessuna modifica a: shouldShow(), trigger, RICH_FLOW, WHATSAPP_ASK_ENABLED
     (vedi nota sotto), PROFILE_CHECK, EVENTS, schermate esistenti.

   CHANGELOG 4.11.0 (27 ottobre 2026, ore 21:30 Europe/Rome) — vero
   interruttore master, richiesta esplicita di Matteo dopo aver visto dal
   vivo (test su STAGING) che il ramo classico del toast resta attivo anche
   con `RICH_FLOW.enabled=false`: "Ho detto che con il flag spento io NON
   DEVO VEDERE IL TOAST. Punto." Causa: `RICH_FLOW` non e' mai stato un
   interruttore dell'intero modulo -- governa SOLO quale ramo (classico vs
   rich) usare UNA VOLTA che il toast viene mostrato, non SE mostrarlo (il
   ramo classico e' "bit-per-bit quello della v3.0.0", sempre attivo,
   indipendente dal flag -- comportamento preesistente dalla v3.0.0, mai
   stato un interruttore totale). Aggiunta una nuova costante dedicata,
   `TOAST_MODULE_ENABLED`, con un'unica guardia in cima a `show()`
   (l'UNICO punto in cui il toast -- classico o rich -- viene creato nel
   DOM, unico `SkonFS.onboarding.show()` chiamato da tutto il file, vedi
   l'armamento trigger in `_init()`): a `false`, `show()` ritorna
   immediatamente, nessun elemento aggiunto al DOM, nessuna chiamata di
   rete, bit-per-bit silenzio totale per il visitatore. Nessun'altra riga
   toccata: `shouldShow()`, i trigger (dwell/inattivita/scroll), `RICH_FLOW`
   stesso, e ogni altra funzione restano esattamente come nella v4.10.0.
   Verificato con un test jsdom dedicato (vedi nota di verifica piu' sotto
   nel file di consegna) che a `TOAST_MODULE_ENABLED=false` nessun nodo
   `#skonFsObToast` viene mai creato indipendentemente da trigger/scroll/
   inattivita, e che a `true` il comportamento e' identico, campo per
   campo, a quello della v4.10.0 (nessuna regressione).

   CHANGELOG 4.10.0 (27 ottobre 2026) — richiesta esplicita di Matteo:
   finche' resta un modulo del flusso rich non compilato/accettato, il tab
   "❔" deve restare raggiungibile DI PAGINA IN PAGINA nella stessa sessione
   di navigazione, non solo finche' la pagina su cui si e' aperto resta
   caricata — prima di questa versione, un refresh o una navigazione ad
   un'altra pagina perdeva il tab (unico, vero modo per "chiudere per
   sempre" un modulo skippato, mai inteso ma di fatto l'unica via esistente
   via `_rc` tenuto solo in memoria). Nessun cambiamento al comportamento
   della X: continua a minimizzare sempre su qualunque schermata diversa da
   "done" (mai un dismiss vero fuori da li'), esattamente come prima —
   questa versione tocca SOLO la persistenza del tab fra un caricamento di
   pagina e il successivo, non quando o se la X chiude per davvero.
   Implementazione: un nuovo campo sessionStorage, `PENDING_TAB_KEY`
   (`skon_fs_ob_pending_tab`), scritto con lo step da riprendere ogni volta
   che il toast si minimizza con qualcosa ancora in sospeso
   (`_richMinimize()` — QUALUNQUE schermata live diversa da "done", anche
   la primissima domanda mai risposta, non solo un modulo esplicitamente
   skippato — e `_richMinimizeForRestart()`), e svuotato SOLO nell'unico
   punto che rappresenta un vero completamento (`_richDismiss()`, "done"
   con doneWasSkip=false). Nuova funzione `_richInitPendingTab(pending)`,
   richiamata da un controllo aggiunto in fondo a `_init()` (PRIMA
   dell'armamento dei trigger normali, quindi niente doppio popup): se
   trova un valore in sessionStorage per questa sessione di navigazione,
   costruisce SOLO l'icona "❔" (toast/scrim restano nascosti, mai aperti
   automaticamente) e la rende subito cliccabile, pronta a riprendere
   esattamente lo step lasciato in sospeso via `_richResumeScreen()` —
   stesso identico dispatch gia' in uso oggi per la ripresa sulla STESSA
   pagina, solo bootstrappato da sessionStorage invece che dalla memoria.
   Deliberatamente NESSUN evento `toast_shown`/`step_view` viene emesso da
   questo bootstrap silenzioso (quegli eventi restano legati a un'apertura
   vera, non alla ricomparsa automatica dell'icona): eviterebbe altrimenti
   di gonfiare quei conteggi di un evento per ogni pagina visitata con
   qualcosa in sospeso. Gated per intero dietro `RICH_FLOW.enabled`: a
   flag spento (produzione, finche' non attivato) questo blocco non gira
   mai, comportamento bit-per-bit invariato. Nessuna modifica a
   `shouldShow()`, alla tassonomia eventi, al CORS/Worker, o a qualunque
   altra schermata del flusso.

   CHANGELOG 4.9.0 (26 ottobre 2026, sera) — due fix emersi da una
   revisione avversariale approfondita richiesta esplicitamente da
   Matteo dopo il deploy della v4.8.0 (verificare "molto approfonditamente"
   i punti deboli del codice, non fidarsi di un primo controllo):
   1) FIX duplicazione evento alla chiusura automatica di "done": i tre
      trigger di chiusura (click, animationend, timer 5300ms) potevano
      scattare quasi simultaneamente nella chiusura "naturale" (nessun
      click dell'utente) PRIMA che il guard esistente (su _rcToast.hidden,
      valorizzato solo 220ms dopo) avesse effetto — risultato: evento
      toast_dismissed/toast_minimized duplicato per una parte consistente
      delle chiusure naturali, non un caso limite raro. Fix: variabile
      locale `doneClosing`, fresca a ogni singola comparsa dello step
      'done', nessun impatto su _rc o su altre schermate.
   2) FIX mancanza di fallback su _hashEmailHex(): chiamava
      window.crypto.subtle direttamente senza guardia — in un contesto
      senza quell'API (raro su HTTPS moderno, non impossibile) lanciava
      un'eccezione sincrona PRIMA che _richCheckProfile() avanzasse il
      flusso: il bottone invio email restava bloccato su "Un attimo…" per
      sempre, nessun errore mostrato. Fix: try/catch + .catch(), in caso
      di fallimento si perde solo l'evento di tracciamento
      email_submitted, mai il flusso reale del toast.
   Nessun'altra modifica: tassonomia eventi, session_id/declared (v4.8.0),
   CORS/Worker, join carrello — tutti invariati. Nessuno dei due fix
   tocca mai carrello o checkout.

   CHANGELOG 4.8.0 (26 ott 2026, ore 13:25 Europe/Rome) — session_id e
   declared su ogni evento, su richiesta esplicita di Matteo per poter
   rispondere via query diretta (senza ricostruire a mano la sequenza per
   ogni visitor_id) al drop-rate per step diviso fra chi si e' dichiarato
   NC e chi RC (vedi claude/skon-toast-events-worker.js v1.2.0, nota
   "SESSION_ID E DECLARED" in testa a quel file per il razionale completo
   condiviso fra i due lati):
   - NUOVO: `_rc.sessionId` — un id fresco (stesso generatore `_uuidv4()`
     gia' usato per `skon_vid`, MA NON un cookie: vive solo in memoria per
     la durata di QUESTA apertura del toast) assegnato in `_richInit`
     subito dopo `_richFreshCtx()`, PRIMA del primo `toast_shown`. Scopo:
     raggruppare senza ambiguita' tutti gli eventi di una singola comparsa
     del toast, a differenza di `visitor_id` che puo' restare lo stesso
     per settimane (cookie `skon_vid`, 60gg) e quindi da solo non isola
     "questa interazione" da un'altra dello stesso visitatore.
   - NUOVO: `_rc.declared` — come questa sessione ha classificato il
     visitatore: `'new'` (dichiarato NC al click iniziale, o rientrato da
     un promemoria che presuppone NC — vedi sotto), `'returning'`
     (dichiarato RC al click iniziale), `'auto'` (riconosciuto
     automaticamente come cliente via Liquid, mai una dichiarazione
     esplicita — entry `auto-consent`/`auto-consent-min`). Impostato in
     quattro punti: (1) `_richInit`, per le entry `auto-consent`/
     `auto-consent-min` → `'auto'`, e per `reminder-wa-code`/
     `reminder-join-wa` → `'new'` (entrambi i cookie di promemoria,
     `skon_wa_subscribed`/`skon_nc_code_sent`, si valorizzano SOLO nel ramo
     NC-dichiarato di `_richBuildPlan`, mai nel ramo RC-riconosciuto: vedi
     quella funzione); (2) nel click su "sono nuovo/a"/"sono gia' cliente"
     in `_richWireStep` → `'new'`/`'returning'`; (3) nel ramo `restart-nc`
     di `_richNext` (RC dichiarato ma non trovato in archivio) → `'new'`,
     coerente col fatto che da li' in poi la persona rientra nel flusso NC
     a tutti gli effetti (nuovo welcome NC, piano ripulito). Senza questo
     campo un evento con step `nc-whatsapp` seria strutturalmente ambiguo
     (stesso step sia per chi si e' dichiarato NC sia per chi e' stato
     riconosciuto RC, vedi `_richRenderNcWhatsapp`).
   - `_richEmitEvent(name, extra)` ora unisce automaticamente
     `session_id: _rc.sessionId` e `declared: _rc.declared || null` in
     OGNI payload, prima di applicare `extra` — zero modifiche richieste
     nei singoli punti di chiamata gia' esistenti (`toast_shown`,
     `step_view`, `step_skip`, `email_submitted`, `wa_clicked`,
     `birthday_submitted`, `toast_done`, `toast_minimized`,
     `toast_dismissed`, `tab_resumed`), tutti beneficiano del nuovo campo
     senza essere stati toccati singolarmente.
   - Nessuna modifica al comportamento visibile del toast, alla tassonomia
     eventi, al join via attributo carrello, o a come/quando il Worker
     viene chiamato: solo due campi aggiuntivi nel payload JSON gia'
     esistente. Un Worker non ancora aggiornato alla v1.2.0 ignorerebbe
     semplicemente i due campi extra (nessun rischio di rottura se il
     deploy del tema precedesse quello del Worker, ma l'ordine corretto
     resta: Worker prima, tema dopo, per non perdere dati nel frattempo).

   CHANGELOG 4.7.1 (26 ott 2026) — accensione del tracciamento eventi:
   `EVENTS.enabled` false→true, `EVENTS.workerUrl` valorizzato con
   'https://skon-toast-events-worker.admins-e7e.workers.dev' (Worker + D1 +
   webhook ordini + Cron di retention tutti deployati e verificati con
   traffico reale da Matteo il 26 ott 2026 — vedi claude/SKON_STATO_ATTUALE.md).
   SOLE due righe toccate rispetto alla v4.7.0, nessun'altra modifica.

   CHANGELOG 4.7.0 (26 ott 2026) — tracciamento eventi toast ("Livello 2",
   vedi claude/SKON_TOAST_EVENT_TRACKING_ARCHITETTURA_22ott2026.md):
   - NUOVO: cookie di prima parte `skon_vid` (UUID v4, 60 giorni, nessun
     gate di consenso — decisione di Matteo, 22 ott 2026), generato una
     sola volta per browser da `_ensureVisitorId()` e riusato per tutta la
     sua durata. Nessuna relazione con `SkonID`/`skon_fs_group_v2`: è un
     identificativo dedicato SOLO a questo tracciamento.
   - NUOVO: `_richEmitEvent(name, extra)` — invia un evento al nuovo Worker
     `skon-toast-events-worker` (`EVENTS.workerUrl`) via
     `navigator.sendBeacon` (fallback `fetch(..., {keepalive:true})`), MAI
     bloccante, MAI un redirect. Agganciato ai punti esatti della
     tassonomia (architettura §3): `toast_shown` in `_richInit`; `step_view`
     a ogni `_richGo`; `step_skip` sul click di qualunque bottone
     `[data-rich-skip]`; `email_submitted` (con `email_hash`, MAI l'email in
     chiaro) in `_richWireEmailSubmit`; `wa_clicked` sul click del link
     WhatsApp; `birthday_submitted` all'invio validato della data di
     nascita; `toast_done` (con `reason`, stessa cascata di `_richRenderDone`
     — vedi nota lì per il riuso della colonna `step` nello schema D1);
     `toast_minimized` in `_richMinimize` E in `_richMinimizeForRestart`
     (estensione deliberata rispetto alla tassonomia originale: anche questo
     secondo caso nasconde il toast allo stesso modo, altrimenti le sessioni
     "done con modulo in sospeso" chiuse da lì non avrebbero alcun evento di
     chiusura); `toast_dismissed` in `_richDismiss`; `tab_resumed` (con
     `resumeStep`) in `_richResumeScreen`.
   - NUOVO: `EVENTS` (config, stesso pattern di `PROFILE_CHECK`) —
     `enabled: false` finché `skon-toast-events-worker` non è distribuito e
     il suo URL confermato da Matteo (vedi
     claude/SKON_TOAST_EVENTS_WORKER_DEPLOY_GUIDA_26ott2026.md): finché
     false, `_richEmitEvent` è un no-op immediato, ZERO chiamate di rete,
     stesso principio di sicurezza già rodato per `PROFILE_CHECK`.
   - NUOVO: join secondario via attributo carrello. A differenza di quanto
     ipotizzato nell'architettura (`SkonFS.cart.setCartAttributes(...)`),
     questo file scrive l'attributo DIRETTAMENTE via `/cart/update.js`
     (endpoint nativo Shopify, documentato, comportamento di merge — non
     sovrascrive altri attributi) invece di richiamare quella funzione:
     questa sessione non ha il sorgente di `skon-fs-test.js` per verificarne
     il contratto esatto (quali chiavi accetta, se fa merge o sovrascrive),
     e il vincolo del progetto è non rischiare mai sul carrello richiamando
     una funzione non verificata. Scritto una sola volta per apertura del
     toast, in `_richInit`, subito dopo `toast_shown` — indipendentemente da
     email sì/no, per coprire anche le sessioni che saltano tutto fin
     dall'inizio (architettura §5).
   - Nessuna modifica al comportamento visibile del toast: ogni invio è
     fire-and-forget, nessun evento può bloccare o ritardare una transizione
     di schermata, nessuna nuova richiesta è sincrona rispetto al click
     dell'utente.

   CHANGELOG 4.6.0 (22 ott 2026):
   - FIX/generalizzazione (segnalato da Matteo dopo aver testato la 4.5.0):
     la 4.5.0 faceva ripartire il tab "❔" SEMPRE dalla domanda iniziale
     (NC/RC), anche per chi aveva già risposto a quella domanda e aveva solo
     abbandonato un modulo successivo (es. l'email, o l'invito WhatsApp, o
     la data di nascita). Comportamento corretto richiesto da Matteo: il
     "❔" deve riprendere esattamente dall'ULTIMA richiesta che era aperta
     nel momento in cui il toast è stato abbandonato — qualunque sia il modo
     in cui è stato abbandonato (bottone di rifiuto/rinvio specifico dello
     step, X in alto a destra, o chiusura "a scorrimento" della schermata
     finale) — e questo deve valere per QUALUNQUE modulo, presente o futuro,
     per restare modulare "by design".
   - NUOVO: `_rc.resumeStep` — generico, non più hardcoded su un singolo
     caso. Impostato dal click su QUALSIASI bottone marcato
     `data-rich-skip="true"` (aggiunto a tutti i bottoni di rifiuto/rinvio
     esistenti: skip email NC/RC, "No, grazie" di auto-consent, "Esplora i
     prodotti" di auto-consent-min, "No, grazie" dell'invito WhatsApp — sia
     nc-whatsapp sia reminder-join-wa —, "Lo uso più tardi" dell'offerta RC,
     "Non ora" dell'email RC, "Non ora" della data di nascita, "Preferisco
     solo esplorare" di mismatch-rc). Un futuro modulo aggiunto segue la
     stessa convenzione: basta marcare il suo bottone di rifiuto con questo
     stesso attributo, zero altro codice da toccare per farlo partecipare.
   - `_rc.doneWasSkip` (v. _richRenderDone) ora riflette la presenza di
     `_rc.resumeStep`, non più solo il ramo finale generico "A presto!":
     anche un vero traguardo (es. codice email ottenuto) può lasciare un
     ALTRO modulo in sospeso (es. WhatsApp rifiutato) — in quel caso il
     "❔" resta comunque visibile.
   - NUOVO: `_richResumeScreen()` — dispatch generico `_rc.resumeStep` ->
     funzione di render dello step corrispondente, usato dal tab "❔" al
     posto del reset totale della 4.5.0. Non tocca `_rc` (nessun
     `_richFreshCtx()`): tutte le risposte già date (ramo NC/RC, email nota,
     profilo) restano intatte, si ripropone solo lo step specifico.
   - Limite noto, scelta consapevole per restare fedele alle parole di
     Matteo ("riparte dall'ultima richiesta"): si ricorda solo L'ULTIMO
     modulo abbandonato, non una coda di tutti quelli eventualmente saltati
     in sequenza nella stessa sessione (es. salta compleanno POI salta
     WhatsApp → si riprende solo da WhatsApp, non anche dal compleanno).
   - Nessuna modifica a `shouldShow`, ai promemoria cross-sessione
     (v4.3.0/v4.4.x), né alla logica di quando mostrare/non mostrare il
     toast: tocca solo cosa succede dopo un abbandono, dentro la stessa
     sessione del toast.

   CHANGELOG 4.5.0 (22 ott 2026):
   - FIX (segnalato da Matteo durante un test dal vivo): dopo "Preferisco
     solo esplorare" (skip, nessun codice ottenuto/iscrizione/compleanno)
     si arriva alla schermata finale generica "A presto!". Chiudendola (col
     bottone "Chiudi" con countdown, con l'animazione a fine countdown, con
     l'autochiusura automatica dopo 5.3s, o con la X in alto) smontava
     sempre tutto il DOM del toast, incluso il tab "❔" sempre presente in
     basso — che invece dovrebbe restare finché c'è ancora una domanda
     aperta per il cliente, per sua esplicita decisione. Un vero
     completamento (codice ottenuto, già cliente con profilo completo,
     iscritto a WhatsApp, data di nascita raccolta) chiude invece
     correttamente tutto come prima: lì non resta nulla da chiedere.
   - NUOVO: `_rc.doneWasSkip` (impostato in `_richRenderDone`, true SOLO sul
     ramo "A presto!" finale) e `_richCloseDone()`, che ora è il punto
     unico attraverso cui passano tutti e 4 i modi di chiudere la
     schermata "done" (bottone, animationend, autoclose, X in alto): se
     `doneWasSkip` chiama la nuova `_richMinimizeForRestart()` (stessa
     animazione di `_richDismiss()`, ma il toast/scrim/tab restano nel DOM
     e il "❔" resta visibile), altrimenti chiama `_richDismiss()` come
     sempre.
   - NUOVO: `_rcRestartPending` — quando il tab "❔" viene toccato dopo una
     chiusura di questo tipo, invece di riaprire la stessa schermata "A
     presto!" già vista, riparte da zero con un contesto pulito
     (`_richFreshCtx()`) sulla domanda iniziale (`_richRenderIntro()`):
     una seconda occasione reale di accettare l'offerta, non solo
     un'icona che resta visibile senza motivo.
   - Nessuna modifica alle regole di quando mostrare/non mostrare il toast
     (`shouldShow`), ai due promemoria cross-sessione (v4.3.0/v4.4.x), né
     al percorso di un completamento vero: tocca solo la chiusura della
     schermata "done" raggiunta per puro skip.

   CHANGELOG 4.4.1 (22 ott 2026):
   - FIX correttezza testo (segnalato da Matteo via screenshot): le due
     nuove frasi "già attivo" introdotte in 4.4.0 erano state scritte con
     apostrofi al posto degli accenti (es. "e' gia' attivo" invece di
     "è già attivo", "Si'" invece di "Sì") — refuso di battitura mio,
     introdotto scrivendo quelle stringhe, non un problema preesistente nel
     resto del file. Corretto in tutti e 6 i punti in cui compariva
     ("reminder-wa-code" e "reminder-join-wa", varianti attivo/non attivo,
     più il link "Sì, voglio il -20%").
   - EMOJI: il segno di spunta dopo "attivo" era ✓ (U+2713, semplice); ora
     è ✅ (U+2705, "check mark button"), su richiesta esplicita di Matteo.
   - STILE testo (schermata "reminder-join-wa", segnalata da Matteo su
     screenshot): la frase era tutta nera tranne i soli numeri (-15%/-20%)
     in arancione. Ora: la prima frase ("Il tuo -15% è già attivo ✅") resta
     intera in nero (colore di default del toast, nessuna classe aggiunta);
     la seconda frase, l'invito ("Vuoi trasformarlo in -20%?"), è ora
     interamente in arancione (avvolta per intero in
     `skon-fs-ob-rich-accent`, non più solo il numero) per distinguere
     visivamente "fatto" (nero) da "prossimo passo" (arancione). Applicato
     per coerenza anche alla variante gemella non-attiva della stessa
     schermata ("ti aspetta ancora... Vuoi trasformarlo in -20%?"), non
     esplicitamente segnalata da Matteo ma identica nella struttura.
   - Nessuna modifica a `_cartHasActiveDiscount`, a `_richInit`, né alla
     logica di ingresso dei due promemoria: solo testo (ortografia, emoji,
     colore).

   CHANGELOG 4.4.0 (22 ott 2026):
   - FIX: i due promemoria introdotti in 4.3.0 ("reminder-wa-code" e
     "reminder-join-wa") dicevano sempre "ti abbiamo mandato un codice,
     controlla la tua casella" / "ti aspetta ancora", anche a chi il codice
     lo aveva GIÀ attivato pochi istanti prima (es. atterrato dal link email,
     popup skon-discount-popup.liquid già mostrato con "codice attivato").
     Segnalato da Matteo con screenshot (22 ott, dopo il primo giro di test):
     stessa famiglia di incoerenza del bug del popup risolto la notte prima
     — un messaggio che dice una cosa diversa da quella vera per il
     carrello di QUESTA persona.
   - NUOVO: `_cartHasActiveDiscount(cb)` — un GET a `/cart.js` (stesso
     dominio, nessun nuovo servizio esterno, nessuna chiamata al Worker di
     lookup) per sapere se `discount_codes` non è vuoto, cioè se un codice
     è già applicato al carrello ADESSO. Stessa fonte di verità già
     validata empiricamente per il popup v1.2.0 — qui serve solo un sì/no,
     non il dettaglio del codice, quindi niente round-trip in più del
     necessario.
   - `_richRenderReminderWaCode(active)` e `_richRenderReminderJoinWa(active)`
     ora accettano questo booleano e cambiano SOLO il copy (verbo al
     presente "è già attivo ✓" invece di "ti aspetta ancora" / "vai a
     cercarlo"): stessa identica logica di ingresso, stesso CTA WhatsApp,
     nessun'altra modifica. `_richInit` fa il check del carrello prima di
     disegnare la schermata, per i due ingressi "reminder-*".
   - Limite noto, accettato consapevolmente: `discount_codes` non vuoto
     dice "c'è un codice applicato", non "è per forza il SUO codice di
     benvenuto" — un cliente che avesse applicato a mano un codice diverso
     vedrebbe comunque il copy "è già attivo". Caso limite non sollevato da
     Matteo, non risolto qui per tenere il cambiamento piccolo e verificabile;
     annotato per completezza.

   CHANGELOG 4.3.0 (22 ott 2026):
   - FIX: il toast NC/RC ricompariva "dalla prima domanda" anche quando la
     persona aveva già risposto, perché TUTTO lo stato di soppressione/
     progresso viveva solo in sessionStorage (per-tab) o nel contesto
     rich-flow _rc (ricreato da zero a ogni show()). Un nuovo tab — es. un
     link aperto da un'email — partiva quindi senza alcuna memoria di una
     sessione precedente. Segnalato da Matteo (22 ott 2026): "devi lavorare
     di cookie affinché non si ripeta una UX già avvenuta con un effetto
     incoerente per il cliente."
   - NUOVO: due cookie di promemoria cross-sessione/cross-tab (90 giorni,
     regolabili via REMINDER_COOKIE_DAYS), scritti nell'unico punto che
     riceve sempre il profilo appena verificato da PROFILE_CHECK
     (_richBuildPlan):
       • skon_nc_code_sent  — il codice di benvenuto -15% è stato inviato
         via email (persona classificata NC, non ancora cliente);
       • skon_wa_subscribed — PROFILE_CHECK ha confermato wa:'active' per
         questa persona (non ancora cliente).
     Nessuno dei due viene mai scritto per chi risulta già cliente
     (isCustomer true): per quel caso shouldShow() la intercetta prima,
     nel ramo RC esistente, invariato.
   - NUOVO: due entry point "promemoria" in shouldShow()/show(), SOLO con
     RICH_FLOW attivo (a flag spento comportamento bit-per-bit invariato),
     con la stessa priorità esplicitamente richiesta da Matteo — chi è già
     su WhatsApp vince sempre, anche se aveva anche il codice email:
       • skon_wa_subscribed=1           → 'reminder-wa-code' (ricorda il
         codice -20% promesso su WhatsApp/email, caso C);
       • skon_nc_code_sent=1 (e non WA) → 'reminder-join-wa' (ricorda il
         -15% via email e invita a iscriversi a WhatsApp per il -20%,
         casi A+B uniti — stesso copy/CTA del ramo "ncMerged" già in uso
         nello stesso giorno in cui il codice viene inviato).
     Nessuno dei due promemoria afferma mai che un codice "è ancora
     valido": la validità reale la verifica solo skon-discount-popup.liquid
     al checkout (v1.2.0, stesso giorno) — qui si invita solo a riguardare
     qualcosa che è stato davvero inviato, mai una garanzia che potrebbe
     rivelarsi falsa e ricreare lo stesso tipo di incoerenza del bug del
     popup sconto.
   - Nessuna modifica al ramo classico (RICH_FLOW.enabled=false), al ramo
     RC/auto-consent, a PROFILE_CHECK, a CUSTOMER_NEEDS, né a
     skon-identity.js: i due nuovi cookie sono bookkeeping interno di
     questo solo file, scelta deliberata per tenere il raggio della
     modifica il più piccolo possibile.

   CHANGELOG 4.2.0 (19 ott 2026, 15:41 Europe/Rome):
   - Chiuso il gap "iscrizione email del toast non passa dal Worker nuovo"
     (vedi claude/SKON_TOAST_SCHEMA_VALIDAZIONE_19ott2026.md §1/§7 punto 3).
     I tre punti del file che iscrivevano l'email con un POST nativo a
     /contact#ContactFooter ora chiamano invece skon-nc-subscribe-worker
     (v4.0.0, gia' deployato e validato end-to-end da Matteo lo stesso
     giorno: scrive sia su Magnews — Welcome Funnel SKON_POPUP_NC — sia su
     Shopify, cliente DISABLED + tag NC-POPUP-TOAST + consenso SUBSCRIBED):
     1) modulo classico LEADGEN_MODULES 'nc-email' (actions.submit);
     2) ramo rich, percorso 'restart-nc' con email gia' nota (prefillEmail,
        dentro il wiring di nc-welcome/rc-welcome);
     3) ramo rich, invio email digitata su nc-welcome (_richWireEmailSubmit,
        branch subscribe=true — invariato il percorso rc-email, che non
        iscrive mai, copy esplicito "non ti stai iscrivendo a nulla").
     Stesso identico comportamento di interfaccia (nessun markup, nessuno
     stato, nessun timing toccato): cambia solo l'URL/metodo della singola
     chiamata di rete best-effort, da form-urlencoded nativo a JSON verso
     il Worker. Un fallimento del Worker non blocca mai il resto del
     flusso, esattamente come falliva prima un POST nativo non andato a
     buon fine (_xhrRequest logga e basta, nessun flusso dipende dall'esito).
     URL del Worker salvato anche in claude/SKON_WORKER_ENDPOINTS.md.

   CHANGELOG 4.1.1 (16 ott 2026, sera):
   - PROFILE_CHECK attivato: enabled true, workerUrl valorizzato con l'URL
     reale del Worker deployato e verificato end-to-end da Matteo (email
     cliente reale -> found:true coerente con Shopify; wa:'none' atteso,
     in attesa della Flow-bridge TextYess). Percorso NC/mismatch ora attivo
     in produzione su questo file, nessun'altra riga toccata.

   CHANGELOG 4.1.0 (16 ott 2026):
   - CUSTOMER_NEEDS (registro estensibile, §14 del piano di porting):
     un'unica definizione di "cosa manca a questo profilo" (oggi: birthday,
     whatsapp), usata sia dal percorso RC gia' loggato sia dal futuro
     percorso NC/mismatch via PROFILE_CHECK.
   - Percorso RC gia' loggato (auto-consent): il placeholder "chiedi sempre
     birthday+whatsapp" (mai da promuovere in produzione cosi' com'e', vedi
     nota storica piu' sotto) e' ELIMINATO per questo percorso. Il profilo
     reale arriva da Liquid (window.SKON_CUSTOMER, vedi layout/theme.liquid
     e sections/quiz-main.liquid, campi birthday/wa aggiunti oggi), zero
     round-trip di rete: Shopify sa gia' tutto cio' che serve per una
     cliente autenticata. Se non manca nulla, NUOVO stato 'auto-consent-min'
     (saluto minimo di navigazione, richiesta esplicita di Matteo del 15
     ott sera) al posto dell'auto-consent pieno.
   - Percorso NC/mismatch (email digitata a meta' flusso, visitatore ancora
     anonimo lato Shopify): NESSUNA modifica in questo file. Resta sul
     Worker dedicato PROFILE_CHECK (nuovo, separato: vedi
     claude/skon-profile-check-worker.js nel progetto Claude), non ancora
     deployato/attivato (PROFILE_CHECK.enabled resta false, workerUrl
     vuoto) — in attesa del deploy Cloudflare e della Flow-bridge TextYess
     per lo stato WhatsApp (vedi guida di deploy).
   - _richBuildPlan: le due condizioni inline su birthday/whatsapp ora
     passano dalla stessa funzione CUSTOMER_NEEDS (_richNeeded) — refactor
     puro, stesso identico esito booleano di prima, zero cambio di
     comportamento per il percorso NC/mismatch gia' esistente.

   CHANGELOG 4.0.0 (15 ott 2026):
   - NUOVO flusso multi-schermo ("rich flow"), porting integrale del
     prototipo validato con Matteo in questa stessa sessione di lavoro
     (schermate: intro, nc-welcome, rc-welcome, auto-consent, rc-teaser,
     rc-email, nc-code-sent, nc-whatsapp con copy che si adatta al
     contesto, rc-birthday con wheel-picker e dettatura vocale,
     mismatch-rc, done con le varianti d'icona già ripulite in questa
     sessione). COMPLETAMENTE SPENTO di default: `RICH_FLOW.enabled =
     false`. Finché resta false, `show()` e TUTTO il comportamento
     osservabile sono bit-per-bit quelli della v3.0.0: nessuna modifica,
     nessun rischio. Il flusso classico (v3.0.0) resta nel file
     INVARIATO, byte per byte nella sua logica, come fallback permanente
     e come unico percorso finché il flag non viene acceso.
   - NUOVO modulo di riconoscimento email: `PROFILE_CHECK`, anch'esso
     spento di default (`enabled: false`). Quando true, al primo invio di
     un'email nel flusso rich si chiama `PROFILE_CHECK.workerUrl` (Worker
     dedicato, ANCORA DA COSTRUIRE — vedi Fase 2 nel piano di porting),
     che deve rispondere `{ found, orders, birthday, wa }`. Finché
     `enabled` resta false (o la chiamata fallisce), il modulo degrada in
     sicurezza: NESSUN dato viene inventato, il profilo è trattato come
     "non trovato" (found:false, orders:0, birthday:false, wa:'none'),
     esattamente come un lead mai visto prima. Non si promette mai nulla
     che non si possa mantenere (stessa filosofia già applicata in questa
     sessione alla rimozione del CTA recensione in mismatch-rc).
   - RICONCILIAZIONE con shouldShow(): il prototipo prevede un ingresso
     "auto-consent" per chi è GIÀ riconosciuta (sessione Shopify attiva o
     link firmato) — ma shouldShow() oggi sopprime il toast del tutto per
     un RC con confidenza SkonID >= 50 (lo stesso identico caso). Quando
     RICH_FLOW.enabled è true, shouldShow() apre un ramo ALTERNATIVO (non
     aggiuntivo) per questo caso specifico: invece di "nessun toast",
     mostra l'ingresso auto-consent del flusso rich. A flag spento,
     shouldShow() resta IDENTICA alla v3.0.0 (stesso identico guard RC
     >=50 → sopprime, punto). Vedi _richEligibleAutoConsent più sotto.
   - NUOVE chiamate a SkonID MAI fatte finora da questo file, pur essendo
     già pronte in skon-identity.js v2.2.0+: markCustomer() /
     markNonCustomer(), chiamate SOLO quando PROFILE_CHECK conferma con
     certezza (isCustomer sì/no) — esattamente il caso d'uso per cui
     quelle funzioni sono state scritte e mai ancora collegate a nulla.
   - Markup, CSS class, DOM id del flusso rich sono TUTTI namespaced
     separatamente (`skonFsObRich*` / `.skon-fs-ob-rich-*`), MAI gli
     stessi del flusso classico (`skonFsObToast` / `.skon-fs-ob-*`):
     zero possibilità di collisione CSS o di selettori che si
     sovrascrivono a vicenda, anche con RICH_FLOW acceso.
   - Nessuna modifica a: shouldShow() nel suo ramo classico, _handleAnswer,
     _handleClick, dismiss, _tearDown, LEADGEN_MODULES, trigger di
     attivazione (dwell/scroll/inattività). Questi restano la sola cosa
     che gira finché RICH_FLOW.enabled è false.
   - Verifica di rilascio: vedi la suite di test jsdom descritta in
     claude/SKON_PORT_PIANO_15ott2026.md — copre sia il percorso classico
     (nessuna regressione) sia tutti i rami principali del percorso rich
     con PROFILE_CHECK disattivato E con una risposta simulata.

   ══ changelog precedenti (ereditati dalla v3.0.0, invariati) ══

   CHANGELOG 3.0.0 (9 ott 2026):
   - REFACTOR strutturale, NESSUN cambio di comportamento visibile
     (verificato: output HTML identico a v2.5.1 a parità di flag, in
     tutte le combinazioni rilevanti).
   - I tre blocchi lead-gen (email NC, data di nascita RC, CTA WhatsApp)
     non sono più funzioni ad hoc ma un registro esplicito LEADGEN_MODULES.
   - NUOVO segnale verso SkonID: dopo un invio email NC riuscito, il modulo
     nc-email chiama SkonID.observe('email_captured', {type:'NC'}).

   COSA FA QUESTO FILE
   ───────────────────
   Mostra un piccolo toast in basso che chiede gentilmente al visitatore
   se è il suo primo acquisto su Skön. Dalla v4.0.0, quando RICH_FLOW è
   attivo, il toast può diventare un flusso a più schermate che raccoglie
   anche data di nascita e iscrizione WhatsApp, riconoscendo (quando
   PROFILE_CHECK è pronto) le clienti già esistenti per evitare di
   promettere un vantaggio "primo ordine" a chi non vi ha diritto.

   DEPLOYMENT: caricare DOPO skon-fs-test.js (defer)
══════════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  function _waitForSkonFS(callback, attempts) {
    attempts = attempts || 0;
    if (window.SkonFS && window.SkonFS._cfg) return callback();
    if (attempts > 50) return;
    setTimeout(function() { _waitForSkonFS(callback, attempts + 1); }, 100);
  }


  function _init() {

    const SkonFS = window.SkonFS;
    const CFG    = SkonFS._cfg;

    // Guard: modulo non attivo
    if (!SkonFS.id.shouldActivate()) return;


    // ──────────────────────────────────────────────────────────────────
    // Utilities (invariate dalla v3.0.0)
    // ──────────────────────────────────────────────────────────────────

    function _log() {
      if (!CFG.debug || !CFG.debug.verbose) return;
      const args = Array.prototype.slice.call(arguments);
      args.unshift('[skon-fs:onboarding]');
      console.info.apply(console, args);
    }

    function _ss(key, val) {
      try {
        if (typeof val === 'undefined') return sessionStorage.getItem(key);
        sessionStorage.setItem(key, val);
      } catch (e) { return null; }
    }

    // v4.3.0 (22 ott 2026) -- cookie di promemoria cross-sessione/cross-tab.
    // sessionStorage (sopra) e' per-tab: un nuovo tab (es. da un link email)
    // non eredita nulla da una sessione precedente, ed e' esattamente la causa
    // del bug segnalato da Matteo ("il toast ricompare dalla prima domanda
    // anche se l'utente ha gia' risposto"). Per i DUE traguardi che vogliamo
    // ricordare oltre il tab/sessione (codice NC inviato, iscrizione
    // WhatsApp confermata) serve un cookie vero. Stessa forma esatta di
    // _setCookie/_getCookie in skon-identity.js (SameSite=Lax, path=/),
    // duplicata qui invece di richiamare skon-identity.js perche' questi due
    // flag sono bookkeeping interno di QUESTO toast, non un segnale di
    // identita' condiviso con altri consumer -- tenerli locali evita di
    // toccare un file da cui dipendono altri moduli per un dettaglio che
    // riguarda solo l'onboarding.
    function _getCookie(name) {
      try {
        var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : null;
      } catch (e) { return null; }
    }
    function _setCookie(name, val, days) {
      try {
        document.cookie = name + '=' + encodeURIComponent(val) + '; max-age=' + (days * 86400) + '; path=/; SameSite=Lax';
      } catch (e) {}
    }

    // Scaduti dopo REMINDER_COOKIE_DAYS: un promemoria non ha senso restare
    // agganciato per sempre a un'offerta che potrebbe non essere piu' quella
    // attuale. 90 giorni e' una scelta di buon senso (non richiesta da
    // Matteo con un numero preciso) -- facile da cambiare qui se la logica
    // di business vuole una finestra diversa.
    const REMINDER_COOKIE_DAYS = 90;
    const NC_CODE_SENT_COOKIE   = 'skon_nc_code_sent';
    const WA_SUBSCRIBED_COOKIE  = 'skon_wa_subscribed';

    // v4.7.0 (26 ott 2026) -- identificativo visitatore per il tracciamento
    // eventi del toast (Livello 2, vedi
    // claude/SKON_TOAST_EVENT_TRACKING_ARCHITETTURA_22ott2026.md §2). UUID
    // v4, 60 giorni, nessun gate di consenso -- decisione esplicita di
    // Matteo. Cookie dedicato, separato da skon_fs_group_v2/SkonID: questo
    // NON è un classificatore NC/RC, è solo la chiave per raggruppare gli
    // eventi di una stessa sessione/browser nel nuovo Worker.
    const VISITOR_ID_COOKIE = 'skon_vid';
    const VISITOR_ID_DAYS   = 60;

    // v4.10.0 -- persistenza cross-pagina del tab "❔" (vedi CHANGELOG in
    // testa al file). sessionStorage, non cookie: deve vivere SOLO per
    // questa sessione di navigazione (stessa tab), esattamente come
    // SETTINGS.sessionFlag qui sotto -- alla chiusura della tab/browser
    // sparisce da solo, comportamento voluto (un modulo skippato non deve
    // inseguire la persona per giorni, solo per il resto di questa visita).
    const PENDING_TAB_KEY = 'skon_fs_ob_pending_tab';

    function _savePendingTab(step) {
      try {
        _ss(PENDING_TAB_KEY, JSON.stringify({
          step:      step,
          entryName: (_rc && _rc.entryName) || '',
          path:      (_rc && _rc.path) || null,
          declared:  (_rc && _rc.declared) || null
        }));
      } catch (e) {}
    }

    function _debounce(fn, ms) {
      let t = null;
      return function() {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    function _euro(cents) {
      const v = (cents || 0) / 100;
      const isInt = (Math.round(v * 100) === Math.round(v) * 100);
      return isInt ? (v + '€') : (v.toFixed(2).replace('.', ',') + '€');
    }

    function _validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
    }

    function _esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function(c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    }

    function _getIdentityProfile() {
      if (window.SkonID && typeof window.SkonID.getProfile === 'function') {
        try { return window.SkonID.getProfile(); } catch (e) { return null; }
      }
      return null;
    }

    // v4.1.0 (16 ott 2026) — profilo "bisogni" per un cliente GIA' loggato,
    // letto da window.SKON_CUSTOMER (iniettato da Liquid, vedi layout/
    // theme.liquid e sections/quiz-main.liquid). Stessa forma esatta del
    // profilo che restituirebbe PROFILE_CHECK ({found, orders, birthday,
    // wa, firstName}), cosi' CUSTOMER_NEEDS/_richNeedsList funzionano
    // identici su entrambe le fonti. MAI inventare: se SKON_CUSTOMER manca
    // o il cliente non e' loggato/non ha ordini, found:false (trattato come
    // "non sappiamo", mai come "non manca nulla").
    function _getLiquidCustomerProfile() {
      var C = window.SKON_CUSTOMER;
      var loggedInCustomer = !!(C && C.loggedIn && Number(C.ordersCount) > 0);
      return {
        found:     loggedInCustomer,
        orders:    loggedInCustomer ? (Number(C.ordersCount) || 0) : 0,
        birthday:  loggedInCustomer ? !!C.birthday : false,
        wa:        (loggedInCustomer && C.wa === 'active') ? 'active' : 'none',
        firstName: (loggedInCustomer && C.firstName) ? C.firstName : null
      };
    }


    // ──────────────────────────────────────────────────────────────────
    // Settings (invariate dalla v3.0.0)
    // ──────────────────────────────────────────────────────────────────

    const SETTINGS = {
      minDwellMs:       6000,
      inactivityMs:     20000,
      scrollThreshold:  0.30,
      sessionFlag:      'skon_fs_onboarding_shown',
      autodeclareFlag:  'skon_nc_declared',
      addedToCartFlag:  'skon_added_to_cart',
    };

    const QUIZ_URL = '/pages/diagnosi-pelle';

    // ──────────────────────────────────────────────────────────────────
    // RICH FLOW — config v4.0.0 (spento di default: zero impatto live)
    // ──────────────────────────────────────────────────────────────────
    //
    // RICH_FLOW.enabled: finché false, show() si comporta ESATTAMENTE
    // come in v3.0.0 (vedi show() più sotto). Va acceso SOLO dopo aver
    // verificato il flusso su staging con ?skon_fs_test=1 (stesso
    // meccanismo già in uso per gli altri moduli FS, vedi
    // skon-fs-config.js → release.mode).
    //
    // v4.11.0 -- VERO interruttore master dell'intero modulo (classico +
    // rich): a `false`, `show()` ritorna subito, nessun toast di nessun
    // tipo viene mai mostrato a nessun visitatore, indipendentemente da
    // RICH_FLOW qui sotto. RICH_FLOW (vedi suo commento) resta invece SOLO
    // la scelta del ramo una volta che il toast e' gia' deciso di
    // comparire -- le due costanti sono deliberatamente separate e
    // indipendenti, non ridondanti: questa decide SE, RICH_FLOW decide
    // COME.
    //
    // COPIA STAGING (28 ottobre 2026, mattina) -- `true`: ambiente di
    // sviluppo/test, deve restare operativo. La copia PRODUZIONE pushata
    // la sera del 27 ottobre ha invece `false`, fino all'attivazione
    // esplicita di Matteo (prevista 28 ottobre, ore 9:00, azione manuale
    // sua: un solo edit di quella riga + push mirato a quel file, MAI
    // un'azione automatica/programmata qui).
    const TOAST_MODULE_ENABLED = true;

    // COPIA STAGING -- Decisione 1 di Matteo, 27 ott 2026: il "flag
    // master" (RICH_FLOW) va in produzione spento fino al go-live, ma su
    // STAGING resta acceso per continuare a testare il flusso rich. Questa
    // e' l'UNICA differenza "di stato" rispetto alla copia PRODUZIONE
    // pushata la sera del 27 ottobre: enabled e' true qui, false li'.
    // Tutto il resto del file e' byte-per-byte identico.
    const RICH_FLOW = {
      enabled: true,
    };

    // WHATSAPP_ASK_ENABLED (28 ott 2026, ore 11:xx Europe/Rome) -- interruttore
    // dedicato, su richiesta esplicita di Matteo: il flow TextYess che riceve
    // le iscrizioni WhatsApp non sta funzionando, quindi SOLO la richiesta di
    // unirsi alla community WhatsApp va spenta temporaneamente, senza toccare
    // nessun'altra parte del toast (email NC/RC, compleanno, sconto, eventi).
    // A `false`: (1) lo step 'whatsapp' non viene mai aggiunto al piano, in
    // NESSUN ramo (nc-welcome/rc-welcome/mismatch-rc/restart-nc/auto-consent),
    // perche' CUSTOMER_NEEDS e' l'unica fonte usata da _richBuildPlan() E da
    // _richNeedsList() (vedi sotto); (2) i due entry-point di promemoria
    // dedicati ("hai ancora il codice/unisciti a WhatsApp", mostrati a chi
    // torna su una pagina diversa) non si attivano piu' -- il visitatore
    // rientra nel flusso normale come se quei cookie di promemoria non ci
    // fossero. Nessuna modifica al rendering del modulo WhatsApp stesso (resta
    // intatto per quando si rimette a `true`), nessuna modifica a email/
    // compleanno/sconto/eventi/CSS. Riportare a `true` quando TextYess torna
    // operativo -- un solo edit di questa riga.
    // 30 ott 2026 -- STAGING allineato a PRODUZIONE (true): in produzione lo step
    // WhatsApp e' attivo, e le CTA (skon-entrypoints.js) promettono "fino al 20%"
    // solo se questo flag e' true -- testarle con lo step spento significherebbe
    // collaudare un'offerta diversa da quella live.
    const WHATSAPP_ASK_ENABLED = true;

    // v4.18.0 -- PERCENTUALI DEL BENVENUTO: l'UNICO punto in questo file. BLACK MONTH (dal 3 nov 2026): email -10%
    // (WELCOME10), WhatsApp -15% (WA15). Fuori promo: 15 e 20 (WELCOME15, WA20). Va tenuto uguale a `steps` di
    // assets/skon-entrypoints.js (le CTA): lo verifica il test di coerenza usando capabilities().welcomePct.
    const WELCOME_PCT = { email: 10, wa: 15 };
    // Espande i segnaposto dei testi (%%PE%% -> "-10%", %%PW%% -> "-15%"). Usata da _richGo (unico sink dei testi).
    function _wp(s) {
      return typeof s === 'string' ? s.split('%%PE%%').join('-' + WELCOME_PCT.email + '%').split('%%PW%%').join('-' + WELCOME_PCT.wa + '%') : s;
    }

    // PROFILE_CHECK: endpoint che, data un'email sottomessa nel flusso
    // rich, dovrebbe rispondere { found, orders, birthday, wa }. NON
    // ESISTE ANCORA (Fase 2 del piano di porting, 15 ott 2026): finché
    // enabled è false, o la chiamata fallisce per qualsiasi motivo, il
    // modulo tratta l'email come "mai vista" — MAI un'invenzione di dati,
    // MAI un mismatch-rc o un riconoscimento inventato. Vedi
    // _richCheckProfile più sotto per il fallback esatto.
    const PROFILE_CHECK = {
      enabled:   true,
      workerUrl: 'https://skon-profile-check-worker.admins-e7e.workers.dev', // attivato 16 ott 2026,
      // Worker verificato end-to-end: email reale -> found:true coerente con
      // Shopify (ordini, data di nascita), wa:'none' atteso finche' la
      // Flow-bridge TextYess non esiste (vedi claude/skon-profile-check-worker.js).
    };

    // EVENTS: tracciamento eventi toast, Livello 2 (v4.7.0, 26 ott 2026) --
    // claude/SKON_TOAST_EVENT_TRACKING_ARCHITETTURA_22ott2026.md. Stesso
    // pattern di PROFILE_CHECK: enabled resta false finche' il Worker
    // skon-toast-events-worker non e' distribuito su Cloudflare E il suo
    // URL pubblico confermato da Matteo (vedi
    // claude/SKON_TOAST_EVENTS_WORKER_DEPLOY_GUIDA_26ott2026.md) -- finche'
    // false, _richEmitEvent() e' un no-op immediato, zero chiamate di rete,
    // zero impatto. Quando pronto: aggiornare SOLO workerUrl ed enabled qui,
    // nessun'altra modifica necessaria altrove nel file.
    const EVENTS = {
      enabled:   true,
      workerUrl: 'https://skon-toast-events-worker.admins-e7e.workers.dev', // attivato 26 ott 2026, Worker+D1+webhook verificati con traffico reale
    };

    // ──────────────────────────────────────────────────────────────────
    // CUSTOMER_NEEDS (v4.1.0, 16 ott 2026) — Fase 2, requisito di design di
    // claude/SKON_PORT_PIANO_15ott2026.md §14: registro estensibile di "cosa
    // potremmo ancora chiedere a questo profilo", UNA SOLA definizione usata
    // sia dal percorso RC gia' loggato (auto-consent, profilo da Liquid/
    // window.SKON_CUSTOMER, zero round-trip) sia dal percorso NC/mismatch
    // (profilo dal Worker PROFILE_CHECK). Aggiungere un futuro modulo (es.
    // "review da lasciare") significa aggiungere UNA voce qui, non toccare
    // la logica di decisione in piu' punti.
    var CUSTOMER_NEEDS = [
      { id: 'birthday', needed: function(p) { return !p.birthday; } },
      // 28 ott 2026 -- gated da WHATSAPP_ASK_ENABLED (vedi definizione sopra):
      // a `false`, questo bisogno non risulta mai "necessario", qualunque sia
      // il valore reale di p.wa -- unico punto toccato, stesso esito ottenuto
      // sia da _richBuildPlan() (flusso NC/RC) sia da _richNeedsList() (auto-
      // consent), nessun'altra riga di CUSTOMER_NEEDS cambiata.
      { id: 'whatsapp', needed: function(p) { return WHATSAPP_ASK_ENABLED && p.wa !== 'active'; } },
    ];
    function _richNeeded(id, p) {
      var m = CUSTOMER_NEEDS.filter(function(x) { return x.id === id; })[0];
      return m ? !!m.needed(p) : false;
    }
    function _richNeedsList(p) {
      return CUSTOMER_NEEDS.filter(function(m) { return m.needed(p); }).map(function(m) { return m.id; });
    }

    // Porting 1:1 dal prototipo: modulo vantaggio per cluster RFM
    // Magnews, esplicitamente in pausa ("fase 1: nessuna offerta ai
    // clienti RC, riattivare quando si deciderà il vantaggio" — nota
    // originale del prototipo, 14 ott 2026). Nessuna decisione da
    // prendere qui: il prototipo stesso lo ha già deciso spento.
    const OFFER_MODULE_ENABLED = false;
    const OFFER_HOURS = 24;
    const OFFERS = {
      lost:     { big:'-50%', title:'Metà prezzo su tutto il tuo ordine per 24 ore.',
                  sub:'Valido per un carrello di almeno <strong>79€</strong>: metti 79€ di prodotti in carrello per pagarli solo 39,50€.' },
      atrisk:   { big:'-50%', title:'Metà prezzo su tutto il tuo ordine per 24 ore.',
                  sub:'Valido per un carrello di almeno <strong>79€</strong>: metti 79€ di prodotti in carrello per pagarli solo 39,50€.' },
      sleepers: { big:'3x2', title:'Tre prodotti, uno è in regalo',
                  sub:'Metti nel carrello tre prodotti: <strong>il meno caro te lo offriamo noi</strong>.' },
      spender:  { big:'🎁', title:'Un omaggio con il tuo ordine',
                  sub:'In regalo con il tuo prossimo ordine: <strong>[gadget da definire]</strong>.' }
    };


    // ──────────────────────────────────────────────────────────────────
    // LEAD GENERATION — step 2 del flusso CLASSICO (invariato v3.0.0)
    // ──────────────────────────────────────────────────────────────────
    const LEADGEN = {
      nc: {
        enabled: true,
        // v4.2.0 (19 ott 2026): endpoint skon-nc-subscribe-worker v4.0.0,
        // deployato e validato end-to-end lo stesso giorno (Magnews +
        // Shopify). Sostituisce il POST nativo /contact#ContactFooter nei
        // tre punti di iscrizione email del toast (vedi CHANGELOG sopra).
        workerUrl: 'https://skon-nc-subscribe.admins-e7e.workers.dev/subscribe-nc'
      },
      rcBirthday: {
        enabled: true,
        workerUrl: 'https://skon-birthday-bridge.admins-e7e.workers.dev'
      },
      whatsapp: {
        enabled: true,
        number: '15558978394',
        // Trigger del flow Community di PRODUZIONE, gia' live: lo usa SOLO
        // il modulo classico (whatsapp-cta) qui sotto. Non toccare.
        triggerText: 'Ciao, vorrei unirmi alla Skön WhatsApp Community',
        // Trigger DEDICATO al flow TextYess "#99 Flow - Welcome Popup NC
        // (test)", isolato apposta dal Community di produzione qui sopra.
        // Usato SOLO dal link WhatsApp del flusso rich (RICH_FLOW), mai da
        // quello classico. Deve combaciare carattere per carattere col
        // trigger configurato in TextYess (match esatto, nessuna tolleranza).
        richTriggerText: 'Ciao, vorrei entrare nella Community Skön e ricevere il mio sconto di benvenuto'
      }
    };

    const LEADGEN_MODULES = [
      {
        id: 'nc-email',
        slot: 'primary',
        enabledModule: function() { return LEADGEN.nc.enabled; },
        eligible: function(profile, ctx) { return ctx.answer === 'new'; },
        render: function(profile, ctx) {
          return [
            '<label class="skon-fs-ob-field-label" for="skonFsObEmail">',
              'La tua email, per un benvenuto come si deve:',
            '</label>',
            '<div class="skon-fs-ob-field-row">',
              '<input type="email" id="skonFsObEmail" class="skon-fs-ob-input" ',
                'placeholder="nome@esempio.it" autocomplete="email" inputmode="email">',
              '<button type="button" class="skon-fs-ob-btn skon-fs-ob-btn--sm" ',
                'data-skon-fs-ob-module="nc-email" data-skon-fs-ob-action="submit">Invia</button>',
            '</div>',
            '<p class="skon-fs-ob-consent">Iscrivendoti accetti di ricevere le nostre comunicazioni via email. Puoi disiscriverti in qualsiasi momento.</p>',
            '<p class="skon-fs-ob-feedback" id="skonFsObEmailFeedback"></p>',
          ].join('');
        },
        actions: {
          submit: function(btn) {
            const toast = document.getElementById('skonFsObToast');
            if (!toast) return;
            const input    = toast.querySelector('#skonFsObEmail');
            const feedback = toast.querySelector('#skonFsObEmailFeedback');
            const email    = input ? input.value.trim() : '';

            if (!_validEmail(email)) {
              if (feedback) {
                feedback.textContent = 'Controlla l\'indirizzo email.';
                feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--error';
              }
              return;
            }

            btn.disabled = true;
            btn.textContent = 'Invio…';
            if (feedback) { feedback.textContent = ''; feedback.className = 'skon-fs-ob-feedback'; }

            _xhrRequest({
              url: LEADGEN.nc.workerUrl,
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: email })
            }, function(err) {
              if (err) {
                _log('lead-gen email error', err);
                btn.disabled = false;
                btn.textContent = 'Invia';
                if (feedback) {
                  feedback.textContent = 'Qualcosa non ha funzionato, riprova tra poco.';
                  feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--error';
                }
                return;
              }
              if (feedback) {
                feedback.textContent = 'Grazie! Controlla la tua casella email.';
                feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--success';
              }
              if (input) input.disabled = true;
              btn.textContent = 'Fatto ✓';
              document.dispatchEvent(new CustomEvent('skon-fs:leadgen-email-submitted', {
                detail: { source: 'onboarding-toast' }
              }));
              _log('lead-gen email submitted');
              if (window.SkonID && typeof window.SkonID.observe === 'function') {
                try { window.SkonID.observe('email_captured', { type: 'NC' }); } catch (e) {}
              }
            });
          }
        }
      },
      {
        id: 'rc-birthday',
        slot: 'primary',
        enabledModule: function() { return LEADGEN.rcBirthday.enabled; },
        eligible: function(profile, ctx) { return ctx.answer === 'returning'; },
        render: function(profile, ctx) {
          return [
            '<label class="skon-fs-ob-field-label" for="skonFsObBirthEmail">',
              'La tua email, per riconoscerti nel nostro database:',
            '</label>',
            '<div class="skon-fs-ob-field-row">',
              '<input type="email" id="skonFsObBirthEmail" class="skon-fs-ob-input" ',
                'placeholder="nome@esempio.it" autocomplete="email" inputmode="email">',
            '</div>',
            '<label class="skon-fs-ob-field-label" for="skonFsObBirthDate">',
              'E la tua data di nascita, per un pensiero quando festeggi:',
            '</label>',
            '<div class="skon-fs-ob-field-row">',
              '<input type="date" id="skonFsObBirthDate" class="skon-fs-ob-input">',
              '<button type="button" class="skon-fs-ob-btn skon-fs-ob-btn--sm" ',
                'data-skon-fs-ob-module="rc-birthday" data-skon-fs-ob-action="submit">Invia</button>',
            '</div>',
            '<p class="skon-fs-ob-consent">Useremo questi dati solo per inviarti un omaggio o un vantaggio il giorno del tuo compleanno.</p>',
            '<p class="skon-fs-ob-feedback" id="skonFsObBirthFeedback"></p>',
          ].join('');
        },
        actions: {
          submit: function(btn) {
            if (!LEADGEN.rcBirthday.enabled) return;

            const toast      = document.getElementById('skonFsObToast');
            if (!toast) return;
            const emailInput = toast.querySelector('#skonFsObBirthEmail');
            const dateInput  = toast.querySelector('#skonFsObBirthDate');
            const feedback   = toast.querySelector('#skonFsObBirthFeedback');
            const email      = emailInput ? emailInput.value.trim() : '';
            const birthDate  = dateInput ? dateInput.value : '';

            if (!_validEmail(email) || !birthDate) {
              if (feedback) {
                feedback.textContent = 'Controlla email e data di nascita.';
                feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--error';
              }
              return;
            }

            btn.disabled = true;
            btn.textContent = 'Invio…';
            if (feedback) { feedback.textContent = ''; feedback.className = 'skon-fs-ob-feedback'; }

            _xhrRequest({
              url: LEADGEN.rcBirthday.workerUrl,
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: email, birthDate: birthDate })
            }, function(err) {
              if (err) {
                _log('lead-gen birthday error', err);
                btn.disabled = false;
                btn.textContent = 'Invia';
                if (feedback) {
                  feedback.textContent = 'Qualcosa non ha funzionato, riprova tra poco.';
                  feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--error';
                }
                return;
              }
              if (feedback) {
                feedback.textContent = 'Grazie! Ti aspetta una sorpresa per il tuo compleanno.';
                feedback.className = 'skon-fs-ob-feedback skon-fs-ob-feedback--success';
              }
              if (emailInput) emailInput.disabled = true;
              if (dateInput) dateInput.disabled = true;
              btn.textContent = 'Fatto ✓';
              document.dispatchEvent(new CustomEvent('skon-fs:leadgen-birthday-submitted', {
                detail: { source: 'onboarding-toast' }
              }));
              _log('lead-gen birthday submitted');
            });
          }
        }
      },
      {
        id: 'whatsapp-cta',
        slot: 'secondary',
        enabledModule: function() {
          return !!(LEADGEN.whatsapp.enabled && LEADGEN.whatsapp.number && LEADGEN.whatsapp.triggerText);
        },
        eligible: function() { return true; },
        render: function() {
          const href = 'https://api.whatsapp.com/send?phone=' + LEADGEN.whatsapp.number
            + '&text=' + encodeURIComponent(LEADGEN.whatsapp.triggerText);
          return [
            '<a href="', href, '" target="_blank" rel="noopener" class="skon-fs-ob-wa-link">',
              'Scrivici su WhatsApp →',
            '</a>',
          ].join('');
        },
        actions: {}
      }
    ];


    // ══════════════════════════════════════════════════════════════════
    // SkonFS.onboarding — namespace pubblico
    // ══════════════════════════════════════════════════════════════════

    SkonFS.onboarding = {

      /**
       * Decide se mostrare il toast adesso o no.
       * INVARIATA dalla v3.0.0 nel suo ramo classico. L'unica aggiunta
       * (v4.0.0) è il ramo "auto-consent" del flusso rich, che si attiva
       * SOLO con RICH_FLOW.enabled true e SOLO per il caso specifico
       * "RC già riconosciuto con confidenza >=50": a flag spento questo
       * ramo non esiste, shouldShow() è bit-per-bit quella di v3.0.0.
       */
      shouldShow: function() {
        if (_ss(SETTINGS.sessionFlag) === '1') return false;

        const declared = _ss(SETTINGS.autodeclareFlag);
        if (declared === 'new' || declared === 'returning') return false;

        if (window.SkonID && typeof window.SkonID.hasCompletedQuiz === 'function'
            && window.SkonID.hasCompletedQuiz()) return false;

        if (window.SkonID && typeof window.SkonID.getProfile === 'function') {
          var _p = window.SkonID.getProfile();
          if (_p && _p.type === 'RC' && _p.confidence >= 50) {
            // v4.0.0 — RICH_FLOW: questo è esattamente il caso "auto-consent"
            // del prototipo (cliente già riconosciuta). A flag spento,
            // comportamento INVARIATO: sopprime (return false), come sempre.
            //
            // v4.0.1 (16 ott 2026) — FIX: questo blocco va PRIMA del controllo
            // su skon_rc_verified qui sotto, non dopo (come era finora). Quel
            // flag lo scrive SEMPRE markCustomer() per OGNI cliente RC reale
            // (vedi skon-identity.js) — quindi con l'ordine precedente un
            // cliente vero, loggato, con ordini, non arrivava MAI fin qui:
            // veniva sempre intercettato prima, e il ramo auto-consent restava
            // codice morto nella pratica (si attivava solo nei test che
            // scrivevano lo stato a mano in sessionStorage, bypassando
            // markCustomer() e quindi mai impostando skon_rc_verified).
            // Scoperto da Matteo testando con un vero account cliente.
            if (RICH_FLOW.enabled) {
              this._richAutoConsentName = (_p.profile && typeof _p.profile === 'object' && _p.profile.name) || null;

              // v4.1.0 (16 ott 2026) — CUSTOMER_NEEDS: per questo caso (cliente
              // GIA' loggata) il profilo e' server-truth via Liquid, zero
              // round-trip (vedi _getLiquidCustomerProfile). Se non manca
              // davvero nulla, niente auto-consent pieno: saluto minimo di
              // navigazione (richiesta esplicita di Matteo, 15 ott sera,
              // SKON_PORT_PIANO_15ott2026.md §14). Se SKON_CUSTOMER non da'
              // un profilo "found" (caso anomalo: non dovrebbe succedere dato
              // che siamo gia' nel ramo _p.type==='RC', ma mai assumere),
              // si ripiega sul pieno auto-consent — mai sul "non manca nulla".
              var _liquidProfile = _getLiquidCustomerProfile();
              this._richAutoConsentProfile = _liquidProfile;
              // 28 ott 2026 -- anche questo fallback anomalo (profilo Liquid
              // non "found") rispetta WHATSAPP_ASK_ENABLED: e' un array
              // hardcoded indipendente da CUSTOMER_NEEDS, quindi va gated qui
              // separatamente perche' non passa da _richNeedsList() in questo
              // ramo specifico.
              this._richAutoConsentNeeds = _liquidProfile.found ? _richNeedsList(_liquidProfile) : (WHATSAPP_ASK_ENABLED ? ['birthday', 'whatsapp'] : ['birthday']);
              if (this._richAutoConsentNeeds.length === 0) {
                return 'auto-consent-min'; // saluto minimo, nessun dato da chiedere
              }
              return 'auto-consent'; // valore troncato a true da ogni if() esistente, ma show() lo ispeziona
            }
            return false;
          }
        }

        if (_ss('skon_rc_verified') === '1') return false;

        if (_ss(SETTINGS.addedToCartFlag) === '1') return false;

        // v4.3.0 -- promemoria cross-sessione (cookie, non sessionStorage:
        // deve sopravvivere a un nuovo tab/sessione, es. un link aperto da
        // email). Si attiva SOLO se non e' gia' risultata cliente (i rami
        // sopra l'hanno gia' esclusa) e SOLO con RICH_FLOW attivo: a flag
        // spento, comportamento invariato. Priorita': chi e' gia' su
        // WhatsApp vince sempre (richiesta esplicita di Matteo, 22 ott 2026:
        // "e' quello di WhatsApp il codice che dobbiamo ricordargli"),
        // altrimenti chi ha solo il codice email viene invitato anche su
        // WhatsApp.
        // 28 ott 2026 -- entrambi i promemoria sono inviti a (ri)fare qualcosa
        // su WhatsApp: gated anche da WHATSAPP_ASK_ENABLED, oltre a
        // RICH_FLOW.enabled. A flag spento, chi avrebbe visto uno di questi
        // due promemoria prosegue semplicemente sul flusso normale (`return
        // true` qui sotto) -- nessun cookie viene toccato/cancellato, i
        // promemoria torneranno a funzionare da soli quando si riaccende.
        if (RICH_FLOW.enabled && WHATSAPP_ASK_ENABLED) {
          if (_getCookie(WA_SUBSCRIBED_COOKIE) === '1') return 'reminder-wa-code';
          if (_getCookie(NC_CODE_SENT_COOKIE) === '1') return 'reminder-join-wa';
        }

        return true;
      },


      /**
       * v4.12.0 -- SOLA LETTURA. Stato/capacita' del modulo per i punti di
       * ingresso (assets/skon-entrypoints.js). Nessun effetto collaterale.
       */
      capabilities: function() {
        var cust = _getLiquidCustomerProfile();
        return {
          version:      '4.18.0',
          welcomePct:   { email: WELCOME_PCT.email, wa: WELCOME_PCT.wa }, // v4.18.0 (sola lettura)
          inline:       true, // v4.15.0: openFrom accetta `host` (montaggio dentro la pagina)
          inlineBanner: true, // v4.16.0: openFrom accetta inlineStyle:'banner' (il banner si trasforma sul posto)
          enabled:      !!(TOAST_MODULE_ENABLED && RICH_FLOW.enabled),
          whatsapp:     !!WHATSAPP_ASK_ENABLED,
          birthday:     !!LEADGEN.rcBirthday.enabled,
          codeSent:     _getCookie(NC_CODE_SENT_COOKIE) === '1',
          waSubscribed: _getCookie(WA_SUBSCRIBED_COOKIE) === '1',
          customer:     cust,
          needs:        cust.found ? _richNeedsList(cust) : null,
          open:         !!(_rcToast && _rcToast.parentNode && !_rcToast.hidden),
          pending:      !!_ss(PENDING_TAB_KEY)
        };
      },

      /**
       * v4.12.0 -- riapre il toast rich da una CTA del sito (vedi CHANGELOG).
       * opts: { entry, origin, lead, modal }. Non lancia mai: ritorna false se
       * non puo' aprire (modulo spento, entry non ammessa, errore interno).
       */
      openFrom: function(opts) {
        try {
          opts = opts || {};
          if (!TOAST_MODULE_ENABLED || !RICH_FLOW.enabled) return false;
          var entry = String(opts.entry || '');
          if (CTA_ENTRIES.indexOf(entry) === -1) return false;
          if ((entry === 'reminder-join-wa' || entry === 'reminder-wa-code') && !WHATSAPP_ASK_ENABLED) return false;
          var origin = String(opts.origin || 'unknown').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 40) || 'unknown';
          _richTeardownDom();
          _ss(SETTINGS.sessionFlag, '1');
          _ss(PENDING_TAB_KEY, '');
          _richInit({ entry: entry, entryType: 'cta:' + origin, modal: opts.modal !== false, lead: opts.lead || null, leadHtml: opts.leadHtml || null, offer: entry === 'nc-welcome' ? (opts.offer || null) : null, host: opts.host || null, onClose: opts.onClose || null, inlineStyle: opts.inlineStyle || null, onReady: opts.onReady || null });
          return true;
        } catch (e) {
          _log('openFrom errore (ignorato)', e);
          return false;
        }
      },

      _renderStep1: function() {
        return [
          '<p class="skon-fs-ob-q">',
            'Hai già provato Skön Cosmetics?',
            '<button type="button" class="skon-fs-ob-close" data-skon-fs-ob-action="dismiss" aria-label="Chiudi">',
              '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"',
                ' stroke-width="2.5" stroke-linecap="round">',
                '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
              '</svg>',
            '</button>',
          '</p>',
          '<p class="skon-fs-ob-sub">Una piccola domanda per personalizzare la tua esperienza in Skön Cosmetics.</p>',
          '<div class="skon-fs-ob-btns">',
            '<button type="button" class="skon-fs-ob-btn" data-skon-fs-ob-answer="new">',
              'No, prima volta',
            '</button>',
            '<button type="button" class="skon-fs-ob-btn skon-fs-ob-btn--secondary" data-skon-fs-ob-answer="returning">',
              'Sì, sono cliente',
            '</button>',
          '</div>',
        ].join('');
      },


      _renderLeadGenSlot: function(answerType) {
        const profile = _getIdentityProfile();
        const ctx = { answer: answerType };

        const primary = LEADGEN_MODULES.filter(function(m) {
          return m.slot === 'primary' && m.enabledModule() && m.eligible(profile, ctx);
        })[0];

        const secondaryHtml = LEADGEN_MODULES.filter(function(m) {
          return m.slot === 'secondary' && m.enabledModule() && m.eligible(profile, ctx);
        }).map(function(m) { return m.render(profile, ctx); }).join('');

        if (primary) {
          return [
            '<div class="skon-fs-ob-leadgen">',
              primary.render(profile, ctx),
              secondaryHtml,
            '</div>',
          ].join('');
        }
        return secondaryHtml;
      },


      _renderStep2New: function() {
        const group     = SkonFS.ab.getGroup();
        const threshold = SkonFS.ab.getThreshold();
        const baseline  = (CFG.thresholds && CFG.thresholds.groupA) || 4900;
        const isB       = (group === 'B');

        const body = isB
          ? [
              'Per il tuo primo acquisto la spedizione è ',
              '<strong>gratuita già da ', _euro(threshold), '</strong>',
              ' invece di <s>', _euro(baseline), '</s>.',
              ' La trovi in automatico al checkout.',
            ].join('')
          : 'Felicissimi di averti qui — esplora le nostre proposte e scopri cosa fa per la tua pelle.';

        return [
          '<p class="skon-fs-ob-q">',
            'Il nostro benvenuto in Skön 🌿',
            '<button type="button" class="skon-fs-ob-close" data-skon-fs-ob-action="dismiss" aria-label="Chiudi">',
              '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"',
                ' stroke-width="2.5" stroke-linecap="round">',
                '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
              '</svg>',
            '</button>',
          '</p>',
          '<p class="skon-fs-ob-sub">', body, '</p>',
          '<div class="skon-fs-ob-btns">',
            '<button type="button" class="skon-fs-ob-btn" data-skon-fs-ob-action="dismiss">',
              'Inizia a esplorare →',
            '</button>',
          '</div>',
          this._renderLeadGenSlot('new'),
        ].join('');
      },


      _renderStep2Returning: function() {
        return [
          '<p class="skon-fs-ob-q">',
            'Bentornata in Skön 🩷',
            '<button type="button" class="skon-fs-ob-close" data-skon-fs-ob-action="dismiss" aria-label="Chiudi">',
              '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"',
                ' stroke-width="2.5" stroke-linecap="round">',
                '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
              '</svg>',
            '</button>',
          '</p>',
          '<p class="skon-fs-ob-sub">Che bello rivederti! Esplora le nostre novità di stagione. Se hai bisogno, siamo a tua disposizione.</p>',
          '<div class="skon-fs-ob-btns">',
            '<button type="button" class="skon-fs-ob-btn skon-fs-ob-btn--secondary" data-skon-fs-ob-action="dismiss">',
              'Continua →',
            '</button>',
          '</div>',
          this._renderLeadGenSlot('returning'),
        ].join('');
      },


      _renderStep2Quiz: function(type) {
        const intro = (type === 'returning')
          ? 'Bentornata! Conosci già la tua routine ideale?'
          : 'Conosci la routine ideale per te?';
        return [
          '<p class="skon-fs-ob-q">',
            intro,
            '<button type="button" class="skon-fs-ob-close" data-skon-fs-ob-action="dismiss" aria-label="Chiudi">',
              '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"',
                ' stroke-width="2.5" stroke-linecap="round">',
                '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
              '</svg>',
            '</button>',
          '</p>',
          '<p class="skon-fs-ob-sub">Bastano 2 minuti per scoprire quali prodotti Skön sono perfetti per la tua pelle. E c\'è qualcosa per te alla fine! 🎁</p>',
          '<div class="skon-fs-ob-btns">',
            '<a href="' + QUIZ_URL + '" class="skon-fs-ob-btn skon-fs-ob-btn--link">Fai il test gratuito →</a>',
          '</div>',
          this._renderLeadGenSlot(type),
        ].join('');
      },


      /**
       * Mostra il toast. v4.0.0: dispatch in base a RICH_FLOW.enabled.
       * Il ramo classico (if/else al suo interno) è ESATTAMENTE quello
       * della v3.0.0, intoccato.
       * v4.11.0 -- PRIMA di qualunque altra cosa: se TOAST_MODULE_ENABLED
       * è false, nessun toast di nessun tipo viene mai mostrato. Questo è
       * l'UNICO punto in cui un toast (classico o rich) viene creato nel
       * DOM in tutto il file -- una guardia qui basta a rendere l'intero
       * modulo silenzioso.
       */
      show: function() {
        if (!TOAST_MODULE_ENABLED) return;

        const decision = this.shouldShow();
        if (!decision) return;

        if (RICH_FLOW.enabled && (decision === 'auto-consent' || decision === 'auto-consent-min')) {
          _ss(SETTINGS.sessionFlag, '1');
          _richInit({
            entry:   decision,
            name:    this._richAutoConsentName,
            profile: this._richAutoConsentProfile,
            needs:   this._richAutoConsentNeeds
          });
          return;
        }
        if (RICH_FLOW.enabled && (decision === 'reminder-wa-code' || decision === 'reminder-join-wa')) {
          // v4.3.0 -- promemoria: entry point dedicato, zero round-trip (non
          // serve ri-verificare nulla per mostrarlo, e' solo un invito ad
          // andare a vedere qualcosa che e' gia' stato inviato).
          _ss(SETTINGS.sessionFlag, '1');
          _richInit({ entry: decision });
          return;
        }
        if (RICH_FLOW.enabled) {
          _ss(SETTINGS.sessionFlag, '1');
          _richInit({ entry: 'intro' });
          return;
        }

        // ── ramo CLASSICO (v3.0.0, invariato) ──
        _ss(SETTINGS.sessionFlag, '1');

        const toast = document.createElement('div');
        toast.id        = 'skonFsObToast';
        toast.className = 'skon-fs-ob-toast';
        toast.innerHTML = this._renderStep1();
        document.body.appendChild(toast);

        toast.addEventListener('click', SkonFS.onboarding._handleClick);

        _log('toast shown (step 1, classic flow)');
      },


      _replaceContent: function(html) {
        const toast = document.getElementById('skonFsObToast');
        if (!toast) return;

        toast.classList.add('skon-fs-ob-toast--switching');
        setTimeout(function() {
          toast.innerHTML = html;
          toast.classList.remove('skon-fs-ob-toast--switching');
        }, 180);
      },


      _handleClick: function(e) {
        const dismissBtn = e.target.closest('[data-skon-fs-ob-action="dismiss"]');
        if (dismissBtn) {
          SkonFS.onboarding.dismiss();
          return;
        }

        const moduleBtn = e.target.closest('[data-skon-fs-ob-module]');
        if (moduleBtn) {
          const modId = moduleBtn.getAttribute('data-skon-fs-ob-module');
          const actionName = moduleBtn.getAttribute('data-skon-fs-ob-action');
          const mod = LEADGEN_MODULES.filter(function(m) { return m.id === modId; })[0];
          if (mod && mod.actions && typeof mod.actions[actionName] === 'function') {
            mod.actions[actionName](moduleBtn);
          }
          return;
        }

        const answerBtn = e.target.closest('[data-skon-fs-ob-answer]');
        if (answerBtn) {
          const answer = answerBtn.getAttribute('data-skon-fs-ob-answer');
          SkonFS.onboarding._handleAnswer(answer);
        }
      },


      _handleAnswer: function(answer) {
        _log('user answered:', answer);

        _ss(SETTINGS.autodeclareFlag, answer);

        var quizDone = !!(window.SkonID
              && typeof window.SkonID.hasCompletedQuiz === 'function'
              && window.SkonID.hasCompletedQuiz());
        if (!quizDone) {
          try { quizDone = !!localStorage.getItem('skon_quiz_result'); } catch (e) {}
        }

        var noQuizCta = quizDone
          || (window.SKON_QUIZ_INVITES === false)
          || !!(window.SkonQuizExcluded && window.SkonQuizExcluded());

        if (answer === 'new') {
          if (window.SkonID) window.SkonID.observe('declared', { type: 'NC' });
          else _ss('skon_visitor_type', 'NC');
          document.dispatchEvent(new CustomEvent('skon-fs:declared', {
            detail: { type: 'new', group: SkonFS.ab.getGroup() }
          }));
          this._replaceContent(noQuizCta ? this._renderStep2New() : this._renderStep2Quiz('new'));
        }

        if (answer === 'returning') {
          if (window.SkonID) window.SkonID.observe('declared', { type: 'RC' });
          else _ss('skon_visitor_type', 'RC');
          document.dispatchEvent(new CustomEvent('skon-fs:declared', {
            detail: { type: 'returning' }
          }));
          this._tearDown();
          this._replaceContent(noQuizCta ? this._renderStep2Returning() : this._renderStep2Quiz('returning'));
        }
      },


      dismiss: function() {
        const toast = document.getElementById('skonFsObToast');
        if (!toast) return;
        toast.classList.add('skon-fs-ob-toast--out');
        setTimeout(function() {
          if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 300);
      },


      _tearDown: function() {
        document.body.classList.remove('skon-fs-active');
        document.querySelectorAll('[data-skon-fs-progress]').forEach(function(el) {
          el.innerHTML = '';
        });
        document.querySelectorAll('[data-skon-fs-suggestions]').forEach(function(el) {
          el.innerHTML = '';
        });
        _log('tear down complete (user declared RC)');
      },
    };


    // ════════════════════════════════════════════════════════════════════
    // RICH FLOW (v4.0.0) — porting del prototipo, namespace isolato.
    // Markup/CSS/DOM id tutti separati dal flusso classico qui sopra
    // (prefisso "Rich"), per zero rischio di collisione.
    // Attivo SOLO quando RICH_FLOW.enabled === true (vedi show()).
    // ════════════════════════════════════════════════════════════════════

    function _xhrRequest(opts, cb) {
      // Helper di rete via XMLHttpRequest invece di fetch(): alcune app di
      // terze parti installate sul tema (ReelUp, estensione checkout
      // Logbase "lb-upsell") sovrascrivono window.fetch con dei wrapper
      // che, in certi contesti, mandano in errore qualsiasi fetch() anche
      // quando non c'entrano nulla con la chiamata originale. XHR non
      // viene intercettato da questi wrapper. Verificato il 18 ott 2026.
      try {
        var xhr = new XMLHttpRequest();
        xhr.open(opts.method || 'POST', opts.url, true);
        if (opts.headers) {
          for (var k in opts.headers) {
            if (Object.prototype.hasOwnProperty.call(opts.headers, k)) xhr.setRequestHeader(k, opts.headers[k]);
          }
        }
        xhr.timeout = opts.timeout || 8000;
        xhr.onload = function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            cb(null, xhr.responseText);
          } else {
            cb(new Error('bad status ' + xhr.status));
          }
        };
        xhr.onerror = function() { cb(new Error('network error')); };
        xhr.ontimeout = function() { cb(new Error('timeout')); };
        xhr.send(opts.body || null);
      } catch (e) {
        cb(e);
      }
    }

    function _richCheckProfile(email, cb) {
      // Fallback di sicurezza: nessun Worker pronto (o chiamata fallita) →
      // MAI inventare un profilo. "non trovato" è l'unico stato onesto.
      var safeFallback = { found: false, orders: 0, birthday: false, wa: 'none' };
      if (!PROFILE_CHECK.enabled || !PROFILE_CHECK.workerUrl) {
        return cb(safeFallback);
      }
      _xhrRequest({
        url: PROFILE_CHECK.workerUrl,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }, function(err, responseText) {
        if (err) {
          _log('profile-check error, fallback a "non trovato"', err);
          return cb(safeFallback);
        }
        var data = {};
        try { data = JSON.parse(responseText || '{}'); } catch (e2) {}
        cb({
          found:    !!data.found,
          orders:   Number(data.orders) || 0,
          birthday: !!data.birthday,
          wa:       (data.wa === 'active' || data.wa === 'irregular') ? data.wa : 'none'
        });
      });
    }

    // v4.4.0 (22 ott 2026) -- verifica se un codice sconto e' GIA' applicato
    // al carrello adesso, per non promettere "ti aspetta ancora" a chi lo ha
    // appena attivato (es. atterrato dal link email, popup SkonDiscount gia'
    // mostrato con "codice attivato" -- segnalato da Matteo con screenshot
    // il 22 ott: il promemoria diceva "controlla la tua casella" a chi aveva
    // gia' il codice applicato al carrello). Stessa fonte di verita' gia'
    // validata empiricamente per skon-discount-popup.liquid v1.2.0:
    // cart.discount_codes[] non vuoto riflette sempre cosa e' davvero in
    // vigore per QUESTO carrello (lo gestisce Shopify stesso, non un'euristica
    // nostra) -- qui basta sapere SE c'e' un codice, non quale, quindi nessuna
    // chiamata al Worker di lookup: solo /cart.js, stesso dominio, nessun
    // nuovo servizio esterno coinvolto. Fallback onesto su qualunque errore:
    // "non attivo" (mai affermare un'attivazione che non si e' potuta
    // verificare).
    function _cartHasActiveDiscount(cb) {
      _xhrRequest({ url: '/cart.js', method: 'GET' }, function(err, text) {
        if (err) return cb(false);
        try {
          var cart = JSON.parse(text || '{}');
          var codes = cart.discount_codes || [];
          cb(codes.length > 0);
        } catch (e) {
          cb(false);
        }
      });
    }

    function _richMakeCode() {
      var a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = '';
      for (var i = 0; i < 6; i++) s += a.charAt(Math.floor(Math.random() * a.length));
      return 'SKON-' + s;
    }
    function _richFmtExpiry(ts) {
      return new Date(ts).toLocaleString('it-IT', { weekday:'long', day:'numeric', month:'long', hour:'2-digit', minute:'2-digit' });
    }
    function _richFmtLeft(ms) {
      if (ms < 0) ms = 0;
      var t = Math.floor(ms / 1000), h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
      function p(n) { return (n < 10 ? '0' : '') + n; }
      return p(h) + ':' + p(m) + ':' + p(s);
    }
    function _richTodayLabel() {
      try {
        return new Intl.DateTimeFormat('it-IT', { weekday:'long', day:'numeric', month:'long', timeZone:'Europe/Rome' }).format(new Date());
      } catch (e) {
        var d = new Date(), g = ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'],
            m = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
        return g[d.getDay()] + ' ' + d.getDate() + ' ' + m[d.getMonth()];
      }
    }

    // ── stato del flusso rich (ricreato a ogni apertura del toast) ──
    var _rc = null;          // ctx corrente
    var _rcNavToken = 0;
    var _rcCountdownTimer = null;
    var _rcAutoCloseTimer = null;
    var _rcInactivityWheel = null; // playIntro timers, non persistenti
    var _rcMinimized = false;
    var _rcRestartPending = false; // v4.5.0: v. _richCloseDone/_richMinimizeForRestart
    var _rcCurrent = 'intro';
    var _rcToast, _rcBody, _rcDots, _rcScrim, _rcTab;
    var _rcModal = false;     // v4.12.0: true se aperto da CTA come popup centrale
    var _rcInline = null;     // v4.15.0: elemento ospite se il flusso e' montato DENTRO la pagina (banner in collection), senza overlay
    var _rcOnClose = null;    // v4.15.0: callback dell'ospite, chiamata quando il flusso inline si chiude o si minimizza
    var CTA_ENTRIES = ['nc-welcome', 'rc-welcome', 'reminder-join-wa', 'reminder-wa-code'];
    var CTA_LEAD_STEPS = ['nc-welcome', 'rc-welcome', 'reminder-join-wa', 'reminder-wa-code'];

    function _richFreshCtx() {
      return {
        path: null, gotEmail: false, gotBirthday: false, waClicked: false, codeSent: false,
        profile: null, greetName: null, plan: [], stepNo: 0, dotTotal: 3,
        mismatch: false, offerCode: null, offerExpires: null, offerApplied: false,
        email: null, prefillEmail: '',
        resumeStep: null, entryName: '',
        // v4.7.0 -- tracciamento eventi (vedi blocco dedicato piu' sotto):
        // visitorId valorizzato da _richInit subito dopo _richFreshCtx(),
        // cartAttrWritten e' il guard "una sola volta per apertura" di
        // _richWriteVisitorIdAttribute.
        visitorId: null, cartAttrWritten: false,
        // v4.8.0 -- sessionId: id fresco per QUESTA apertura del toast, MAI
        // un cookie (vive solo in memoria) — valorizzato in _richInit subito
        // dopo questo _richFreshCtx(). declared: 'new'/'returning'/'auto',
        // valorizzato nei punti elencati nel CHANGELOG 4.8.0 in testa al file.
        sessionId: null, declared: null
      };
    }

    function _richHi(title) {
      if (_rc.greetName) { var n = _rc.greetName; _rc.greetName = null; return 'Ciao ' + n + '! ' + title; }
      return title;
    }
    function _richNextDots() {
      _rc.stepNo++;
      if (_rc.stepNo >= _rc.dotTotal) return null;
      return { names: Array.from({ length: _rc.dotTotal }), idx: _rc.stepNo };
    }

    // decide i passi successivi in base a cosa dichiara la persona e a cosa
    // il profile-check restituisce (o al fallback sicuro "non trovato")
    function _richBuildPlan(p, declared) {
      var isCustomer = p.found && p.orders > 0;
      var plan = [];

      // v4.3.0 -- persistenza cookie dei traguardi NC gia' raggiunti, SOLO
      // per chi non e' ancora cliente (isCustomer false): per una cliente
      // vera, il ramo "_p.type==='RC' && confidence>=50" di shouldShow() la
      // intercetta gia' prima che si arrivi qui. _richBuildPlan e' l'unico
      // punto che riceve SEMPRE il profilo appena verificato da PROFILE_CHECK
      // (o da un'email nota in precompilazione), per ogni ramo del flusso NC
      // -- scelto apposta come unico punto di scrittura invece di duplicarlo
      // nei due call site che lo invocano.
      if (!isCustomer && p.wa === 'active') {
        _setCookie(WA_SUBSCRIBED_COOKIE, '1', REMINDER_COOKIE_DAYS);
      }

      if (isCustomer) {
        _rc.mismatch = (declared === 'new');
        if (OFFER_MODULE_ENABLED) {
          plan.push('offer');
        } else if (_rc.mismatch) {
          plan.push('mismatch-rc');
        }
        if (_richNeeded('birthday', p)) plan.push('birthday'); // v4.1.0: via CUSTOMER_NEEDS, stesso esito di !p.birthday
      } else if (declared === 'new') {
        _rc.codeSent = true;
        _setCookie(NC_CODE_SENT_COOKIE, '1', REMINDER_COOKIE_DAYS); // v4.3.0
        if (p.wa === 'active') {
          plan.push('nc-code-sent');
        }
      } else {
        plan.push('restart-nc');
      }
      if (_richNeeded('whatsapp', p)) plan.push('whatsapp'); // v4.1.0: via CUSTOMER_NEEDS, stesso esito di p.wa !== 'active'
      plan.push('done');
      return plan;
    }

    function _richNext() {
      var s = _rc.plan.shift() || 'done';
      if (s === 'offer') return _richRenderOffer();
      if (s === 'mismatch-rc') return _richRenderMismatchRc();
      if (s === 'restart-nc') {
        // v4.8.0 -- da qui in poi la sessione rientra nel flusso NC a tutti
        // gli effetti (nuovo welcome NC, piano ripulito): declared segue path.
        _rc.path = 'new'; _rc.declared = 'new'; _rc.plan = []; _rc.prefillEmail = _rc.email || ''; _rc.greetName = null;
        return _richRenderNcWelcome();
      }
      if (s === 'nc-code-sent') return _richRenderNcCodeSent();
      if (s === 'birthday') return _richRenderRcBirthday();
      if (s === 'whatsapp') return _richRenderNcWhatsapp();
      return _richRenderDone();
    }

    function _richSetScrim(on) {
      if (_rcScrim) _rcScrim.classList.toggle('on', !!on && !_rcMinimized);
    }

    // v4.16.1 -- verifica rigorosa della struttura di un indirizzo email (solo flusso rich, vedi CHANGELOG).
    function _richValidEmail(v) {
      var e = String(v == null ? '' : v).trim();
      if (!e || e.length > 254) return false;
      var at = e.indexOf('@');
      if (at < 1 || at !== e.lastIndexOf('@')) return false;
      var local = e.slice(0, at), dom = e.slice(at + 1);
      if (local.length > 64) return false;
      if (!/^[A-Za-z0-9.!#$%&'*+\/=?^_`{|}~-]+$/.test(local)) return false;
      if (local.charAt(0) === '.' || local.charAt(local.length - 1) === '.' || local.indexOf('..') !== -1) return false;
      var labels = dom.split('.');
      if (labels.length < 2) return false;
      for (var i = 0; i < labels.length; i++) {
        if (!/^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/.test(labels[i])) return false;
      }
      var tld = labels[labels.length - 1];
      return /^[A-Za-z]{2,24}$/.test(tld) || /^xn--[A-Za-z0-9-]{2,59}$/.test(tld);
    }

    // ──────────────────────────────────────────────────────────────────
    // TRACCIAMENTO EVENTI TOAST (v4.7.0, 26 ott 2026) — Livello 2, vedi
    // claude/SKON_TOAST_EVENT_TRACKING_ARCHITETTURA_22ott2026.md
    // ──────────────────────────────────────────────────────────────────

    // UUID v4 — crypto.randomUUID() dove disponibile (tutti i browser
    // moderni), fallback manuale via crypto.getRandomValues per i rari
    // contesti senza (mai un errore bloccante: un fallback pseudo-casuale
    // su Math.random come ultimissima rete di sicurezza, accettabile per
    // un ID di tracciamento, MAI per nulla di crittografico).
    function _uuidv4() {
      try {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
      } catch (e) {}
      try {
        var buf = new Uint8Array(16);
        window.crypto.getRandomValues(buf);
        buf[6] = (buf[6] & 0x0f) | 0x40;
        buf[8] = (buf[8] & 0x3f) | 0x80;
        var hex = Array.prototype.map.call(buf, function(b) { return b.toString(16).padStart(2, '0'); }).join('');
        return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
      } catch (e) {
        return 'vid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      }
    }

    // Genera il cookie skon_vid una sola volta per browser (60gg, nessun
    // gate di consenso — decisione di Matteo, vedi architettura §2) e lo
    // riusa per tutta la sua durata. Richiamabile piu' volte senza side
    // effect: se il cookie esiste gia', lo rilegge e basta (nessuna
    // rigenerazione, nessun rinnovo della scadenza qui — il rinnovo
    // avviene naturalmente alla prossima apertura dopo la scadenza).
    function _ensureVisitorId() {
      var existing = _getCookie(VISITOR_ID_COOKIE);
      if (existing) return existing;
      var id = _uuidv4();
      _setCookie(VISITOR_ID_COOKIE, id, VISITOR_ID_DAYS);
      return id;
    }

    // Algoritmo di riferimento: DEVE restare identico a hashEmailHex() in
    // claude/skon-toast-events-worker.js (normalizza minuscolo+trim, SHA-256
    // su UTF-8, esadecimale minuscolo) — vedi nota "ALGORITMO EMAIL_HASH" in
    // testa a quel file. Un disallineamento qui romperebbe silenziosamente
    // il join del §5 dell'architettura per qualunque email con differenze
    // di maiuscole/spazi fra invio nel toast e checkout.
    function _hashEmailHex(rawEmail) {
      var normalized = String(rawEmail || '').trim().toLowerCase();
      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized)).then(function(digest) {
        var bytes = new Uint8Array(digest);
        var hex = '';
        for (var i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
        return hex;
      });
    }

    // Invio evento, fire-and-forget, MAI bloccante, MAI un redirect (vedi
    // architettura §3). sendBeacon sopravvive anche se la pagina sta per
    // essere scaricata (es. tap su link WhatsApp, chiusura tab) — proprio
    // il caso che un fetch normale perderebbe. extra puo' contenere step,
    // entry_type, email_hash, ts — tutti opzionali, il Worker li tratta
    // come tali (vedi claude/skon-toast-events-worker.js).
    function _richEmitEvent(name, extra) {
      if (!EVENTS.enabled || !EVENTS.workerUrl) return; // no-op finche' il Worker non e' pronto
      try {
        var payload = Object.assign({
          visitor_id: _rc && _rc.visitorId,
          event: name,
          ts: Date.now(),
          // v4.8.0 -- automatico per OGNI evento, nessuna modifica richiesta
          // nei singoli call site esistenti (vedi CHANGELOG 4.8.0 in testa
          // al file). null se _rc.declared non e' ancora stato valorizzato
          // (es. toast_shown sull'intro, prima di qualunque dichiarazione).
          session_id: _rc && _rc.sessionId,
          declared: (_rc && _rc.declared) || null,
        }, extra || {});
        if (!payload.visitor_id) return; // difensivo: non dovrebbe mai succedere dopo _richInit
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          var ok = navigator.sendBeacon(EVENTS.workerUrl + '/event', new Blob([body], { type: 'application/json' }));
          if (ok) return;
        }
        fetch(EVENTS.workerUrl + '/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, mode: 'cors' }).catch(function() {});
      } catch (e) {
        _log('richEmitEvent errore (ignorato, non blocca il toast)', e);
      }
    }

    // Join secondario via attributo carrello (architettura §5) — scritto
    // direttamente via l'endpoint nativo Shopify /cart/update.js (merge
    // documentato, non sovrascrive altri attributi) invece di richiamare
    // SkonFS.cart.setCartAttributes(): vedi nota nel CHANGELOG 4.7.0 in
    // testa al file sul perche' di questa scelta. Scritto una sola volta
    // per apertura del toast (guard su _rc.cartAttrWritten), fire-and-forget,
    // nessun impatto se fallisce (il join primario via email_hash resta
    // comunque disponibile per chi arriva a inserire un'email).
    function _richWriteVisitorIdAttribute(visitorId) {
      if (!EVENTS.enabled || !visitorId) return;
      if (_rc && _rc.cartAttrWritten) return;
      if (_rc) _rc.cartAttrWritten = true;
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { skon_visitor_id: visitorId } }),
          keepalive: true,
        }).catch(function() {});
      } catch (e) {}
    }

    function _richRenderDots(names, idx) {
      if (!_rcDots) return;
      _rcDots.innerHTML = names.map(function(_, i) {
        return '<span class="' + (i === idx ? 'active' : '') + '"></span>';
      }).join('');
    }

    function _richClearCountdown() { if (_rcCountdownTimer) { clearInterval(_rcCountdownTimer); _rcCountdownTimer = null; } }
    function _richClearAutoClose() { if (_rcAutoCloseTimer) { clearTimeout(_rcAutoCloseTimer); _rcAutoCloseTimer = null; } }

    function _richLockStep() {
      _rcBody.querySelectorAll('button, a').forEach(function(b) { b.disabled = true; b.style.pointerEvents = 'none'; });
    }

    function _richGo(stepId, html, dotInfo) {
      html = _wp(html); // v4.18.0: percentuali dal punto unico WELCOME_PCT
      _richClearAutoClose();
      _richClearCountdown();
      var myNav = ++_rcNavToken;
      _richSetScrim(_rcModal || (stepId !== 'intro' && stepId !== 'rc-teaser' && stepId !== 'auto-consent' && stepId !== 'auto-consent-min' && stepId !== 'reminder-wa-code' && stepId !== 'reminder-join-wa'));
      // v4.16.0 -- banner in collection: prima schermata SINCRONA (il focus del campo deve avvenire dentro il gesto
      // dell'utente); uscendo dal banner verso la scheda si anima l'altezza del box e si cambia "pelle" a meta' dissolvenza.
      var bnFirst = !!(_rc && _rc.bnMode && _rcInline && stepId === 'nc-welcome' && !_rc.bnShown);
      var bnLeave = !!(_rc && _rc.bnMode && _rcInline && stepId !== 'nc-welcome');
      var bnH0 = bnLeave ? _rcInline.offsetHeight : 0;
      if (!bnFirst) _rcBody.classList.add('skon-fs-ob-rich-leaving');
      var swap = function() {
        if (myNav !== _rcNavToken) return;
        if (bnLeave && _rcInline) _richBnToCard(bnH0);
        // v4.12.0 -- riga di raccordo da CTA: UNA volta, sulla prima schermata
        // d'ingresso (mai sulle successive), testo semplice escapato.
        if (_rc && _rc.ctaLead && !_rc.ctaLeadUsed && CTA_LEAD_STEPS.indexOf(stepId) !== -1) {
          html = '<p class="skon-fs-ob-rich-lead">' + (_rc.ctaLeadHtml || _esc(_rc.ctaLead)) + '</p>' + html;
          _rc.ctaLeadUsed = true;
        }
        _rcBody.innerHTML = html;
        _rcCurrent = stepId;
        _richEmitEvent('step_view', { step: stepId });
        if (dotInfo) _richRenderDots(dotInfo.names, dotInfo.idx); else _rcDots.innerHTML = '';
        _rcBody.classList.remove('skon-fs-ob-rich-leaving');
        _rcBody.classList.add('skon-fs-ob-rich-entering');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { _rcBody.classList.remove('skon-fs-ob-rich-entering'); });
        });
        _richWireStep(stepId);
        if (_rcMinimized && stepId === 'done') {
          _rcMinimized = false;
          _rcTab.hidden = true;
          _richClearAutoClose();
        }
        if (bnFirst) {
          _rc.bnShown = true;
          var rdy = _rc.bnOnReady; _rc.bnOnReady = null;
          if (rdy) { try { rdy(); } catch (e) {} }
        }
      };
      if (bnFirst) swap(); else setTimeout(swap, 180);
    }

    // v4.17.0 -- tastiera virtuale: tiene il campo di testo con il focus nella parte VISIBILE dello schermo.
    // Controllo a ciclo chiuso (misura -> corregge -> rimisura): su Android la tastiera sale dopo il focus e in piu'
    // passaggi, un calcolo unico lascia il campo coperto. Usa visualViewport (offsetTop/height = area non coperta);
    // senza tastiera (desktop) non fa nulla, a parte portare in vista un campo che sta troppo in basso.
    var _kbd = null;
    // v4.17.1 -- altezza (in px dal bordo alto dell'area visibile) della testata fissa/sticky, misurata sul posto.
    function _richTopInset(vTop) {
      var best = 0;
      try {
        var x = Math.round(window.innerWidth / 2), ys = [vTop + 2, vTop + 40];
        for (var i = 0; i < ys.length; i++) {
          var el = document.elementFromPoint(x, ys[i]);
          while (el && el !== document.body && el !== document.documentElement) {
            var pos = window.getComputedStyle(el).position;
            if (pos === 'fixed' || pos === 'sticky') {
              var b = el.getBoundingClientRect().bottom - vTop;
              if (b > best && b < window.innerHeight * 0.4) best = b;
            }
            el = el.parentElement;
          }
        }
      } catch (e) {}
      return best;
    }
    function _richKbdStop() {
      var k = _kbd; if (!k) return; _kbd = null;
      try { clearInterval(k.iv); } catch (e) {}
      try {
        var vv0 = window.visualViewport;
        if (vv0 && vv0.removeEventListener) { vv0.removeEventListener('resize', k.onVv); vv0.removeEventListener('scroll', k.onVv); }
        window.removeEventListener('resize', k.onVv);
        window.removeEventListener('touchmove', k.onTouch, true);
      } catch (e) {}
      try { if (k.spacer && k.spacer.parentNode) k.spacer.parentNode.removeChild(k.spacer); } catch (e) {}
      try {
        var t = k.toast;
        if (t && k.styled) { t.style.removeProperty('top'); t.style.removeProperty('bottom'); t.style.removeProperty('max-height'); t.style.removeProperty('overflow-y'); }
      } catch (e) {}
    }
    function _richKbdStart(inp) {
      var toast = _rcToast;
      if (!inp || !toast) return;
      if (_kbd && _kbd.inp === inp) { _kbd.until = Date.now() + 2800; _kbd.step(); return; }
      _richKbdStop();
      var k = _kbd = { inp: inp, toast: toast, until: Date.now() + 2800, h0: window.innerHeight, spacer: null, styled: false, iv: 0 };
      var vv = window.visualViewport;
      var scrollPage = function(d) {
        if (!d) return;
        try { window.scrollBy({ top: d, left: 0, behavior: 'instant' }); } catch (e) { try { window.scrollBy(0, d); } catch (e2) {} }
      };
      k.step = function() {
        if (_kbd !== k) return;
        try {
          if (!inp.isConnected || !toast.isConnected) { _richKbdStop(); return; }
          var vTop = vv ? vv.offsetTop : 0, vH = vv ? vv.height : window.innerHeight;
          k.h0 = Math.max(k.h0, window.innerHeight);
          var kb = Math.max(0, k.h0 - vTop - vH);       // parte bassa dello schermo coperta dalla tastiera
          var open = kb > 100;                           // sotto i 100 px = barra indirizzi, non tastiera
          var converge = Date.now() < k.until;
          var r, cy;
          if (_rcInline) {
            // ── flusso nella pagina (banner): scorre la PAGINA ──
            if (open) {
              if (!k.spacer) {
                k.spacer = document.createElement('div');
                k.spacer.setAttribute('aria-hidden', 'true');
                k.spacer.style.cssText = 'height:0;margin:0;padding:0;border:0;pointer-events:none;';
                document.body.appendChild(k.spacer);
              }
              k.spacer.style.height = Math.round(kb + 24) + 'px';
            } else if (k.spacer) { if (k.spacer.parentNode) k.spacer.parentNode.removeChild(k.spacer); k.spacer = null; } // tastiera chiusa (anche senza blur: tasto Indietro di Android)
            r = inp.getBoundingClientRect();
            var hb = _rcInline.getBoundingClientRect();           // il BOX (banner): e' il suo inizio che portiamo in alto
            var inset = _richTopInset(vTop);                       // altezza della testata fissa
            var safeTop = vTop + inset + 12;
            var coarse = false;
            try { coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) {}
            var room = 64;                                         // spazio utile sotto il campo (conferma, privacy)
            var visBottom = open ? vTop + vH : vTop + vH * (coarse ? 0.58 : 0.85); // senza tastiera su touch: la sto per avere
            var covered;
            if (converge) covered = r.bottom + room > visBottom || r.top < vTop + inset + 4;
            else covered = open && (r.bottom > vTop + vH - 16 || r.top < vTop + inset);
            var d = 0;
            if (covered) {
              d = hb.top - safeTop;                                // inizio del box sotto la testata
              var lim = vTop + vH - 16 - (open ? room : 0);
              var after = r.bottom - d;                            // dove finirebbe il campo
              if (after > lim) d += after - lim;                   // box piu' alto dell'area libera: vince il campo
            }
            if (Math.abs(d) < 20) d = 0;
            scrollPage(d);
          } else {
            // ── popup centrale / toast fisso: adatta il POPUP all'area visibile ──
            if (open) {
              if (_rcModal) {
                toast.style.top = Math.round(vTop) + 'px';
                toast.style.bottom = Math.max(0, Math.round(window.innerHeight - vTop - vH)) + 'px';
              } else {
                toast.style.bottom = Math.round(kb + 12) + 'px';
              }
              toast.style.maxHeight = Math.max(160, Math.round(vH - 16)) + 'px';
              toast.style.overflowY = 'auto';
              k.styled = true;
            } else if (k.styled) {
              toast.style.removeProperty('top'); toast.style.removeProperty('bottom');
              toast.style.removeProperty('max-height'); toast.style.removeProperty('overflow-y');
              k.styled = false;
            }
            r = inp.getBoundingClientRect(); cy = r.top + r.height / 2;
            if (open && (r.top < vTop + 8 || r.bottom > vTop + vH - 12)) toast.scrollTop += cy - (vTop + vH / 2);
          }
        } catch (e) {}
      };
      k.onVv = function() { if (_kbd !== k) return; k.until = Math.max(k.until, Date.now() + 1200); k.step(); };
      k.onTouch = function() { k.until = 0; }; // la persona scorre col dito: smettiamo di inseguire
      if (vv && vv.addEventListener) { vv.addEventListener('resize', k.onVv); vv.addEventListener('scroll', k.onVv); }
      window.addEventListener('resize', k.onVv);
      window.addEventListener('touchmove', k.onTouch, true);
      k.iv = setInterval(function() { if (_kbd === k && Date.now() < k.until) k.step(); }, 120);
      k.step();
    }

    // v4.17.0 -- ascoltatori globali (una sola volta): valgono per QUALSIASI toast del modulo (anche quello creato
    // nascosto per la linguetta "?" e poi riaperto).
    var _kbdWired = false;
    function _richKbdWire() {
      if (_kbdWired) return; _kbdWired = true;
      document.addEventListener('focusin', function(e) {
        var t = e.target;
        if (!t || !t.tagName || !_rcToast || !_rcToast.contains(t)) return;
        if (/^(INPUT|TEXTAREA)$/.test(t.tagName) && !/^(checkbox|radio|button|submit|hidden)$/i.test(t.type || '')) _richKbdStart(t);
      });
      document.addEventListener('focusout', function() {
        if (!_kbd) return;
        setTimeout(function() {
          var a = document.activeElement;
          if (!(a && _rcToast && _rcToast.contains(a) && /^(INPUT|TEXTAREA)$/.test(a.tagName))) _richKbdStop();
        }, 250);
      });
    }

    // v4.16.0 -- il banner diventa la cornice verde con la scheda bianca (schermate dopo la prima): altezza animata.
    function _richBnToCard(h0) {
      var host = _rcInline;
      _rc.bnMode = false;
      try {
        host.style.overflow = 'hidden'; host.style.transition = 'none'; host.style.height = h0 + 'px';
        _rcToast.classList.remove('skon-fs-ob-rich-toast--inline-bn');
        _rcToast.classList.add('skon-fs-ob-rich-toast--inline');
        host.setAttribute('data-skon-ep-inline', 'card');
        var done = function() { host.style.height = ''; host.style.overflow = ''; host.style.transition = ''; };
        // l'altezza finale si misura dopo il cambio di contenuto (vedi swap): subito dopo il prossimo frame
        requestAnimationFrame(function() {
          try {
            host.style.height = 'auto'; var h1 = host.scrollHeight; host.style.height = h0 + 'px';
            host.offsetHeight; // reflow
            host.style.transition = 'height .4s cubic-bezier(.2,.8,.2,1)';
            host.style.height = h1 + 'px';
            setTimeout(done, 460);
          } catch (e) { done(); }
        });
      } catch (e) {}
    }

    function _richRenderIntro() {
      _richGo('intro', [
        '<p class="skon-fs-ob-rich-q">Hai già provato Skön Cosmetics?</p>',
        '<p class="skon-fs-ob-rich-sub">Una piccola domanda per personalizzare la tua esperienza.</p>',
        '<div class="skon-fs-ob-rich-btns">',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" data-rich-go="new">No, prima volta</button>',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--secondary" data-rich-go="returning">Sì, sono cliente</button>',
        '</div>'
      ].join(''), null);
    }

    // v4.13.0 -- raccordo con HTML minimo: ammesso SOLO <s>…</s>; il resto e' testo e viene
    // escapato qui (anche se arriva gia' con entita' HTML dal modulo CTA).
    function _ctaUnent(t) {
      return String(t).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
    }
    function _ctaLeadHtml(x) {
      if (!x) return null;
      var parts = String(x).slice(0, 500).split(/(<\/?s>)/), out = '', open = false;
      for (var i = 0; i < parts.length; i++) {
        var pt = parts[i];
        if (pt === '<s>') { if (!open) { out += '<s>'; open = true; } }
        else if (pt === '</s>') { if (open) { out += '</s>'; open = false; } }
        else out += _esc(_ctaUnent(pt));
      }
      if (open) out += '</s>';
      out = out.trim();
      return out || null;
    }
    // v4.13.0 -- `offer` dal modulo CTA: solo testi/numeri, validati e tagliati. null se incompleta.
    function _ctaOffer(o) {
      try {
        if (!o || typeof o !== 'object' || !o.title || typeof o.title !== 'object') return null;
        var tx = function(v, n) { return v == null ? '' : String(v).replace(/\s+/g, ' ').trim().slice(0, n); };
        // pezzi del titolo: gli spazi ai bordi si CONSERVANO (stanno attorno alla parte in evidenza); "\n" = a capo
        var tt = function(v, n) { return v == null ? '' : String(v).replace(/[ \t\r\f]+/g, ' ').slice(0, n); };
        var out = {
          title: { pre: tt(o.title.pre, 140), acc: tt(o.title.acc, 60), post: tt(o.title.post, 80), ast: o.title.ast === true, astKind: o.title.astKind === 'price' ? 'price' : 'plain' },
          sub: tx(o.sub, 200), cta: tx(o.cta, 40), disclaimer: tx(o.disclaimer, 240), conditions: []
        };
        if (!out.title.pre && !out.title.acc) return null;
        if (!out.sub || !out.cta) return null;
        // v4.16.0 -- testi del banner in collection (solo se presenti e completi)
        if (o.banner && typeof o.banner === 'object' && o.banner.title && typeof o.banner.title === 'object') {
          var bt = { pre: tt(o.banner.title.pre, 140), acc: tt(o.banner.title.acc, 60), post: tt(o.banner.title.post, 80) };
          var bs = tx(o.banner.sub, 200), bc = tx(o.banner.cta, 40);
          if ((bt.pre || bt.acc) && bs && bc) out.banner = { title: bt, sub: bs, cta: bc };
        }
        if (o.conditions && o.conditions.length) {
          for (var i = 0; i < o.conditions.length && i < 3; i++) { var c = tx(o.conditions[i], 260); if (c) out.conditions.push(c); }
        }
        return out;
      } catch (e) { return null; }
    }

    function _richRenderNcWelcomeCta(of) {
      var nl = function(t) { return _esc(t).replace(/\n/g, '<br>'); };
      var astBtn = of.title.ast ? '<span role="button" tabindex="0" class="skon-fs-ob-rich-ast" data-skon-ep-ast="' + (of.title.astKind === 'price' ? 'price' : 'plain') + '" aria-label="Condizioni dello sconto">*</span>' : '';
      var titleHtml = nl(of.title.pre) + (of.title.acc ? '<strong class="skon-fs-ob-rich-accent">' + nl(of.title.acc) + '</strong>' : '') + nl(of.title.post) + astBtn;
      var note = '';
      if (of.disclaimer) note += _esc(of.disclaimer);
      if (of.conditions.length) note += (note ? '<br>' : '') + _esc(of.conditions.join(' '));
      _richGo('nc-welcome', [
        '<p class="skon-fs-ob-rich-q skon-fs-ob-rich-q--cta">' + titleHtml + '</p>',
        '<p class="skon-fs-ob-rich-sub">' + _esc(of.sub) + '</p>',
        '<div class="skon-fs-ob-rich-morph" id="richMorph">',
          '<div class="skon-fs-ob-rich-morph-cta"><div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richWantCode" type="button">' + _esc(of.cta) + '</button></div></div>',
          '<div class="skon-fs-ob-rich-morph-field" id="richField" aria-hidden="true">',
            '<label class="skon-fs-ob-rich-sr-only" for="richInEmail">La tua mail dove mandarti il codice sconto</label>',
            '<input type="email" id="richInEmail" class="skon-fs-ob-rich-input" placeholder="La tua mail dove mandarti il codice sconto" autocomplete="email" inputmode="email" enterkeyhint="send" tabindex="-1">',
            '<p class="skon-fs-ob-rich-consent">Ti mandiamo il codice via email; ricevi anche le nostre comunicazioni commerciali, puoi disiscriverti quando vuoi. <a href="https://skoncosmetics.com/pages/privacy-policy" target="_blank" rel="noopener">Informativa privacy</a>.</p>',
          '</div>',
        '</div>',
        '<div class="skon-fs-ob-rich-reveal" id="richConfirm" aria-hidden="true"><div class="skon-fs-ob-rich-reveal-inner">',
          '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
          '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitEmail" type="button" tabindex="-1">Inviami il codice</button></div>',
        '</div></div>',
        (note ? '<p class="skon-fs-ob-rich-disc">' + note + '</p>' : ''),
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" id="richNcSkip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>'
      ].join(''), { names:[0,1,2], idx:0 });
    }

    // v4.16.0 -- prima schermata nel BANNER in collection: stesso aspetto del banner di pagina, con gli STESSI id
    // della schermata nc-welcome (#richMorph, #richWantCode, #richField, #richInEmail, #richConfirm, #richSubmitEmail,
    // #richNcSkip) cosi' _richWireStep gestisce morph, validazione, invio e skip senza una riga in piu'.
    var BN_ARROW = '<svg class="skon-ep__arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    function _richRenderNcWelcomeBanner(of) {
      var b = of.banner;
      var nl = function(t) { return _esc(t).replace(/\n/g, '<br>'); };
      var astBtn = of.title.ast ? '<span role="button" tabindex="0" class="skon-fs-ob-rich-ast skon-fs-ob-bn-ast" data-skon-ep-ast="' + (of.title.astKind === 'price' ? 'price' : 'plain') + '" aria-label="Condizioni dello sconto">*</span>' : '';
      var titleHtml = nl(b.title.pre) + (b.title.acc ? '<b class="skon-ep__acc">' + nl(b.title.acc) + '</b>' : '') + nl(b.title.post) + astBtn;
      _richGo('nc-welcome', [
        '<div class="skon-ep__hit skon-fs-ob-bn" id="richBn">',
          '<span class="skon-ep__body"><span class="skon-ep__title">' + titleHtml + '</span><span class="skon-ep__sub">' + _esc(b.sub) + '</span></span>',
          '<span class="skon-ep__side">',
            '<div class="skon-fs-ob-rich-morph" id="richMorph">',
              '<div class="skon-fs-ob-rich-morph-cta"><button class="skon-ep__btn skon-fs-ob-bn-btn" id="richWantCode" type="button">' + _esc(b.cta) + BN_ARROW + '</button></div>',
              '<div class="skon-fs-ob-rich-morph-field" id="richField" aria-hidden="true">',
                '<label class="skon-fs-ob-rich-sr-only" for="richInEmail">La tua mail dove mandarti il codice sconto</label>',
                '<input type="email" id="richInEmail" class="skon-fs-ob-rich-input" placeholder="La tua mail dove mandarti il codice sconto" autocomplete="email" inputmode="email" enterkeyhint="send" tabindex="-1">',
                '<p class="skon-fs-ob-rich-consent">Ti mandiamo il codice via email; ricevi anche le nostre comunicazioni commerciali, puoi disiscriverti quando vuoi. <a href="https://skoncosmetics.com/pages/privacy-policy" target="_blank" rel="noopener">Informativa privacy</a>.</p>',
              '</div>',
            '</div>',
            '<div class="skon-fs-ob-rich-reveal" id="richConfirm" aria-hidden="true"><div class="skon-fs-ob-rich-reveal-inner">',
              '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
              '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitEmail" type="button" tabindex="-1">Inviami il codice</button></div>',
            '</div></div>',
            '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" id="richNcSkip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>',
          '</span>',
        '</div>'
      ].join(''), null);
    }

    function _richRenderNcWelcome() {
      if (_rc && _rc.ctaOffer && _rc.bnMode && _rcInline && _rc.ctaOffer.banner) return _richRenderNcWelcomeBanner(_rc.ctaOffer); // v4.16.0 (banner in collection)
      if (_rc && _rc.ctaOffer) return _richRenderNcWelcomeCta(_rc.ctaOffer); // v4.13.0 (ingresso da CTA con testi dedicati)
      _richGo('nc-welcome', [
        '<p class="skon-fs-ob-rich-q">Il nostro benvenuto in Skön 🌿</p>',
        '<p class="skon-fs-ob-rich-sub">Oggi <strong>' + _richTodayLabel() + '</strong> per il tuo primo acquisto c’è un vantaggio: <strong class="skon-fs-ob-rich-accent">%%PE%% EXTRA cumulabile</strong> con le promozioni sul sito. Vuoi approfittarne?</p>',
        '<div class="skon-fs-ob-rich-morph" id="richMorph">',
          '<div class="skon-fs-ob-rich-morph-cta"><div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richWantCode" type="button">Sì, voglio il mio %%PE%% extra</button></div></div>',
          '<div class="skon-fs-ob-rich-morph-field" id="richField" aria-hidden="true">',
            '<label class="skon-fs-ob-rich-sr-only" for="richInEmail">La tua mail dove mandarti il codice sconto</label>',
            '<input type="email" id="richInEmail" class="skon-fs-ob-rich-input" placeholder="La tua mail dove mandarti il codice sconto" autocomplete="email" inputmode="email" enterkeyhint="send" tabindex="-1">',
            '<p class="skon-fs-ob-rich-consent">Ti mandiamo il codice via email; ricevi anche le nostre comunicazioni commerciali, puoi disiscriverti quando vuoi. <a href="https://skoncosmetics.com/pages/privacy-policy" target="_blank" rel="noopener">Informativa privacy</a>.</p>',
          '</div>',
        '</div>',
        '<div class="skon-fs-ob-rich-reveal" id="richConfirm" aria-hidden="true"><div class="skon-fs-ob-rich-reveal-inner">',
          '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
          '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitEmail" type="button" tabindex="-1">Inviami il codice</button></div>',
        '</div></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" id="richNcSkip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>'
      ].join(''), { names:[0,1,2], idx:0 });
    }

    function _richRenderRcWelcome() {
      _richGo('rc-welcome', [
        '<p class="skon-fs-ob-rich-q">Ricordaci chi sei per un’esperienza Skön personalizzata! 💝</p>',
        '<div class="skon-fs-ob-rich-morph skon-fs-ob-rich-morph--field" id="richMorph">',
          '<div class="skon-fs-ob-rich-morph-field" id="richField">',
            '<label class="skon-fs-ob-rich-sr-only" for="richInEmail">Inserisci la mail con cui hai ordinato</label>',
            '<input type="email" id="richInEmail" class="skon-fs-ob-rich-input" placeholder="Inserisci la mail con cui hai ordinato" autocomplete="email" inputmode="email" enterkeyhint="send">',
            '<p class="skon-fs-ob-rich-consent">Non ti stai iscrivendo a nulla, serve solo l’email con cui hai già ordinato.</p>',
          '</div>',
        '</div>',
        '<div class="skon-fs-ob-rich-reveal" id="richConfirm" aria-hidden="true"><div class="skon-fs-ob-rich-reveal-inner">',
          '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
          '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitEmail" type="button" tabindex="-1">Continua</button></div>',
        '</div></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" id="richNcSkip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>'
      ].join(''), { names:[0,1,2], idx:0 });
    }

    function _richRenderAutoConsent(name) {
      _richGo('auto-consent', [
        '<p class="skon-fs-ob-rich-q">Ciao ' + _esc(name) + '! 👋</p>',
        '<p class="skon-fs-ob-rich-sub">Vuoi aiutarci a offrirti un’esperienza ancora più personalizzata e ricca di vantaggi?</p>',
        '<div class="skon-fs-ob-rich-btns">',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" data-rich-go="auto-yes">Sì, volentieri</button>',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--secondary" data-rich-go="done" data-rich-skip="true">No, grazie</button>',
        '</div>'
      ].join(''), null);
    }

    // v4.1.0 (16 ott 2026) — saluto minimo di navigazione: caso "non manca
    // davvero nulla" di SKON_PORT_PIANO_15ott2026.md §14. "Esplora i prodotti"
    // riusa il dispatch generico data-rich-go="done" gia' cablato in
    // _richWireStep — _richRenderDone() senza nessuno dei flag di stato del
    // flusso lead-gen (gotBirthday/waClicked/ecc.) ricade gia' da sola sul
    // ramo finale generico ("A presto! Buona esplorazione tra le nostre
    // novita'."), quindi zero nuovo wiring per quel pulsante. "I miei ordini"
    // e' un link nativo, nessun JS necessario. _richDismiss() stesso non
    // puo' essere richiamato direttamente da qui: per design chiude solo da
    // _rcCurrent === 'done' (vedi _richDismiss piu' sotto) — motivo in piu'
    // per passare sempre da 'done', mai bypassarlo.
    function _richTimeGreeting() {
      var h = new Date().getHours();
      if (h >= 6 && h < 13)  return 'Buongiorno';
      if (h >= 13 && h < 22) return 'Buonasera';
      return 'Buonanotte';
    }
    function _richRenderAutoConsentMinimal(name) {
      var greet = _richTimeGreeting();
      var hi = name ? (greet + ' ' + _esc(name)) : greet;
      _richGo('auto-consent-min', [
        '<p class="skon-fs-ob-rich-q">' + hi + ', che piacere rivederti! 👋</p>',
        '<p class="skon-fs-ob-rich-sub">Vuoi andare ai tuoi ordini o preferisci esplorare le novità?</p>',
        '<div class="skon-fs-ob-rich-btns">',
          '<a href="/account/orders" class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary">I miei ordini</a>',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--secondary" data-rich-go="done" data-rich-skip="true">Esplora i prodotti</button>',
        '</div>'
      ].join(''), null);
    }

    // v4.3.0 (22 ott 2026) -- DUE entry point di "promemoria", per chi
    // torna (nuovo tab/sessione, es. da un link email) dopo aver gia' vissuto
    // un pezzo del percorso NC in precedenza. Mai una riaffermazione di
    // validita' del codice (quello lo verifica gia' skon-discount-popup.liquid
    // al checkout): qui solo un invito a ritrovare qualcosa che e' gia' stato
    // davvero inviato, per non far ripartire da zero una domanda a cui la
    // persona ha gia' risposto. Nessun round-trip, nessun nome: una persona
    // non ancora identificata via email in QUESTA sessione non ha un nome da
    // mostrare, ed e' corretto cosi' (vedi _richBuildPlan per dove nascono i
    // due cookie che decidono quale dei due mostrare).
    function _richRenderReminderWaCode(active) {
      // v4.4.0 -- `active`: true se /cart.js mostra gia' un codice applicato
      // ORA (vedi _cartHasActiveDiscount). Cambia SOLO il copy (verbo al
      // presente/attivo invece di "vai a cercarlo"), mai la logica di
      // ingresso: resta lo stesso identico promemoria, caso C.
      var q, sub, primaryLabel, skipRow;
      if (active) {
        q = 'Il tuo <strong class="skon-fs-ob-rich-accent">%%PW%%</strong> è già attivo \u2705';
        sub = 'Il codice è già applicato al tuo carrello. Buono shopping!';
        primaryLabel = 'Continua';
        skipRow = '';
      } else {
        q = 'Bentornata! \ud83d\udc4b';
        sub = 'Sei già nella nostra community WhatsApp: il tuo codice di benvenuto <strong class="skon-fs-ob-rich-accent">%%PW%%</strong> è quello che ti abbiamo inviato lì (o via email). Lo trovi nella chat o nella tua casella di posta.';
        primaryLabel = 'Vado a cercarlo, grazie';
        skipRow = '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done">Esplora i prodotti</button></div>';
      }
      _richGo('reminder-wa-code', [
        '<p class="skon-fs-ob-rich-q">' + q + '</p>',
        '<p class="skon-fs-ob-rich-sub">' + sub + '</p>',
        '<div class="skon-fs-ob-rich-btns">',
          '<button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" data-rich-go="done">' + primaryLabel + '</button>',
        '</div>',
        skipRow
      ].join(''), null);
    }

    function _richRenderReminderJoinWa(active) {
      // v4.4.0 -- `active`: true se /cart.js mostra gia' un codice applicato
      // ORA (vedi _cartHasActiveDiscount). Segnalato da Matteo (screenshot,
      // 22 ott): dire "controlla la tua casella" a chi ha appena attivato il
      // -15% dal link email (popup SkonDiscount gia' confermato) crea la
      // stessa incoerenza del bug del popup risolto la notte prima. Cambia
      // SOLO il copy (il codice e' "gia' attivo", non "in arrivo"), mai la
      // logica di ingresso ne' il CTA WhatsApp.
      var q, sub;
      if (active) {
        q = 'Il tuo %%PE%% è già attivo \u2705<br><strong class="skon-fs-ob-rich-accent">Vuoi trasformarlo in %%PW%%?</strong> \ud83d\udcac';
        sub = 'Il codice è già applicato al tuo carrello. Se ti iscrivi alla community WhatsApp di Sko\u0308n Cosmetics, lo sconto EXTRA diventa %%PW%%. Puoi disiscriverti quando preferisci.';
      } else {
        q = 'Il tuo %%PE%% ti aspetta ancora \u2709\ufe0f<br><strong class="skon-fs-ob-rich-accent">Vuoi trasformarlo in %%PW%%?</strong> \ud83d\udcac';
        sub = 'Ti abbiamo già mandato un codice via email: controlla la tua casella, anche nello spam. Se ti iscrivi alla community WhatsApp di Sko\u0308n Cosmetics, lo sconto EXTRA diventa %%PW%%. Puoi disiscriverti quando preferisci.';
      }
      _richGo('reminder-join-wa', [
        '<p class="skon-fs-ob-rich-q">' + q + '</p>',
        '<p class="skon-fs-ob-rich-sub">' + sub + '</p>',
        '<a href="https://api.whatsapp.com/send?phone=' + LEADGEN.whatsapp.number + '&text=' + encodeURIComponent(LEADGEN.whatsapp.richTriggerText) + '" target="_blank" rel="noopener" class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--wa" id="richWaLink">',
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2c-5.46 0-9.9 4.44-9.9 9.9 0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.39a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.44 9.9-9.9 0-2.64-1.03-5.12-2.9-6.98A9.82 9.82 0 0 0 12.04 2z"/></svg>',
          'Sì, voglio il %%PW%% \u2192',
        '</a>',
        '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done" data-rich-skip="true">No, grazie</button></div>'
      ].join(''), null);
    }

    function _richRenderRcTeaser(name) {
      _richGo('rc-teaser', [
        '<p class="skon-fs-ob-rich-q">Ciao ' + _esc(name) + ', per te che torni oggi c’è un regalo 🩷</p>',
        '<p class="skon-fs-ob-rich-sub">Lo abbiamo scelto pensando a te: è valido 24 ore da quando lo apri.</p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richRevealOffer" type="button">Mostrami il mio vantaggio</button></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>'
      ].join(''), { names: Array.from({ length: _rc.dotTotal }), idx: 0 });
    }

    function _richRenderOffer() {
      // Modulo spento (OFFER_MODULE_ENABLED = false): questa funzione non
      // viene mai chiamata in pratica, portata 1:1 per completezza e per
      // quando il modulo verrà riattivato (decisione business, non tecnica).
      var o = OFFERS[(_rc.cluster) || 'atrisk'];
      if (!o) return _richNext();
      if (!_rc.offerCode) {
        _rc.offerCode = _richMakeCode();
        _rc.offerExpires = Date.now() + OFFER_HOURS * 3600 * 1000;
      }
      var n = _rc.greetName; _rc.greetName = null;
      var kicker = _rc.mismatch
        ? 'Ci risulta che sei già tra i nostri clienti, grazie! ❤️ Lo sconto di benvenuto è riservato ai nuovi, ma per te c’è di meglio:'
        : (n ? 'Ciao ' + _esc(n) + ', bentornata 🩷 Oggi per te:' : 'Ecco il tuo vantaggio di oggi 🩷');
      _richGo('offer', [
        '<p class="skon-fs-ob-rich-offer-kicker">' + kicker + '</p>',
        '<div class="skon-fs-ob-rich-offer-hero"><span class="skon-fs-ob-rich-offer-big">' + o.big + '</span><p class="skon-fs-ob-rich-q skon-fs-ob-rich-offer-title">' + o.title + '</p></div>',
        '<p class="skon-fs-ob-rich-sub">' + o.sub + '</p>',
        '<div class="skon-fs-ob-rich-code-box"><div><div class="skon-fs-ob-rich-code-label">Il tuo codice personale</div><div class="skon-fs-ob-rich-code-value" id="richOfferCode">' + _rc.offerCode + '</div></div>',
          '<button class="skon-fs-ob-rich-code-copy" id="richCopyCode" type="button">Copia</button></div>',
        '<div class="skon-fs-ob-rich-expiry" role="timer" aria-live="off">',
          '<div class="skon-fs-ob-rich-expiry-row"><span>Scade tra</span><strong class="skon-fs-ob-rich-countdown" id="richCountdown">' + _richFmtLeft(_rc.offerExpires - Date.now()) + '</strong></div>',
          '<div class="skon-fs-ob-rich-expiry-date">Valido fino a ' + _richFmtExpiry(_rc.offerExpires) + '. Solo per te, utilizzabile una volta.</div>',
        '</div>',
        '<p class="skon-fs-ob-rich-offer-note">Questo messaggio non si aprirà più: il codice ti arriva anche via email, insieme al riordino veloce dei tuoi preferiti.</p>',
        '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richApplyOffer" type="button">Applica al carrello</button></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="next" data-rich-skip="true">Lo uso più tardi</button></div>'
      ].join(''), _richNextDots());
    }

    function _richRenderRcEmail() {
      _rc.stepNo = 1; _rc.dotTotal = 3;
      _richGo('rc-email', [
        '<label class="skon-fs-ob-rich-field-label" for="richInEmail">La tua email, per riconoscerti nel nostro database:</label>',
        '<div class="skon-fs-ob-rich-field-row"><input type="email" id="richInEmail" class="skon-fs-ob-rich-input" placeholder="nome@esempio.it" autocomplete="email" inputmode="email"></div>',
        '<p class="skon-fs-ob-rich-feedback" id="richFb"></p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitEmail">Invia</button></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done" data-rich-skip="true">Non ora</button></div>'
      ].join(''), { names:[0,1,2], idx:1 });
    }

    function _richRenderNcCodeSent() {
      _richGo('nc-code-sent', [
        '<div class="skon-fs-ob-rich-done-icon">✉️</div>',
        '<p class="skon-fs-ob-rich-q" style="padding-right:0">' + _richHi('Il tuo %%PE%% è in arrivo!') + '</p>',
        '<p class="skon-fs-ob-rich-sub">Controlla la tua email: trovi il codice pronto da usare al checkout, anche insieme alle promozioni in corso.</p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" data-rich-go="next" type="button">Continua →</button></div>'
      ].join(''), _richNextDots());
    }

    function _richRenderNcWhatsapp() {
      var irregular = _rc.profile && _rc.profile.wa === 'irregular';
      var ncMerged = _rc.path === 'new' && _rc.codeSent === true && !irregular && !_rc.mismatch;
      var title, sub, ctaLabel;
      if (irregular) {
        title = 'Confermi la tua iscrizione WhatsApp? 💬';
        sub = 'La tua iscrizione alla community non risulta completa: basta un messaggio per confermarla. Puoi disiscriverti quando preferisci.';
        ctaLabel = 'Conferma su WhatsApp →';
      } else if (ncMerged) {
        title = 'Il tuo %%PE%% è già in arrivo ✉️<br>Vuoi trasformarlo in <strong class="skon-fs-ob-rich-accent">%%PW%%</strong>? 💬';
        sub = 'Controlla la tua email: il codice è pronto da usare al checkout. Se invece ti iscrivi alla community WhatsApp di Skön Cosmetics, <strong class="skon-fs-ob-rich-accent">lo sconto EXTRA diventa %%PW%%</strong>. Puoi disiscriverti quando preferisci.';
        ctaLabel = 'Sì, voglio il %%PW%% →';
      } else {
        title = 'Vuoi restare in contatto anche su WhatsApp? 💬';
        sub = 'Anteprime, consigli skincare e qualche sorpresa. Solo se vuoi: puoi disiscriverti quando preferisci.';
        ctaLabel = 'Iscriviti alla Community Skön';
      }
      _richGo('nc-whatsapp', [
        '<p class="skon-fs-ob-rich-q">' + _richHi(title) + '</p>',
        '<p class="skon-fs-ob-rich-sub">' + sub + '</p>',
        '<a href="https://api.whatsapp.com/send?phone=' + LEADGEN.whatsapp.number + '&text=' + encodeURIComponent(LEADGEN.whatsapp.richTriggerText) + '" target="_blank" rel="noopener" class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--wa" id="richWaLink">',
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2c-5.46 0-9.9 4.44-9.9 9.9 0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.39a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.44 9.9-9.9 0-2.64-1.03-5.12-2.9-6.98A9.82 9.82 0 0 0 12.04 2z"/></svg>',
          ctaLabel,
        '</a>',
        '<p class="skon-fs-ob-rich-feedback" id="richFb" aria-live="polite"></p>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done" data-rich-skip="true">No, grazie</button></div>'
      ].join(''), _richNextDots());
    }

    function _richVariantMarkup() {
      // Fedeltà al prototipo: wheel-picker (dettatura vocale spostata sopra,
      // vedi _richRenderRcBirthday — qui restano solo i cilindri). Etichette
      // GIORNO/MESE/ANNO rimosse su richiesta di Matteo (15 ott 2026, notte):
      // superflue, l'ordine dei cilindri si capisce da solo.
      return [
        '<div class="skon-fs-ob-rich-wheels">',
          '<div class="skon-fs-ob-rich-wheel" id="richWheelDay"></div>',
          '<div class="skon-fs-ob-rich-wheel" id="richWheelMonth"></div>',
          '<div class="skon-fs-ob-rich-wheel" id="richWheelYear"></div>',
          '<div class="skon-fs-ob-rich-wheels-shade"></div>',
          '<div class="skon-fs-ob-rich-wheel-frame"></div>',
        '</div>'
      ].join('');
    }

    function _richRenderRcBirthday(rerender) {
      var dotInfo = rerender ? { names: Array.from({ length: _rc.dotTotal }), idx: _rc.stepNo } : _richNextDots();
      _richGo('rc-birthday', [
        // Wording rivisto 15 ott 2026 (notte, v3), su richiesta di Matteo: la v2
        // ("La useremo solo per questo: zero spam, promesso") aveva un "la"
        // iniziale senza un referente chiaro nella frase prima (che parla di
        // regalo/compleanno, non del dato), e la parola "spam" non andava
        // comunque citata. Ora il referente ("la tua data di nascita") è
        // esplicito nella stessa frase, e la rassicurazione resta ma senza
        // nominare lo spam.
        '<p class="skon-fs-ob-rich-q">' + _richHi('Il tuo compleanno merita un regalo 🎂') + '</p>',
        '<p class="skon-fs-ob-rich-sub">Ci serve solo la tua data di nascita: la useremo esclusivamente per questo. 💝</p>',
        '<div class="skon-fs-ob-rich-dictate-row skon-fs-ob-rich-dictate-row--top">',
          '<button class="skon-fs-ob-rich-dictate-btn" id="richDictateBtn" type="button" aria-label="Pronuncia la tua data di nascita invece di scorrerla">',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z"/><path d="M19 11a7 7 0 0 1-14 0M12 18v3"/></svg>',
            '<span id="richDictateLabel">Pronuncia la tua data di nascita</span>',
          '</button>',
        '</div>',
        '<p class="skon-fs-ob-rich-dictate-status" id="richDictateStatus" aria-live="polite">oppure selezionala qui sotto</p>',
        _richVariantMarkup(),
        '<p class="skon-fs-ob-rich-consent">Useremo questi dati solo per inviarti un omaggio o un vantaggio il giorno del tuo compleanno. <a href="https://skoncosmetics.com/pages/privacy-policy" target="_blank" rel="noopener">Informativa privacy</a>.</p>',
        '<p class="skon-fs-ob-rich-feedback" id="richFb"></p>',
        // Il CTA primario resta SEMPRE visibile (richiesto 15 ott 2026, notte,
        // v2 di questa idea: nasconderlo del tutto lasciava solo "Non ora"
        // come unica azione possibile, troppo poco) ma disabilitato finché
        // la data non è stata davvero scelta (drag su tutti e 3 i cilindri, o
        // dettatura andata a buon fine) — vedi _richCheckWheelsReady() per il
        // toggle di disabled/etichetta.
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" id="richSubmitBirthday" type="button" disabled aria-disabled="true">Compila la data di nascita…</button></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="next" data-rich-skip="true">Non ora</button></div>',
        '<div class="skon-fs-ob-rich-mic-overlay" id="richMicOverlay" aria-hidden="true"><div class="skon-fs-ob-rich-mic-overlay-inner"><span class="skon-fs-ob-rich-mic-overlay-emoji" aria-hidden="true">🎤</span><p>Autorizza l\'uso del microfono per procedere...</p></div></div>'
      ].join(''), dotInfo);
    }

    function _richRenderMismatchRc() {
      var n = _rc.greetName; _rc.greetName = null;
      _richGo('mismatch-rc', [
        '<p class="skon-fs-ob-rich-q">' + (n ? 'Ciao ' + n + ', ci risulta che sei già dei nostri 🩷' : 'Ci risulta che sei già dei nostri 🩷') + '</p>',
        '<p class="skon-fs-ob-rich-sub">Grazie per aver scelto ancora una volta Skön, siamo felici di riaverti con noi!</p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--primary" data-rich-go="next">Continua →</button></div>',
        '<div class="skon-fs-ob-rich-skip-row"><button class="skon-fs-ob-rich-btn-skip" data-rich-go="done" data-rich-skip="true">Preferisco solo esplorare</button></div>'
      ].join(''), _richNextDots());
    }

    function _richRenderDone() {
      var title, sub, icon = '👋';
      var complete = _rc.profile && _rc.profile.orders > 0 && _rc.profile.birthday && _rc.profile.wa === 'active';
      var offerLive = !!_rc.offerExpires && Date.now() < _rc.offerExpires;
      // v4.6.0 -- "resta qualcosa in sospeso" ora e' deciso SOLO da
      // _rc.resumeStep (impostato dal click su un bottone [data-rich-skip],
      // vedi _richWireStep), non piu' da quale titolo vince qui sotto: anche
      // un traguardo vero (es. codeSent) puo' avere un ALTRO modulo ancora
      // in sospeso (es. WhatsApp rifiutato) -- in quel caso il "❔" deve
      // comunque restare, e riprendere esattamente da li' (v. _richCloseDone
      // e _richResumeScreen piu' sotto).
      _rc.doneWasSkip = !!_rc.resumeStep;
      var reason;
      if (_rc.offerApplied && offerLive) { title = 'Buono shopping'; sub = 'Il tuo vantaggio è già nel carrello, valido fino a ' + _richFmtExpiry(_rc.offerExpires) + '.'; icon = '🛍️'; reason = 'offerApplied'; }
      else if (_rc.offerCode && offerLive) { title = 'Il tuo codice ti aspetta'; sub = 'Lo trovi nella tua email, valido fino a ' + _richFmtExpiry(_rc.offerExpires) + '.'; icon = '✉️'; reason = 'offerCode'; }
      else if (_rc.waClicked) { title = 'Ci vediamo su WhatsApp!'; sub = 'Ti aspettiamo nella community.'; icon = '💬'; reason = 'waClicked'; }
      else if (_rc.gotBirthday) { title = 'Fatto!'; sub = 'Ti aspetta una sorpresa per il tuo compleanno.'; icon = '🎉'; reason = 'gotBirthday'; }
      else if (_rc.codeSent) { title = 'Il tuo %%PE%% è in arrivo'; sub = 'Controlla la casella email: trovi il codice pronto da usare al checkout, anche insieme alle promozioni in corso.'; icon = '✉️'; reason = 'codeSent'; }
      else if (complete) { title = 'Bentornata'; sub = 'Abbiamo già tutto quello che ci serve: buona esplorazione tra le novità di stagione.'; icon = '🩷'; reason = 'complete'; }
      else { title = 'A presto!'; sub = 'Buona esplorazione tra le nostre novità.'; reason = 'none'; }
      // v4.7.0 -- toast_done, con "reason" portato nella colonna "step" dello
      // schema D1 (riuso deliberato: toast_done non ha un concetto di
      // step/schermata proprio, e aggiungere una colonna dedicata per un
      // solo evento non valeva una migrazione — vedi CHANGELOG in testa al
      // file). _rc.doneWasSkip viaggia a parte: dice se resta un modulo
      // abbandonato in sospeso, informazione diversa dal "perche' si e'
      // arrivati a done" che reason descrive.
      _richEmitEvent('toast_done', { step: reason, entry_type: _rc.doneWasSkip ? 'skip_pending' : 'closed' });
      _richGo('done', [
        '<div class="skon-fs-ob-rich-done-icon">' + icon + '</div>',
        '<p class="skon-fs-ob-rich-done-thanks">Grazie per aver scelto Skön 🌿</p>',
        '<p class="skon-fs-ob-rich-q" style="padding-right:0">' + _richHi(title) + '</p>',
        '<p class="skon-fs-ob-rich-sub">' + sub + '</p>',
        '<div class="skon-fs-ob-rich-btns"><button class="skon-fs-ob-rich-btn skon-fs-ob-rich-btn--secondary skon-fs-ob-rich-btn--countdown" id="richCloseDone" type="button" aria-label="Chiudi (si chiude da solo tra 5 secondi)">Chiudi</button></div>'
      ].join(''), null);

      document.dispatchEvent(new CustomEvent('skon-fs:rich-done', {
        detail: { mismatch: !!_rc.mismatch, gotBirthday: !!_rc.gotBirthday, waClicked: !!_rc.waClicked }
      }));
    }


    // ── wheel picker (porting 1:1 dal prototipo, namespace isolato) ──
    var _rwITEM_H = 38.5;
    var _rwDECEL  = 0.997;
    var _rwState  = { day:1, month:1, year:1978, touched:{ day:false, month:false, year:false } };
    var _rwMONTHS = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
    var _rwApi    = null;
    var _rwLastHaptic = 0;

    function _rwDaysInMonth(month, year) {
      var leap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
      return [31, leap ? 29 : 28, 31,30,31,30,31,31,30,31,30,31][month - 1];
    }
    function _rwHaptic() {
      if (!navigator.vibrate) return;
      var now = performance.now();
      if (now - _rwLastHaptic < 30) return;
      _rwLastHaptic = now;
      try { navigator.vibrate(8); } catch (e) {}
    }

    function _richCreateWheel(el, opts) {
      var count = opts.count;
      var pos = opts.index * _rwITEM_H;
      var raf = null, animTarget = null, items = [], lastIdx = -1, introActive = false;
      var track = document.createElement('div');
      track.className = 'skon-fs-ob-rich-wheel-track';
      el.innerHTML = ''; el.appendChild(track);
      el.tabIndex = 0;
      el.setAttribute('role', 'spinbutton');
      el.setAttribute('aria-label', opts.ariaLabel);

      function maxPos() { return (count - 1) * _rwITEM_H; }
      function clampIdx(i) { return Math.max(0, Math.min(count - 1, i)); }
      function curIdx() { return clampIdx(Math.round(pos / _rwITEM_H)); }
      function damp(raw) {
        if (raw < 0) return raw * 0.35;
        if (raw > maxPos()) return maxPos() + (raw - maxPos()) * 0.35;
        return raw;
      }
      function undamp(p) {
        if (p < 0) return p / 0.35;
        if (p > maxPos()) return maxPos() + (p - maxPos()) / 0.35;
        return p;
      }

      function render() {
        track.innerHTML = ''; items = [];
        for (var i = 0; i < count; i++) {
          var it = document.createElement('div');
          it.className = 'skon-fs-ob-rich-wheel-item';
          it.textContent = opts.label(i);
          track.appendChild(it); items.push(it);
        }
        lastIdx = -1;
      }

      function paint() {
        // FIX 15 ott 2026 (sera): la vecchia costante (_rwITEM_H * 2) centrava
        // visivamente l'elemento PRECEDENTE a quello davvero selezionato (pos/H),
        // disallineando di una riga intera il riquadro di selezione (.skon-fs-ob-rich-wheel-frame,
        // che sta al 50% del contenitore) rispetto all'elemento con opacity:1/rotateX:0deg
        // (quello realmente restituito da curIdx()/onSettle). Bug trovato da Matteo via
        // dettatura vocale (status diceva "10 aprile 1982", il cilindro mostrava 9/Mar/1981
        // al centro) e riprodotto anche sul rendering iniziale, senza alcuna interazione:
        // non era un problema di dettatura ma un difetto strutturale del wheel-picker,
        // presente anche con trascinamento manuale. Il valore inviato era sempre quello
        // corretto (coerente con lo stato interno), ma quello mostrato come "selezionato"
        // nel riquadro era sistematicamente quello di una riga prima.
        track.style.transform = 'translate3d(0,' + (_rwITEM_H - pos) + 'px,0)';
        var c = pos / _rwITEM_H;
        for (var i = 0; i < items.length; i++) {
          var d = i - c, ad = Math.abs(d), st = items[i].style;
          if (ad > 3.3) { st.visibility = 'hidden'; continue; }
          st.visibility = '';
          st.opacity = Math.max(0.18, 1 - ad * 0.3).toFixed(3);
          st.transform = 'rotateX(' + (-d * 20).toFixed(2) + 'deg)';
        }
        var idx = curIdx();
        if (idx !== lastIdx) {
          if (lastIdx !== -1) _rwHaptic();
          lastIdx = idx;
          el.setAttribute('aria-valuenow', String(idx));
          el.setAttribute('aria-valuetext', items[idx] ? items[idx].textContent : '');
        }
      }

      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } animTarget = null; }

      function animateTo(target, dur, notify) {
        stop();
        var from = pos, t0 = performance.now();
        animTarget = target;
        if (Math.abs(target - from) < 0.5 || dur <= 0) { pos = target; paint(); animTarget = null; if (notify) settle(); return; }
        function step(now) {
          var t = Math.min(1, (now - t0) / dur);
          var e = 1 - Math.pow(1 - t, 3);
          pos = from + (target - from) * e;
          paint();
          if (t < 1) { raf = requestAnimationFrame(step); }
          else { raf = null; animTarget = null; pos = target; paint(); if (notify) settle(); }
        }
        raf = requestAnimationFrame(step);
      }
      function goToIdx(idx, dur) { animateTo(clampIdx(idx) * _rwITEM_H, dur == null ? 280 : dur, true); }
      function settle() { opts.onSettle(curIdx()); }

      var drag = null;
      el.addEventListener('pointerdown', function(e) {
        if (e.button !== undefined && e.button !== 0) return;
        introActive = false;
        stop();
        el.focus({ preventScroll:true });
        drag = { id:e.pointerId, y0:e.clientY, raw0:undamp(pos), t0:performance.now(), moved:0,
                 samples:[{ t:performance.now(), p:pos }] };
        try { el.setPointerCapture(e.pointerId); } catch (ex) {}
        el.classList.add('skon-fs-ob-rich-grabbing');
      });
      el.addEventListener('pointermove', function(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dy = e.clientY - drag.y0;
        drag.moved = Math.max(drag.moved, Math.abs(dy));
        pos = damp(drag.raw0 - dy);
        paint();
        var now = performance.now();
        drag.samples.push({ t:now, p:pos });
        while (drag.samples.length > 2 && now - drag.samples[0].t > 100) drag.samples.shift();
      });
      function release(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var d = drag; drag = null;
        el.classList.remove('skon-fs-ob-rich-grabbing');
        var now = performance.now();

        if (d.moved < 6 && now - d.t0 < 350) {
          var rect = el.getBoundingClientRect();
          var off = (e.clientY - rect.top - rect.height / 2) / _rwITEM_H;
          goToIdx(Math.round(pos / _rwITEM_H + off), 300);
          return;
        }
        if (pos < 0 || pos > maxPos()) {
          animateTo(pos < 0 ? 0 : maxPos(), 360, true);
          return;
        }
        var first = d.samples[0], last = d.samples[d.samples.length - 1];
        var v = 0;
        if (now - last.t < 60 && last.t - first.t > 0) v = (last.p - first.p) / (last.t - first.t);
        var projected = pos + v * _rwDECEL / (1 - _rwDECEL);
        var target = clampIdx(Math.round(projected / _rwITEM_H)) * _rwITEM_H;
        var dist = Math.abs(target - pos);
        var dur = 260;
        if (Math.abs(v) > 0.05 && (target - pos) * v > 0) dur = 3 * dist / Math.abs(v);
        dur = Math.max(220, Math.min(1600, dur));
        animateTo(target, dur, true);
      }
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);

      var wheelTimer = null;
      el.addEventListener('wheel', function(e) {
        introActive = false;
        e.preventDefault();
        var dy = e.deltaY * (e.deltaMode === 1 ? _rwITEM_H : e.deltaMode === 2 ? _rwITEM_H * 5 : 1);
        if (Math.abs(dy) >= 40) {
          var base = animTarget != null ? Math.round(animTarget / _rwITEM_H) : curIdx();
          goToIdx(base + (dy > 0 ? 1 : -1), 200);
          return;
        }
        stop();
        pos = Math.max(0, Math.min(maxPos(), pos + dy));
        paint();
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function() { goToIdx(curIdx(), 220); }, 120);
      }, { passive:false });

      el.addEventListener('keydown', function(e) {
        introActive = false;
        var base = animTarget != null ? Math.round(animTarget / _rwITEM_H) : curIdx();
        var map = { ArrowUp:-1, ArrowDown:1, PageUp:-5, PageDown:5 };
        if (e.key in map) { e.preventDefault(); goToIdx(base + map[e.key], 180); }
        else if (e.key === 'Home') { e.preventDefault(); goToIdx(0, 260); }
        else if (e.key === 'End') { e.preventDefault(); goToIdx(count - 1, 260); }
      });

      render(); paint();

      return {
        setCount: function(n, idx) {
          stop(); count = n; render();
          pos = clampIdx(idx) * _rwITEM_H; paint();
        },
        getCount: function() { return count; },
        goTo: function(idx, dur) { goToIdx(idx, dur == null ? 520 : dur); },
        playIntro: function(steps, dur) {
          if (introActive) return;
          introActive = true;
          var original = pos;
          var forward = Math.min(maxPos(), original + steps * _rwITEM_H);
          animateTo(forward, dur, false);
          setTimeout(function() {
            if (!introActive) return;
            if (!document.body.contains(el)) { introActive = false; return; }
            animateTo(original, dur, false);
            setTimeout(function() { introActive = false; }, dur + 30);
          }, dur + 30);
        }
      };
    }

    function _richCheckWheelsReady() {
      var btn = document.getElementById('richSubmitBirthday');
      if (!btn) return;
      ['day','month','year'].forEach(function(k) {
        var w = document.getElementById('richWheel' + k.charAt(0).toUpperCase() + k.slice(1));
        if (w && _rwState.touched[k]) w.classList.remove('skon-fs-ob-rich-needs');
      });
      var ready = _rwState.touched.day && _rwState.touched.month && _rwState.touched.year;
      var fb = document.getElementById('richFb');
      if (ready && fb && fb.classList.contains('skon-fs-ob-rich-err')) { fb.textContent = ''; fb.className = 'skon-fs-ob-rich-feedback'; }
      // Il CTA resta visibile ma disabilitato finché la data non è stata
      // davvero scelta (richiesta 15 ott 2026, notte, v2: un bottone SEMPRE
      // nascosto lasciava "Non ora" come unica azione possibile sulla
      // schermata, troppo poco — ora si "accende" e cambia etichetta).
      btn.disabled = !ready;
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      btn.textContent = ready ? 'Inviatemi un 🎁 al mio compleanno' : 'Compila la data di nascita…';
    }

    function _richSetupWheels() {
      var dayEl = document.getElementById('richWheelDay');
      var monthEl = document.getElementById('richWheelMonth');
      var yearEl = document.getElementById('richWheelYear');
      if (!dayEl) return;

      var dayWheel = _richCreateWheel(dayEl, {
        count: _rwDaysInMonth(_rwState.month, _rwState.year),
        index: _rwState.day - 1, ariaLabel: 'Giorno',
        label: function(i) { return String(i + 1); },
        onSettle: function(idx) { _rwState.day = idx + 1; _rwState.touched.day = true; _richCheckWheelsReady(); }
      });
      function syncDays() {
        var max = _rwDaysInMonth(_rwState.month, _rwState.year);
        if (_rwState.day > max) _rwState.day = max;
        if (max !== dayWheel.getCount()) dayWheel.setCount(max, _rwState.day - 1);
      }
      var monthWheel = _richCreateWheel(monthEl, {
        count: 12, index: _rwState.month - 1, ariaLabel: 'Mese',
        label: function(i) { return _rwMONTHS[i]; },
        onSettle: function(idx) { _rwState.month = idx + 1; _rwState.touched.month = true; syncDays(); _richCheckWheelsReady(); }
      });
      var yearWheel = _richCreateWheel(yearEl, {
        count: 71, index: _rwState.year - 1940, ariaLabel: 'Anno',
        label: function(i) { return String(1940 + i); },
        onSettle: function(idx) { _rwState.year = 1940 + idx; _rwState.touched.year = true; syncDays(); _richCheckWheelsReady(); }
      });

      _rwApi = {
        setDate: function(d, m, y) {
          _rwState.day = d; _rwState.month = m; _rwState.year = y;
          var max = _rwDaysInMonth(m, y);
          if (max !== dayWheel.getCount()) dayWheel.setCount(max, Math.min(d, max) - 1);
          yearWheel.goTo(y - 1940);
          monthWheel.goTo(m - 1);
          dayWheel.goTo(d - 1);
        }
      };
      _richSetupDictation();

      setTimeout(function() {
        dayWheel.playIntro(4, 420);
        monthWheel.playIntro(2, 620);
        yearWheel.playIntro(6, 850);
      }, 300);
    }

    var _rwMONTH_NAMES = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
    function _richParseSpokenDate(transcript) {
      var t = String(transcript || '').toLowerCase().replace(/\bprimo\b/g, '1').replace(/(\d)\s*[º°]/g, '$1');
      var d, m, y;
      var num = t.match(/\b(\d{1,2})\s*[\/.\-]\s*(\d{1,2})\s*[\/.\-]\s*(\d{4})\b/);
      if (num) { d = +num[1]; m = +num[2]; y = +num[3]; }
      else {
        var mi = -1;
        for (var i = 0; i < _rwMONTH_NAMES.length; i++) { if (t.indexOf(_rwMONTH_NAMES[i]) !== -1) { mi = i; break; } }
        var ym = t.match(/\b(19|20)\d{2}\b/);
        var dm = t.match(/\b(\d{1,2})\b/);
        if (mi === -1 || !ym || !dm) return null;
        d = +dm[1]; m = mi + 1; y = +ym[0];
      }
      if (y < 1940 || y > 2010 || m < 1 || m > 12 || d < 1 || d > _rwDaysInMonth(m, y)) return null;
      return { day:d, month:m, year:y };
    }

    function _richSetupDictation() {
      var btn = document.getElementById('richDictateBtn');
      var label = document.getElementById('richDictateLabel');
      var status = document.getElementById('richDictateStatus');
      var micOverlay = document.getElementById('richMicOverlay');
      if (!btn) return;
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      var rec = null, busy = false, simTimer = null, overlayFallback = null, activePerm = null, overlayOn = false;
      // Etichetta di riposo del pulsante (richiesta 15 ott 2026, sera): prima
      // era "Dettala", ora il pulsante è la CTA principale sopra i cilindri.
      var IDLE_LABEL = 'Pronuncia la tua data di nascita';

      function setListening(on) {
        busy = on;
        btn.classList.toggle('skon-fs-ob-rich-listening', on);
        label.textContent = on ? 'Ti ascolto…' : IDLE_LABEL;
      }
      function apply(p, simulated) {
        _rwApi.setDate(p.day, p.month, p.year);
        status.innerHTML = 'Ho capito <strong>' + p.day + ' ' + _rwMONTH_NAMES[p.month - 1] + ' ' + p.year + '</strong>' +
          (simulated ? ' (simulato)' : '') + ': controlla la data e premi Invia.';
      }
      function simulate(why) {
        setListening(true);
        status.textContent = why + ' Riprova tra poco, oppure scorri i cilindri.';
        simTimer = setTimeout(function() {
          simTimer = null;
          setListening(false);
          status.textContent = 'Dettatura non disponibile: puoi scorrere giorno, mese e anno.';
        }, 1300);
      }
      function setWarn(on) { status.classList.toggle('skon-fs-ob-rich-warn', !!on); }
      // Overlay a schermo intero sul toast (richiesto 15 ott 2026, notte, v2 —
      // la v1 di stasera spariva troppo presto, PRIMA che l'utente avesse
      // davvero risposto al popup nativo del browser). Ora l'overlay resta
      // su finché non arriva un segnale CONCRETO che il permesso è stato
      // deciso, non più un timeout fisso arbitrario:
      //  - rec.onstart (sotto, in startListening): il motore ha davvero
      //    iniziato ad ascoltare → permesso concesso, segnale più affidabile
      //    di PermissionStatus.onchange su molti browser mobile;
      //  - rec.onerror 'not-allowed'/'service-not-allowed': permesso negato;
      //  - PermissionStatus.onchange, dove supportato, come segnale aggiuntivo;
      //  - rete di sicurezza a 20s (molto più lunga della vecchia v1 da 2s)
      //    solo per il caso limite in cui nessuno dei segnali sopra arrivi mai.
      function hideMicOverlay() {
        if (!overlayOn) return;
        overlayOn = false;
        clearTimeout(overlayFallback); overlayFallback = null;
        if (activePerm) { activePerm.onchange = null; activePerm = null; }
        setWarn(false);
        if (micOverlay) { micOverlay.classList.remove('on'); micOverlay.setAttribute('aria-hidden', 'true'); }
      }
      function showMicOverlay(permStatus) {
        overlayOn = true;
        setWarn(true);
        if (micOverlay) { micOverlay.classList.add('on'); micOverlay.setAttribute('aria-hidden', 'false'); }
        label.textContent = 'Annulla';
        status.innerHTML = '<strong>Il browser ti sta chiedendo il permesso di usare il microfono:</strong> tocca "Consenti" per dettare la data.';
        overlayFallback = setTimeout(hideMicOverlay, 20000);
        if (permStatus) {
          activePerm = permStatus;
          permStatus.onchange = function() {
            if (permStatus.state === 'granted' || permStatus.state === 'denied') hideMicOverlay();
          };
        }
      }

      btn.addEventListener('click', function() {
        if (overlayOn) {
          hideMicOverlay();
          label.textContent = IDLE_LABEL;
          status.textContent = 'Dettatura annullata: puoi scorrere giorno, mese e anno.';
          if (rec) try { rec.abort(); } catch (e) {}
          return;
        }
        if (busy) { if (rec) try { rec.stop(); } catch (e) {} return; }
        if (!SR) { simulate('Questo browser non offre la dettatura.'); return; }
        var perms = navigator.permissions && navigator.permissions.query;
        if (perms) {
          try {
            navigator.permissions.query({ name:'microphone' }).then(function(r) {
              if (r.state === 'granted') startListening(); else { showMicOverlay(r); startListening(); }
            }, function() { showMicOverlay(null); startListening(); });
          } catch (e) { showMicOverlay(null); startListening(); }
        } else { showMicOverlay(null); startListening(); }
      });

      function startListening() {
        try {
          rec = new SR();
          rec.lang = 'it-IT';
          rec.interimResults = false;
          rec.maxAlternatives = 5;
          rec.continuous = false;
        } catch (e) { hideMicOverlay(); simulate('Dettatura non disponibile qui.'); return; }

        var handled = false, gaveUp = false;
        var watchdog = setTimeout(function() {
          if (handled || !busy) return;
          gaveUp = true;
          hideMicOverlay();
          setListening(false);
          simulate('Il riconoscimento vocale non risponde.');
          try { rec.abort(); } catch (e) {}
        }, 10000);
        rec.onstart = function() {
          // Segnale più affidabile che il permesso è stato concesso (vedi nota
          // sopra, su showMicOverlay/hideMicOverlay): il motore non comincia
          // mai ad ascoltare senza il permesso del microfono.
          hideMicOverlay();
        };
        rec.onresult = function(e) {
          if (gaveUp) return;
          handled = true;
          var alts = e.results[0], heard = alts[0] ? alts[0].transcript : '';
          for (var i = 0; i < alts.length; i++) {
            var p = _richParseSpokenDate(alts[i].transcript);
            if (p) { apply(p, false); return; }
          }
          status.innerHTML = 'Ho sentito "' + heard.replace(/[<>&]/g, '') + '" ma non è una data valida: riprova o scorri giorno, mese e anno.';
        };
        rec.onerror = function(e) {
          if (gaveUp) return;
          handled = true;
          hideMicOverlay();
          if (e.error === 'no-speech' || e.error === 'aborted') {
            status.textContent = 'Non ho sentito nulla: riprova o scorri giorno, mese e anno.';
          } else if (e.error === 'not-allowed' || e.error === 'service-not-allowed') {
            setListening(false); simulate('Microfono non autorizzato.');
          } else {
            setListening(false); simulate('Servizio di riconoscimento non raggiungibile (' + e.error + ').');
          }
        };
        rec.onend = function() {
          clearTimeout(watchdog);
          hideMicOverlay();
          if (gaveUp || simTimer) return;
          setListening(false);
          if (!handled) status.textContent = 'Non ho sentito nulla: riprova o scorri giorno, mese e anno.';
        };
        try {
          rec.start();
          setListening(true);
          status.textContent = 'Pronuncia la data, es. "20 maggio 1990"';
        } catch (e) { simulate('Dettatura non disponibile qui.'); }
      }
    }


    // ── wiring per-step del flusso rich ──────────────────────────────
    function _richWireStep(stepId) {
      _rcBody.querySelectorAll('[data-rich-go]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var target = btn.getAttribute('data-rich-go');
          _richLockStep();
          // v4.6.0 -- qualunque bottone marcato [data-rich-skip] rappresenta un
          // rifiuto/rinvio della richiesta corrente (email, WhatsApp, compleanno,
          // o un futuro modulo che segua la stessa convenzione): si ricorda
          // qui lo step abbandonato, generico per costruzione (vedi
          // _richResumeScreen piu' sotto per come viene ripreso dal tab "❔").
          if (btn.hasAttribute('data-rich-skip')) {
            _rc.resumeStep = _rcCurrent;
            _richEmitEvent('step_skip', { step: _rcCurrent });
          }
          if (target === 'new' || target === 'returning') {
            _rc.path = target;
            _rc.declared = target === 'new' ? 'new' : 'returning'; // v4.8.0
            if (target === 'new') _richRenderNcWelcome(); else _richRenderRcWelcome();
            return;
          }
          if (target === 'nc-whatsapp') { _rc.plan = ['done']; return _richRenderNcWhatsapp(); }
          if (target === 'auto-yes') {
            // v4.1.0 (16 ott 2026) — placeholder "chiedi sempre" ELIMINATO per
            // questo percorso (era il segnaposto di SKON_PORT_PIANO_15ott2026
            // §14, mai da promuovere in produzione cosi' com'e'). Il piano ora
            // si costruisce SOLO sui bisogni reali gia' calcolati da
            // shouldShow() (vedi _rc._autoNeeds, da _getLiquidCustomerProfile
            // — server-truth via Liquid, zero invenzione). Se per qualunque
            // motivo _rc._autoNeeds non fosse disponibile (difensivo, non
            // dovrebbe succedere dato che show() lo passa sempre insieme a
            // 'auto-consent'), si ripiega sul chiedere tutto — mai sul non
            // chiedere nulla per errore.
            var needs = _rc._autoNeeds || _richNeedsList(_rc.profile || { found: true, orders: 1, birthday: false, wa: 'none' });
            _rc.plan = needs.concat(['done']);
            _rc.stepNo = -1;
            _rc.dotTotal = _rc.plan.filter(function(x) { return x !== 'done'; }).length;
            return _richNext();
          }
          if (target === 'next') return _richNext();
          if (target === 'done') return _richRenderDone();
        });
      });

      if (stepId === 'nc-welcome' || stepId === 'rc-welcome') {
        var isRc = stepId === 'rc-welcome';
        var morph = document.getElementById('richMorph');
        var cta = document.getElementById('richWantCode');
        var field = document.getElementById('richField');
        var nIn = document.getElementById('richInEmail');
        var confirmWrap = document.getElementById('richConfirm');
        var nSubmit = document.getElementById('richSubmitEmail');
        var skip = document.getElementById('richNcSkip');
        var ready = false;

        if (_rc.prefillEmail) {
          var knownEmail = _rc.prefillEmail; _rc.prefillEmail = '';
          var consentNow = document.createElement('p');
          consentNow.className = 'skon-fs-ob-rich-consent';
          consentNow.style.margin = '10px 0 0';
          consentNow.innerHTML = 'Ti mandiamo il codice su ' + _esc(knownEmail) + '; ricevi anche le nostre comunicazioni commerciali, puoi disiscriverti quando vuoi. <a href="https://skoncosmetics.com/pages/privacy-policy" target="_blank" rel="noopener">Informativa privacy</a>.';
          morph.parentNode.insertBefore(consentNow, morph.nextSibling);
          cta.addEventListener('click', function() {
            cta.disabled = true; cta.textContent = 'Un attimo…';
            // v4.1.1 (18 ott 2026) — stesso discorso del ramo email-digitata:
            // questo screen promette "ricevi anche le nostre comunicazioni
            // commerciali", quindi iscriviamo per davvero. Best-effort.
            // v4.2.0 (19 ott 2026): via skon-nc-subscribe-worker, non piu'
            // il POST nativo (vedi CHANGELOG in testa al file).
            _xhrRequest({
              url: LEADGEN.nc.workerUrl,
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: knownEmail })
            }, function(err) {
              if (err) _log('rich NC subscribe (prefill) error', err);
            });
            setTimeout(function() {
              _rc.email = knownEmail;
              _rc.plan = _richBuildPlan(_rc.profile, 'new');
              _rc.stepNo = 0;
              _rc.dotTotal = 1 + _rc.plan.filter(function(x) { return x !== 'done'; }).length;
              _richNext();
            }, 650);
          });
          return;
        }

        if (cta) cta.addEventListener('click', function() {
          var bnEl = document.getElementById('richBn'); // v4.16.0 (banner in collection)
          if (bnEl) {
            var sd = bnEl.querySelector('.skon-ep__side');
            if (sd && window.matchMedia && window.matchMedia('(min-width: 641px)').matches) {
              sd.style.width = sd.offsetWidth + 'px'; sd.offsetWidth; // da larghezza attuale a quella del campo, senza salto
              sd.style.width = '300px';
              setTimeout(function() { sd.style.width = ''; }, 420); // poi decide solo il CSS (.skon-fs-ob-bn--open: 300px)
            }
            bnEl.classList.add('skon-fs-ob-bn--open');
          }
          var from = morph.offsetHeight;
          morph.style.height = from + 'px';
          morph.classList.add('skon-fs-ob-rich-morph--field');
          field.removeAttribute('aria-hidden');
          cta.tabIndex = -1; nIn.tabIndex = 0;
          var to = field.offsetHeight;
          morph.offsetHeight; // reflow
          morph.style.height = to + 'px';
          setTimeout(function() { morph.style.height = ''; }, 360);
          try { nIn.focus({ preventScroll:true }); } catch (e) { nIn.focus(); }
          // preventScroll evita un salto brutto durante l'animazione di altezza
          // del morph; una volta assestata (vedi timeout sopra), riportiamo in
          // vista il campo noi stessi, altrimenti su mobile resta coperto dalla
          // tastiera virtuale (a differenza del ramo RC, che non sopprime lo
          // scroll nativo perche' il campo e' gia' visibile dal primo render).
          setTimeout(function() { _richKbdStart(nIn); }, 380); // v4.17.0: tiene il campo sopra la tastiera (anche dopo l'animazione del morph)
          skip.textContent = isRc ? 'Non ora' : 'Non ora, continua';
          // 28 ott 2026 -- questo e' il punto che il test adversarial ha
          // scoperto NON passare da CUSTOMER_NEEDS: il bottone "skip" del
          // ramo NC viene rietichettato qui via JS per portare DIRETTAMENTE
          // a nc-whatsapp (bypassando l'email), indipendentemente dal
          // bisogno calcolato altrove. Gated anche qui da
          // WHATSAPP_ASK_ENABLED: a flag spento resta sul target di default
          // gia' nel markup statico (data-rich-go="done", righe 1782/1800),
          // quindi "Non ora, continua" chiude semplicemente verso "done"
          // come l'altro bottone skip esistente, nessuna schermata WhatsApp.
          if (!isRc && WHATSAPP_ASK_ENABLED) skip.setAttribute('data-rich-go', 'nc-whatsapp');
          _rc.stepNo = 0; _rc.dotTotal = 2;
        });
        // v4.16.0 -- banner: UN solo clic dell'utente = CTA gia' trasformata e campo email gia' selezionato
        if (cta && _rc.bnMode && document.getElementById('richBn')) cta.click();

        function syncConfirm() {
          var ok = _richValidEmail(nIn.value);
          if (ok === ready) return;
          ready = ok;
          confirmWrap.classList.toggle('skon-fs-ob-rich-on', ok);
          confirmWrap.setAttribute('aria-hidden', ok ? 'false' : 'true');
          nSubmit.tabIndex = ok ? 0 : -1;
        }
        nIn.addEventListener('input', syncConfirm);
        nIn.addEventListener('change', syncConfirm);
        nIn.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { e.preventDefault(); if (ready && !nSubmit.disabled) nSubmit.click(); }
        });
        _richWireEmailSubmit(nSubmit, nIn, document.getElementById('richFb'), function() {
          _rc.stepNo = 0;
          _rc.dotTotal = 1 + _rc.plan.filter(function(x) { return x !== 'done'; }).length;
        }, !isRc);
      }

      if (stepId === 'rc-email') {
        _richWireEmailSubmit(document.getElementById('richSubmitEmail'), document.getElementById('richInEmail'), document.getElementById('richFb'), null);
      }

      if (stepId === 'rc-teaser') {
        var rv = document.getElementById('richRevealOffer');
        rv.addEventListener('click', function() {
          _richLockStep(); rv.textContent = 'Un attimo…';
          setTimeout(_richNext, 700);
        });
      }

      if (stepId === 'offer') {
        var cd = document.getElementById('richCountdown');
        var fbOffer = document.getElementById('richFb');
        var expire = function() {
          _richClearCountdown();
          var row = _rcBody.querySelector('.skon-fs-ob-rich-expiry-row'); if (row) row.innerHTML = '<span>Vantaggio scaduto</span>';
          var box = _rcBody.querySelector('.skon-fs-ob-rich-code-box'); if (box) box.remove();
          var ed = _rcBody.querySelector('.skon-fs-ob-rich-expiry-date'); if (ed) ed.textContent = 'Le 24 ore di validità sono terminate.';
          var ap = document.getElementById('richApplyOffer'); if (ap) ap.closest('.skon-fs-ob-rich-btns').remove();
          var nt = _rcBody.querySelector('.skon-fs-ob-rich-offer-note'); if (nt) nt.remove();
          var lt = _rcBody.querySelector('.skon-fs-ob-rich-btn-skip[data-rich-go="next"]'); if (lt) lt.textContent = 'Continua';
        };
        var tick = function() {
          var left = _rc.offerExpires - Date.now();
          if (left <= 0) return expire();
          cd.textContent = _richFmtLeft(left);
        };
        tick();
        _rcCountdownTimer = setInterval(tick, 1000);
        var copyBtn = document.getElementById('richCopyCode');
        copyBtn.addEventListener('click', function() {
          var done = function() { copyBtn.textContent = 'Copiato ✓'; setTimeout(function() { copyBtn.textContent = 'Copia'; }, 1600); };
          var fail = function() {
            try {
              var r = document.createRange(); r.selectNodeContents(document.getElementById('richOfferCode'));
              var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
            } catch (e) {}
            copyBtn.textContent = 'Tieni premuto per copiare';
          };
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(_rc.offerCode).then(done, fail);
            else fail();
          } catch (e) { fail(); }
        });
        var apply = document.getElementById('richApplyOffer');
        apply.addEventListener('click', function() {
          if (Date.now() >= _rc.offerExpires) return expire();
          _richClearCountdown();
          _richLockStep(); apply.textContent = 'Applico…';
          setTimeout(function() {
            _rc.offerApplied = true;
            fbOffer.textContent = 'Applicato al carrello ✓'; fbOffer.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-ok';
            apply.textContent = 'Applicato ✓';
            setTimeout(_richNext, 700);
          }, 600);
        });
      }

      if (stepId === 'nc-whatsapp' || stepId === 'reminder-join-wa') {
        document.getElementById('richWaLink').addEventListener('click', function() {
          _rc.waClicked = true;
          _richEmitEvent('wa_clicked', { step: _rcCurrent });
          var fb = document.getElementById('richFb');
          if (fb) { fb.textContent = 'Apri WhatsApp e invia il messaggio'; fb.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-ok'; }
          _richLockStep();
          setTimeout(_richNext, 1400);
        });
      }

      if (stepId === 'rc-birthday') {
        _richSetupWheels();
        document.getElementById('richSubmitBirthday').addEventListener('click', function() {
          var btn = this, fb = document.getElementById('richFb');
          var miss = ['day','month','year'].filter(function(k) { return !_rwState.touched[k]; });
          if (miss.length) {
            var nomi = { day:'giorno', month:'mese', year:'anno' };
            miss.forEach(function(k) {
              var w = document.getElementById('richWheel' + k.charAt(0).toUpperCase() + k.slice(1));
              if (w) { w.classList.remove('skon-fs-ob-rich-needs'); void w.offsetWidth; w.classList.add('skon-fs-ob-rich-needs'); }
            });
            var elenco = miss.map(function(k) { return nomi[k]; });
            var testo = elenco.length === 1 ? elenco[0] : elenco.slice(0, -1).join(', ') + ' e ' + elenco[elenco.length - 1];
            var singolo = { day:'il giorno', month:'il mese', year:"l'anno" };
            fb.textContent = miss.length === 1
              ? 'Tocca anche ' + singolo[miss[0]] + ': anche se è già il valore giusto, serve un tocco per confermarlo.'
              : 'Tocca ' + testo + ': anche se sono già i valori giusti, serve un tocco per confermarli.';
            fb.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-err';
            return;
          }
          btn.disabled = true; btn.textContent = 'Invio…';
          // v4.7.0 -- birthday_submitted: solo l'evento, MAI la data stessa
          // nel payload (vedi architettura §3). Emesso al momento del
          // submit validato, indipendentemente dall'esito della chiamata al
          // Worker compleanno qui sotto.
          _richEmitEvent('birthday_submitted', { step: 'rc-birthday' });

          // Invio reale al Worker già in produzione (skon-birthday-bridge),
          // stesso endpoint già usato dal flusso classico — nessun nuovo
          // backend richiesto per QUESTO pezzo, solo per il profile-check.
          var birthDate = _rwState.year + '-' + String(_rwState.month).padStart(2, '0') + '-' + String(_rwState.day).padStart(2, '0');
          var email = _rc.email || '';
          if (!email || !LEADGEN.rcBirthday.enabled || !LEADGEN.rcBirthday.workerUrl) {
            // difensivo: senza email nota o Worker spento, non si invia nulla
            // di finto. Si avanza comunque nel flusso senza promettere l'invio.
            _rc.gotBirthday = true;
            return _richNext();
          }
          _xhrRequest({
            url: LEADGEN.rcBirthday.workerUrl,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, birthDate: birthDate })
          }, function(err) {
            if (err) {
              _log('rich rc-birthday worker error', err);
              btn.disabled = false; btn.textContent = 'Inviatemi un 🎁 al mio compleanno';
              fb.textContent = 'Qualcosa non ha funzionato, riprova tra poco.';
              fb.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-err';
              return;
            }
            _rc.gotBirthday = true;
            _richNext();
          });
        });
      }

      if (stepId === 'done') {
        var closeBtn = document.getElementById('richCloseDone');
        // v4.9.0 -- FIX: i tre trigger sotto (click, animationend della
        // stessa animazione CSS da ~5.3s, e il timer JS a 5300ms) scattano
        // quasi sempre a pochi millisecondi l'uno dall'altro nella chiusura
        // "naturale" (nessun click dell'utente): PRIMA di questo fix,
        // _richCloseDone() veniva eseguita due volte in quel caso comune
        // (il guard su _rcToast.hidden scatta solo 220ms dopo, nel
        // setTimeout di _richDismiss()/_richMinimizeForRestart() — troppo
        // tardi per bloccare il secondo trigger), emettendo due volte
        // toast_dismissed/toast_minimized e gonfiando quell'evento nei dati
        // di analisi. doneClosing e' una variabile locale a QUESTA singola
        // comparsa dello step 'done' (fresca a ogni _richGo('done', ...),
        // quindi corretta anche nel caso raro in cui 'done' venga
        // ri-renderizzato una seconda volta nella stessa apertura del toast
        // dopo una ripresa dal tab "❔" — vedi _richResumeScreen): non e'
        // un campo di _rc, per evitare che un flag "gia' chiuso" sopravviva
        // oltre questa singola comparsa della schermata.
        var doneClosing = false;
        var _richCloseDoneOnce = function() {
          if (doneClosing) return;
          doneClosing = true;
          _richCloseDone();
        };
        closeBtn.addEventListener('click', _richCloseDoneOnce);
        closeBtn.addEventListener('animationend', _richCloseDoneOnce);
        _rcAutoCloseTimer = setTimeout(_richCloseDoneOnce, 5300);
      }
    }

    function _richWireEmailSubmit(submit, input, fb, afterPlan, subscribe) {
      submit.addEventListener('click', function() {
        var email = input.value.trim();
        if (!_richValidEmail(email)) {
          fb.textContent = "Controlla l'indirizzo email."; fb.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-err';
          return;
        }
        submit.disabled = true; submit.textContent = 'Un attimo…';

        // v4.1.1 (18 ott 2026) — iscrizione reale su Shopify, SOLO quando
        // questo screen promette la subscription al cliente (copy "ricevi
        // anche le nostre comunicazioni commerciali"): mai sul passo
        // rc-email, dove il copy dice esplicitamente "non ti stai
        // iscrivendo a nulla". Best-effort, non blocca il flusso del toast.
        if (subscribe) {
          // v4.2.0 (19 ott 2026): via skon-nc-subscribe-worker, non piu' il
          // POST nativo /contact (vedi CHANGELOG in testa al file).
          _xhrRequest({
            url: LEADGEN.nc.workerUrl,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email })
          }, function(err) {
            if (err) { _log('rich NC subscribe error', err); return; }
            _log('rich NC subscribe ok');
          });
        }

        // v4.7.0 -- email_submitted, con email_hash (MAI l'email in chiaro:
        // vedi architettura §3). Hashing asincrono via Web Crypto, non
        // blocca in alcun modo il resto del flusso (_richCheckProfile parte
        // subito, l'evento parte quando l'hash e' pronto, tipicamente
        // pochi millisecondi dopo).
        // v4.9.0 -- FIX: _hashEmailHex() chiama window.crypto.subtle
        // direttamente, SENZA guardia — in un browser/contesto dove
        // crypto.subtle non esiste (raro su HTTPS moderno, ma non
        // impossibile: webview con policy restrittive, browser molto
        // datati) lanciava un'eccezione SINCRONA proprio qui, PRIMA che
        // _richCheckProfile() sotto venisse mai raggiunta: il bottone
        // restava disabilitato su "Un attimo…" per sempre, nessun codice
        // NC consegnato, nessun errore mostrato. Avvolto in try/catch: se
        // l'hashing fallisce (sincrono o asincrono), si perde solo
        // l'evento di tracciamento email_submitted — mai il flusso reale
        // del toast, che resta il caso che conta davvero.
        try {
          _hashEmailHex(email).then(function(emailHash) {
            _richEmitEvent('email_submitted', { email_hash: emailHash });
          }).catch(function(e) {
            _log('hash email fallito (asincrono), evento email_submitted perso', e);
          });
        } catch (e) {
          _log('hash email fallito (sincrono), evento email_submitted perso', e);
        }

        _richCheckProfile(email, function(profile) {
          _rc.gotEmail = true; _rc.email = email;
          _rc.profile = profile;
          _rc.greetName = null; // email digitata, non verificata: niente nome finché non è certificata
          _rc.plan = _richBuildPlan(profile, _rc.path);
          _rc.dotTotal = 2 + _rc.plan.filter(function(x) { return x !== 'done'; }).length;
          if (afterPlan) afterPlan();

          // SkonID — certificazione, SOLO quando il profile-check è attivo e
          // ha risposto con certezza (non sul fallback "non trovato" di
          // sicurezza, che non è una certificazione ma solo l'assenza di dati).
          if (PROFILE_CHECK.enabled && window.SkonID) {
            try {
              if (profile.found && profile.orders > 0 && typeof window.SkonID.markCustomer === 'function') {
                window.SkonID.markCustomer();
              } else if (profile.found === false && typeof window.SkonID.markNonCustomer === 'function') {
                window.SkonID.markNonCustomer();
              }
            } catch (e) {}
          }

          fb.textContent = 'Fatto ✓'; fb.className = 'skon-fs-ob-rich-feedback skon-fs-ob-rich-ok';
          setTimeout(_richNext, 500);
        });
      });
    }

    // v4.12.0 -- chiusura della variante modale (Esc / tocco sullo scrim): stessa
    // azione della X, quindi mai un nuovo comportamento da testare.
    function _richModalClose() {
      if (!_rcModal || !_rcToast || _rcToast.hidden) return;
      if (_rcCurrent === 'done') return _richCloseDone();
      _richMinimize();
    }
    function _richModalKeydown(e) {
      if (e && (e.key === 'Escape' || e.key === 'Esc')) _richModalClose();
    }

    // v4.12.0 -- smonta l'eventuale toast gia' presente (anche minimizzato con
    // il tab "❔", o aperto in modalita' automatica) prima di riaprirlo da CTA:
    // la persona ha appena chiesto esplicitamente un percorso nuovo, il vecchio
    // contesto (_rc) viene sostituito, mai mescolato.
    function _richTeardownDom() {
      _richKbdStop();
      _richClearAutoClose();
      _richClearCountdown();
      _rcNavToken++; // invalida eventuali _richGo() in volo
      [_rcToast, _rcScrim, _rcTab].forEach(function(n) { if (n && n.parentNode) n.parentNode.removeChild(n); });
      _rcToast = _rcScrim = _rcTab = _rcBody = _rcDots = null;
      _rcModal = false; _rcMinimized = false; _rcRestartPending = false;
      document.removeEventListener('keydown', _richModalKeydown);
      _richInlineClosed(); // v4.15.0: se il toast era montato in un banner, il banner viene avvisato e torna com'era
    }

    // v4.15.0 -- flusso inline (banner in collection): avvisa l'ospite UNA volta che il flusso e' finito.
    function _richInlineClosed() {
      if (_rc) { _rc.bnMode = false; _rc.bnOnReady = null; }
      var cb = _rcOnClose; _rcInline = null; _rcOnClose = null;
      if (cb) { try { cb(); } catch (e) {} }
    }
    // v4.15.0 -- minimizzazione di un flusso inline: il toast esce dal banner e diventa il normale toast flottante
    // (nascosto) che il "❔" sa riaprire; il banner torna com'era.
    function _richInlineDetach() {
      if (!_rcInline) return;
      _richKbdStop();
      try {
        _rcToast.classList.remove('skon-fs-ob-rich-toast--inline');
        _rcToast.classList.remove('skon-fs-ob-rich-toast--inline-bn');
        document.body.appendChild(_rcToast);
        if (!_rcScrim) { _rcScrim = document.createElement('div'); _rcScrim.className = 'skon-fs-ob-rich-scrim'; document.body.appendChild(_rcScrim); }
      } catch (e) {}
      _richInlineClosed();
    }

    function _richDismiss() {
      if (_rcCurrent !== 'done' || _rcToast.hidden) return;
      // v4.10.0 -- unico vero punto di completamento (doneWasSkip=false,
      // vedi _richCloseDone): da qui in poi non resta piu' nulla da
      // riprendere, quindi e' anche l'unico posto giusto per svuotare il
      // marcatore cross-pagina -- altrimenti il tab ricomparirebbe su una
      // pagina successiva per un modulo che in realta' e' stato concluso.
      _ss(PENDING_TAB_KEY, '');
      _richEmitEvent('toast_dismissed', {});
      _richClearAutoClose();
      _rcToast.style.transition = 'opacity .2s ease, transform .2s ease';
      _rcToast.style.opacity = '0'; _rcToast.style.transform = 'translateY(8px)';
      setTimeout(function() {
        _rcToast.hidden = true;
        _richSetScrim(false);
        _rcToast.style.transition = ''; _rcToast.style.opacity = ''; _rcToast.style.transform = '';
        if (_rcToast.parentNode) _rcToast.parentNode.removeChild(_rcToast);
        if (_rcScrim && _rcScrim.parentNode) _rcScrim.parentNode.removeChild(_rcScrim);
        if (_rcTab && _rcTab.parentNode) _rcTab.parentNode.removeChild(_rcTab);
        _rcModal = false;
        document.removeEventListener('keydown', _richModalKeydown);
        _richInlineClosed(); // v4.15.0
      }, 220);
    }

    function _richMinimize() {
      _richKbdStop();
      _richEmitEvent('toast_minimized', { step: _rcCurrent });
      // v4.10.0 -- qualunque schermata diversa da "done" (anche la
      // primissima domanda mai risposta, non solo un modulo esplicitamente
      // skippato: richiesta esplicita di Matteo, "finche' c'e' qualcosa
      // che l'utente puo' compilare/accettare, il tab deve restare
      // accessibile") lascia una traccia in sessionStorage, cosi' il tab
      // ricompare anche su una pagina successiva, non solo su questa.
      _savePendingTab(_rcCurrent);
      _rcMinimized = true;
      _richSetScrim(false);
      _rcToast.style.transition = 'opacity .2s ease, transform .2s ease';
      _rcToast.style.opacity = '0'; _rcToast.style.transform = 'translateY(8px)';
      setTimeout(function() {
        _rcToast.hidden = true;
        _rcToast.style.transition = ''; _rcToast.style.opacity = ''; _rcToast.style.transform = '';
        _rcTab.hidden = false;
        _richInlineDetach(); // v4.15.0
      }, 220);
    }

    // v4.6.0 — generalizzato su richiesta di Matteo (22 ott 2026): la v4.5.0
    // riprendeva SEMPRE dalla domanda iniziale, perdendo le risposte già
    // date (es. ramo NC/RC già scelto). Ora, se resta un modulo in sospeso
    // (_rc.resumeStep, impostato da un click [data-rich-skip] — v.
    // _richWireStep/_richRenderDone), chiudere "done" minimizza invece di
    // smontare il DOM — il "❔" resta visibile — e un tocco successivo sul
    // "❔" riprende esattamente da QUELLO specifico modulo (_richResumeScreen
    // qui sotto), non dall'inizio: la domanda NC/RC già risposta non si
    // ripete, ma il modulo abbandonato (email, WhatsApp, compleanno, o un
    // futuro modulo che segua la stessa convenzione [data-rich-skip]) sì.
    // Semplificazione nota: si ricorda solo L'ULTIMO modulo abbandonato, non
    // una coda di tutti quelli saltati in sequenza (vedi commento su
    // _rc.resumeStep in _richWireStep) — corrisponde a quanto descritto da
    // Matteo ("a partire dall'ultima richiesta"). Per ogni "done" davvero
    // senza nulla in sospeso, il comportamento resta quello di sempre:
    // chiusura definitiva, "❔" rimosso, nulla da riproporre.
    function _richCloseDone() {
      if (_rc && _rc.doneWasSkip) return _richMinimizeForRestart();
      return _richDismiss();
    }

    function _richMinimizeForRestart() {
      if (_rcToast.hidden) return;
      // v4.7.0 -- stesso evento toast_minimized di _richMinimize() (vedi
      // CHANGELOG in testa al file): anche qui il toast si nasconde, con la
      // differenza che il "❔" riprendera' dal modulo in sospeso invece che
      // dall'ultima schermata vista. entry_type distingue i due casi per
      // chi analizza i dati.
      _richEmitEvent('toast_minimized', { step: _rcCurrent, entry_type: 'pending_resume' });
      // v4.10.0 -- stesso principio di _richMinimize() sopra: persiste lo
      // step da riprendere (qui _rc.resumeStep, il modulo esplicitamente
      // skippato) cosi' il tab ricompare anche su una pagina successiva.
      _savePendingTab(_rc.resumeStep);
      _richClearAutoClose();
      _rcRestartPending = true;
      _richSetScrim(false);
      _rcToast.style.transition = 'opacity .2s ease, transform .2s ease';
      _rcToast.style.opacity = '0'; _rcToast.style.transform = 'translateY(8px)';
      setTimeout(function() {
        _rcToast.hidden = true;
        _rcToast.style.transition = ''; _rcToast.style.opacity = ''; _rcToast.style.transform = '';
        _rcTab.hidden = false;
        _richInlineDetach(); // v4.15.0
      }, 220);
    }

    // v4.6.0 — dispatch generico stepId -> funzione di render, per riprendere
    // esattamente il modulo abbandonato (_rc.resumeStep). Aggiungere un nuovo
    // modulo in futuro richiede solo un nuovo `case` qui, stesso principio
    // del dispatch già esistente in _richNext().
    function _richResumeScreen() {
      var step = _rc.resumeStep;
      _rc.resumeStep = null;
      _richEmitEvent('tab_resumed', { step: step });
      switch (step) {
        case 'nc-welcome': return _richRenderNcWelcome();
        case 'rc-welcome': return _richRenderRcWelcome();
        case 'auto-consent': return _richRenderAutoConsent(_rc.entryName || '');
        case 'auto-consent-min': return _richRenderAutoConsentMinimal(_rc.entryName || '');
        case 'reminder-join-wa': return _cartHasActiveDiscount(function(active) { _richRenderReminderJoinWa(active); });
        case 'rc-email': return _richRenderRcEmail();
        case 'offer': return _richRenderOffer();
        case 'mismatch-rc': return _richRenderMismatchRc();
        case 'nc-whatsapp': return _richRenderNcWhatsapp();
        case 'rc-birthday': return _richRenderRcBirthday(true);
        default: return _richRenderIntro(); // difensivo: non dovrebbe succedere (doneWasSkip implica sempre un resumeStep valido)
      }
    }

    // v4.10.0 -- bootstrap SILENZIOSO del solo tab "❔", chiamato da _init()
    // quando questa e' una pagina nuova (non quella su cui il modulo era
    // stato lasciato in sospeso) e sessionStorage dice che c'e' ancora
    // qualcosa da riprendere (vedi PENDING_TAB_KEY/CHANGELOG in testa al
    // file). Costruisce scrim/toast/tab esattamente come _richInit() sotto,
    // STESSA identica struttura DOM e STESSI due listener (X e tab) --
    // copiati qui invece di richiamare _richInit() per un motivo preciso:
    // _richInit() emette SEMPRE toast_shown e scrive SEMPRE l'attributo
    // carrello in apertura, nessuno dei due e' corretto qui (questa non e'
    // una vera apertura, e' solo la ricomparsa automatica dell'icona --
    // l'apertura vera, con il suo toast_shown, avviene solo quando la
    // persona tocca davvero il tab, dentro _richResumeScreen piu' sopra).
    // Toast e scrim restano SEMPRE nascosti qui: mai mostrati senza
    // un'azione esplicita della persona.
    function _richInitPendingTab(pending) {
      _rc = _richFreshCtx();
      _rc.entryName   = pending.entryName || '';
      _rc.path        = pending.path || null;
      _rc.declared    = pending.declared || null;
      _rc.resumeStep  = pending.step;
      _rcCurrent      = pending.step;
      _rcMinimized    = true;
      _rc.visitorId   = _ensureVisitorId();

      _rcScrim = document.createElement('div');
      _rcScrim.className = 'skon-fs-ob-rich-scrim';
      document.body.appendChild(_rcScrim);

      _rcToast = document.createElement('div');
      _rcToast.id = 'skonFsObRichToast';
      _rcToast.className = 'skon-fs-ob-rich-toast';
      _rcToast.hidden = true; // mai aperto automaticamente
      _richKbdWire(); // v4.17.0
      _rcToast.innerHTML = [
        '<button class="skon-fs-ob-rich-close" id="richToastClose" type="button" aria-label="Chiudi">',
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
        '<div class="skon-fs-ob-rich-dots" id="richToastDots"></div>',
        '<div class="skon-fs-ob-rich-body" id="richToastBody"></div>'
      ].join('');
      document.body.appendChild(_rcToast);

      _rcBody = _rcToast.querySelector('#richToastBody');
      _rcDots = _rcToast.querySelector('#richToastDots');
      _rcBody.addEventListener('click', _richHandleClick);
      _richKbdWire(); // v4.17.0

      _rcTab = document.createElement('button');
      _rcTab.className = 'skon-fs-ob-rich-tab';
      _rcTab.type = 'button';
      _rcTab.hidden = false; // visibile subito: e' lo scopo di questa funzione
      _rcTab.setAttribute('aria-label', 'Riapri: hai ancora qualcosa da dirci');
      _rcTab.innerHTML = '<span aria-hidden="true">❔</span>';
      document.body.appendChild(_rcTab);

      _rcRestartPending = true; // il prossimo tocco sul tab deve riprendere esattamente pending.step

      _rcTab.addEventListener('click', function() {
        _rcTab.hidden = true;
        _rcToast.hidden = false;
        if (_rcRestartPending) {
          _rcRestartPending = false;
          return _richResumeScreen();
        }
        _rcMinimized = false;
        _richSetScrim(_rcCurrent !== 'intro' && _rcCurrent !== 'rc-teaser' && _rcCurrent !== 'auto-consent' && _rcCurrent !== 'auto-consent-min' && _rcCurrent !== 'reminder-wa-code' && _rcCurrent !== 'reminder-join-wa');
      });

      document.getElementById('richToastClose').addEventListener('click', function() {
        if (_rcCurrent === 'done') return _richCloseDone();
        _richMinimize();
      });
    }

    /**
     * Punto di ingresso del flusso rich. opts.entry: 'intro' | 'auto-consent'.
     * Costruisce il DOM dedicato (namespace Rich*, mai quello classico) e fa
     * partire lo step iniziale.
     */
    function _richInit(opts) {
      _rc = _richFreshCtx();
      _rcInline = (opts.host && opts.host.nodeType === 1 && opts.host.isConnected) ? opts.host : null; // v4.15.0
      _rcOnClose = (_rcInline && typeof opts.onClose === 'function') ? opts.onClose : null;
      _rcModal = !!opts.modal && !_rcInline; // v4.12.0 (mai modale se e' montato inline)
      _rc.ctaLead = opts.lead ? String(opts.lead).slice(0, 220) : null; // v4.12.0
      _rc.ctaLeadHtml = _ctaLeadHtml(opts.leadHtml);   // v4.13.0 (null se assente/non valido)
      if (!_rc.ctaLead && _rc.ctaLeadHtml) _rc.ctaLead = ' ';
      _rc.ctaOffer = _ctaOffer(opts.offer);            // v4.13.0 (null = schermata di sempre)
      // v4.16.0 -- banner in collection: il banner si trasforma sul posto (solo NC da CTA, con i testi del banner)
      _rc.bnMode = !!(_rcInline && opts.inlineStyle === 'banner' && opts.entry === 'nc-welcome' && _rc.ctaOffer && _rc.ctaOffer.banner);
      _rc.bnShown = false;
      _rc.bnOnReady = (_rc.bnMode && typeof opts.onReady === 'function') ? opts.onReady : null;
      _rc.entryName = opts.name || ''; // v4.6.0: serve a _richResumeScreen per auto-consent/auto-consent-min
      _rcCurrent = opts.entry;
      _rcMinimized = false;

      // v4.7.0 -- tracciamento eventi: visitor id (cookie, creato una sola
      // volta per browser), toast_shown, e il join secondario via attributo
      // carrello (scritto subito, indipendentemente da come prosegue poi la
      // sessione — vedi CHANGELOG in testa al file e architettura §5).
      _rc.visitorId = _ensureVisitorId();
      // v4.8.0 -- sessionId fresco per QUESTA apertura (mai un cookie),
      // PRIMA del primo toast_shown cosi' anche quell'evento lo riporta.
      // declared: solo le entry che NON passano mai dalla domanda
      // iniziale lo sanno gia' qui (auto-consent* -> 'auto', i due
      // promemoria -> 'new', vedi CHANGELOG 4.8.0 per il perche'); per
      // l'entry 'intro' resta null finche' l'utente non clicca
      // "sono nuovo/a"/"sono gia' cliente" in _richWireStep.
      _rc.sessionId = _uuidv4();
      if (opts.entry === 'auto-consent' || opts.entry === 'auto-consent-min') {
        _rc.declared = 'auto';
      } else if (opts.entry === 'reminder-wa-code' || opts.entry === 'reminder-join-wa') {
        _rc.declared = 'new';
      } else if (opts.entry === 'nc-welcome') {
        // v4.12.0 -- ingresso diretto da CTA NC: stesso stato che _richWireStep
        // imposta dopo il tap su "No, prima volta".
        _rc.path = 'new'; _rc.declared = 'new';
      } else if (opts.entry === 'rc-welcome') {
        _rc.path = 'returning'; _rc.declared = 'returning';
      }
      _richEmitEvent('toast_shown', { entry_type: opts.entryType || opts.entry });
      _richWriteVisitorIdAttribute(_rc.visitorId);

      if (!_rcInline) {
        _rcScrim = document.createElement('div');
        _rcScrim.className = 'skon-fs-ob-rich-scrim';
        document.body.appendChild(_rcScrim);
      }

      _rcToast = document.createElement('div');
      _rcToast.id = 'skonFsObRichToast';
      _rcToast.className = 'skon-fs-ob-rich-toast';
      _rcToast.innerHTML = [
        '<button class="skon-fs-ob-rich-close" id="richToastClose" type="button" aria-label="Chiudi">',
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
        '<div class="skon-fs-ob-rich-dots" id="richToastDots"></div>',
        '<div class="skon-fs-ob-rich-body" id="richToastBody"></div>'
      ].join('');
      (_rcInline || document.body).appendChild(_rcToast);
      if (_rcInline) _rcToast.classList.add(_rc.bnMode ? 'skon-fs-ob-rich-toast--inline-bn' : 'skon-fs-ob-rich-toast--inline'); // v4.15.0 / v4.16.0

      _rcBody = _rcToast.querySelector('#richToastBody');
      _rcDots = _rcToast.querySelector('#richToastDots');
      _rcBody.addEventListener('click', _richHandleClick);

      _rcTab = document.createElement('button');
      _rcTab.className = 'skon-fs-ob-rich-tab';
      _rcTab.type = 'button';
      _rcTab.hidden = true;
      _rcTab.setAttribute('aria-label', 'Riapri: hai ancora qualcosa da dirci');
      _rcTab.innerHTML = '<span aria-hidden="true">❔</span>';
      document.body.appendChild(_rcTab);
      _rcTab.addEventListener('click', function() {
        _rcTab.hidden = true;
        _rcToast.hidden = false;
        if (_rcRestartPending) {
          _rcRestartPending = false;
          return _richResumeScreen(); // v4.6.0: riprende il modulo specifico abbandonato, non piu' un reset totale
        }
        _rcMinimized = false;
        _richSetScrim(_rcCurrent !== 'intro' && _rcCurrent !== 'rc-teaser' && _rcCurrent !== 'auto-consent' && _rcCurrent !== 'auto-consent-min' && _rcCurrent !== 'reminder-wa-code' && _rcCurrent !== 'reminder-join-wa');
      });

      document.getElementById('richToastClose').addEventListener('click', function() {
        if (_rcCurrent === 'done') return _richCloseDone();
        _richMinimize();
      });

      // v4.12.0 -- variante modale (apertura da CTA): dialogo centrato, chiusura
      // con Esc o tocco sullo scrim = stessa azione della X (minimizza o chiude).
      if (_rcModal) {
        _rcToast.classList.add('skon-fs-ob-rich-toast--modal');
        _rcToast.setAttribute('role', 'dialog');
        _rcToast.setAttribute('aria-modal', 'true');
        _rcToast.setAttribute('aria-label', 'Skön Cosmetics');
        _rcToast.tabIndex = -1;
        _rcScrim.addEventListener('click', _richModalClose);
        document.addEventListener('keydown', _richModalKeydown);
        _richSetScrim(true);
      }

      if (opts.entry === 'auto-consent' || opts.entry === 'auto-consent-min') {
        // v4.1.0 (16 ott 2026): profilo/bisogni gia' calcolati da shouldShow()
        // (Liquid, zero round-trip) — salvati su _rc cosi' _richWireStep puo'
        // costruire il piano reale su 'auto-yes' senza ricalcolare nulla.
        if (opts.profile) _rc.profile = opts.profile;
        if (opts.needs)   _rc._autoNeeds = opts.needs;
      }
      if (opts.entry === 'auto-consent') {
        _richRenderAutoConsent(opts.name || '');
      } else if (opts.entry === 'auto-consent-min') {
        _richRenderAutoConsentMinimal(opts.name || '');
      } else if (opts.entry === 'reminder-wa-code') {
        // v4.4.0 -- un breve check del carrello prima di scrivere "ti
        // aspetta" o "e' gia' attivo" (vedi _cartHasActiveDiscount).
        _cartHasActiveDiscount(function(active) { _richRenderReminderWaCode(active); });
      } else if (opts.entry === 'reminder-join-wa') {
        _cartHasActiveDiscount(function(active) { _richRenderReminderJoinWa(active); });
      } else if (opts.entry === 'nc-welcome') {
        _richRenderNcWelcome(); // v4.12.0 (ingresso da CTA)
      } else if (opts.entry === 'rc-welcome') {
        _richRenderRcWelcome(); // v4.12.0 (ingresso da CTA)
      } else {
        _richRenderIntro();
      }
    }

    // _handleClick dedicato al flusso rich (il body del toast rich delega qui,
    // separato da SkonFS.onboarding._handleClick che resta per il classico)
    function _richHandleClick(e) {
      // il dispatch per data-rich-go è già delegato per-step in _richWireStep
      // (attach diretto sui bottoni, non delegato sul body): questo handler
      // resta un hook di estensione futura, oggi senza azioni proprie.
    }

    // v4.10.0 -- controllo cross-pagina (vedi CHANGELOG in testa al file):
    // PRIMA di armare i trigger normali qui sotto, verifica se questa
    // sessione di navigazione ha gia' un modulo lasciato in sospeso su
    // un'altra pagina. Se si', mostra SOLO il tab "❔" (mai il toast
    // completo: nessun popup nuovo mentre uno e' gia' in sospeso) e si
    // ferma qui -- niente armamento dei trigger su questa pagina, nessun
    // rischio di un secondo popup che si sovrappone al tab gia' mostrato.
    // Gated dietro RICH_FLOW.enabled: a flag spento (produzione, finche'
    // non si decide di accenderlo) questo blocco non gira mai.
    if (RICH_FLOW.enabled) {
      var _pendingRaw = _ss(PENDING_TAB_KEY);
      if (_pendingRaw) {
        var _pending = null;
        try { _pending = JSON.parse(_pendingRaw); } catch (e) { _pending = null; }
        if (_pending && _pending.step) {
          _richInitPendingTab(_pending);
          return;
        }
        // JSON corrotto/non valido: non blocca nulla, si prosegue come se
        // non ci fosse alcun modulo in sospeso (si ripulisce per non
        // ritentare il parse ad ogni pagina).
        _ss(PENDING_TAB_KEY, '');
      }
    }


    // ──────────────────────────────────────────────────────────────────
    // TRIGGER LOGIC (invariata dalla v3.0.0)
    // ──────────────────────────────────────────────────────────────────

    const startTime = Date.now();
    let triggered     = false;
    let inactivityTimer = null;

    function fire() {
      if (triggered) return;
      if (Date.now() - startTime < SETTINGS.minDwellMs) {
        setTimeout(fire, SETTINGS.minDwellMs - (Date.now() - startTime));
        return;
      }
      triggered = true;
      clearTimeout(inactivityTimer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('click', onActivity);
      SkonFS.onboarding.show();
    }

    function resetInactivity() {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(function() { fire(); }, SETTINGS.inactivityMs);
    }

    function onActivity() { resetInactivity(); }

    const onScroll = _debounce(function() {
      const pageH = document.documentElement.scrollHeight - window.innerHeight;
      const pct   = pageH > 0 ? (window.scrollY / pageH) : 0;
      if (pct >= SETTINGS.scrollThreshold) {
        fire();
        return;
      }
      resetInactivity();
    }, 150);

    resetInactivity();
    window.addEventListener('scroll',  onScroll,    { passive: true });
    document.addEventListener('click', onActivity,  { passive: true });

    _log('trigger armed (minDwell', SETTINGS.minDwellMs,
         'ms, scroll', SETTINGS.scrollThreshold * 100,
         '%, inactivity', SETTINGS.inactivityMs, 'ms, rich flow',
         RICH_FLOW.enabled ? 'ON' : 'off', ')');
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { _waitForSkonFS(_init); });
  } else {
    _waitForSkonFS(_init);
  }

})();
